define(["esri/tasks/QueryTask","esri/tasks/support/Query","esri/geometry/Point","esri/tasks/GeometryService","esri/tasks/support/BufferParameters","esri/tasks/support/ProjectParameters","esri/geometry/Polygon","esri/geometry/Polyline","esri/tasks/support/IdentifyParameters","esri/tasks/IdentifyTask","esri/request","esri/Map","esri/views/MapView","esri/Color","esri/layers/MapImageLayer","esri/layers/TileLayer","esri/core/Collection","esri/layers/GraphicsLayer","esri/Graphic","esri/symbols/SimpleFillSymbol","esri/symbols/SimpleLineSymbol","esri/Basemap","dojo/on","esri/config","esri/tasks/PrintTask","esri/tasks/support/PrintTemplate","esri/tasks/support/PrintParameters","esri/symbols/TextSymbol","esri/symbols/PictureMarkerSymbol","esri/geometry/ScreenPoint","esri/PopupTemplate","esri/geometry/SpatialReference","esri/widgets/Print","dojo/request/xhr"], function(__WEBPACK_EXTERNAL_MODULE_36__, __WEBPACK_EXTERNAL_MODULE_37__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_39__, __WEBPACK_EXTERNAL_MODULE_40__, __WEBPACK_EXTERNAL_MODULE_41__, __WEBPACK_EXTERNAL_MODULE_42__, __WEBPACK_EXTERNAL_MODULE_43__, __WEBPACK_EXTERNAL_MODULE_44__, __WEBPACK_EXTERNAL_MODULE_45__, __WEBPACK_EXTERNAL_MODULE_46__, __WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_49__, __WEBPACK_EXTERNAL_MODULE_50__, __WEBPACK_EXTERNAL_MODULE_51__, __WEBPACK_EXTERNAL_MODULE_52__, __WEBPACK_EXTERNAL_MODULE_53__, __WEBPACK_EXTERNAL_MODULE_54__, __WEBPACK_EXTERNAL_MODULE_55__, __WEBPACK_EXTERNAL_MODULE_56__, __WEBPACK_EXTERNAL_MODULE_57__, __WEBPACK_EXTERNAL_MODULE_58__, __WEBPACK_EXTERNAL_MODULE_59__, __WEBPACK_EXTERNAL_MODULE_61__, __WEBPACK_EXTERNAL_MODULE_81__, __WEBPACK_EXTERNAL_MODULE_82__, __WEBPACK_EXTERNAL_MODULE_83__, __WEBPACK_EXTERNAL_MODULE_84__, __WEBPACK_EXTERNAL_MODULE_86__, __WEBPACK_EXTERNAL_MODULE_87__, __WEBPACK_EXTERNAL_MODULE_88__, __WEBPACK_EXTERNAL_MODULE_89__, __WEBPACK_EXTERNAL_MODULE_122__, __WEBPACK_EXTERNAL_MODULE_133__) { return webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(2);
	var app_module_1 = __webpack_require__(24);
	var config_1 = __webpack_require__(60);
	//import 'whatwg-fetch';
	// // This is to use Fetch API (NOT working in IE or mobile browsers but can use polyfill) 
	// window.fetch('data/settings.json', {method: 'get'}).then((response) => {
	//     response.json().then((config:Object) => {
	//         Config.config = config;
	//         platformBrowserDynamic().bootstrapModule(AppModule)
	//     });
	// });
	// // This is to use the XMLHttpRequest API (good but might be some hickups with browsers)
	// var xhr = new XMLHttpRequest;
	// xhr.onreadystatechange = function() {
	//     if (xhr.readyState == 4 && xhr.status == 200) {
	//          Config.config = JSON.parse(xhr.responseText);
	//          platformBrowserDynamic().bootstrapModule(AppModule);
	//     }
	// }
	// xhr.open("GET", 'data/settings.json')
	// xhr.send();
	// This is to use dojo/request/xhr from ArcGIS JS API library (theoretically compatible with all browsers)
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(133)], __WEBPACK_AMD_DEFINE_RESULT__ = function (xhr) {
	    xhr("data/settings.json", {
	        handleAs: "json"
	    }).then(function (data) {
	        // Do something with the handled data
	        config_1.Config.config = data;
	        platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);
	    }, function (err) {
	        // Handle the error condition
	        console.log(err);
	    }, function (evt) {
	        // Handle a progress event from the request if the
	        // browser supports XHR2
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var platform_browser_1 = __webpack_require__(22);
	var http_1 = __webpack_require__(25);
	var http_2 = __webpack_require__(25);
	var shared_module_1 = __webpack_require__(26);
	var app_component_1 = __webpack_require__(121);
	/**This portion below only works when working with Webpack. For SystemJS, comment out the following lines**/
	__webpack_require__(125);
	__webpack_require__(129);
	__webpack_require__(131);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    return AppModule;
	}());
	AppModule = __decorate([
	    core_1.NgModule({
	        declarations: [
	            app_component_1.AppComponent
	        ],
	        imports: [
	            platform_browser_1.BrowserModule,
	            http_1.HttpModule,
	            http_2.JsonpModule,
	            //RouterModule,
	            shared_module_1.SharedModule.forRoot()
	        ],
	        bootstrap: [app_component_1.AppComponent]
	    }),
	    __metadata("design:paramtypes", [])
	], AppModule);
	exports.AppModule = AppModule;


/***/ },
/* 25 */,
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var core_1 = __webpack_require__(4);
	var common_1 = __webpack_require__(23);
	var forms_1 = __webpack_require__(27);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var map_component_1 = __webpack_require__(47);
	var map_service_1 = __webpack_require__(62);
	var navTools_component_1 = __webpack_require__(85);
	var addressLocator_component_1 = __webpack_require__(92);
	var addressLocator_service_1 = __webpack_require__(93);
	var basemapNav_component_1 = __webpack_require__(97);
	var legend_component_1 = __webpack_require__(100);
	var searchModule_component_1 = __webpack_require__(105);
	var searchTool_component_1 = __webpack_require__(108);
	var email_component_1 = __webpack_require__(111);
	var obliquePhoto_component_1 = __webpack_require__(113);
	var parcelReport_component_1 = __webpack_require__(116);
	var apphelp_component_1 = __webpack_require__(118);
	var parcelReport_service_1 = __webpack_require__(63);
	var SharedModule = SharedModule_1 = (function () {
	    function SharedModule() {
	    }
	    SharedModule.forRoot = function () {
	        var parcelReportServiceFactory = function (_esriTasksService, _mapService, _eventsService) {
	            return function () { return new parcelReport_service_1.ParcelReportService(_esriTasksService, _mapService, _eventsService); };
	        };
	        return {
	            ngModule: SharedModule_1,
	            providers: [map_service_1.MapService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService, addressLocator_service_1.LocationService, {
	                    provide: parcelReport_service_1.ParcelReportService,
	                    useFactory: parcelReportServiceFactory,
	                    deps: [esriTasks_service_1.EsriTasksService, map_service_1.MapService]
	                }]
	        };
	    };
	    return SharedModule;
	}());
	SharedModule = SharedModule_1 = __decorate([
	    core_1.NgModule({
	        imports: [common_1.CommonModule, forms_1.FormsModule, forms_1.ReactiveFormsModule],
	        declarations: [map_component_1.MapComponent, navTools_component_1.NavToolsComponent, addressLocator_component_1.AddressLocatorComponent, basemapNav_component_1.BasemapNavComponent, legend_component_1.LegendComponent, searchModule_component_1.SearchModuleComponent, searchTool_component_1.SearchToolComponent, email_component_1.EmailComponent, obliquePhoto_component_1.ObliquePhotoComponent, parcelReport_component_1.ParcelReportComponent, apphelp_component_1.AppHelpComponent],
	        exports: [common_1.CommonModule, forms_1.FormsModule, forms_1.ReactiveFormsModule, map_component_1.MapComponent, navTools_component_1.NavToolsComponent, addressLocator_component_1.AddressLocatorComponent, basemapNav_component_1.BasemapNavComponent, legend_component_1.LegendComponent, searchModule_component_1.SearchModuleComponent, searchTool_component_1.SearchToolComponent, email_component_1.EmailComponent, obliquePhoto_component_1.ObliquePhotoComponent, parcelReport_component_1.ParcelReportComponent, apphelp_component_1.AppHelpComponent]
	    })
	], SharedModule);
	exports.SharedModule = SharedModule;
	var SharedModule_1;


/***/ },
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var core_1 = __webpack_require__(4);
	var Subject_1 = __webpack_require__(5);
	var EventsService = (function () {
	    function EventsService() {
	        // Observable navItem source
	        this._navItemSource = new Subject_1.Subject();
	        // Observable navItem stream
	        this.navItem$ = this._navItemSource.asObservable();
	        // Observable source
	        this._mapClicked = new Subject_1.Subject();
	        // Observable stream
	        this.mapClicked$ = this._mapClicked.asObservable();
	        this._mapDrag = new Subject_1.Subject();
	        this.mapDrag$ = this._mapDrag.asObservable();
	        this._mapPointerDown = new Subject_1.Subject();
	        this.mapPointerDown$ = this._mapPointerDown.asObservable();
	        this._mapPointerUp = new Subject_1.Subject();
	        this.mapPointerUp$ = this._mapPointerUp.asObservable();
	        this._mapPointerMove = new Subject_1.Subject();
	        this.mapPointerMove$ = this._mapPointerMove.asObservable();
	        this._mapDoubleClick = new Subject_1.Subject();
	        this.mapDoubleClick$ = this._mapDoubleClick.asObservable();
	        this._addressSearchActivate = new Subject_1.Subject();
	        this.addressSearchActivate$ = this._addressSearchActivate.asObservable();
	        this._dynamicLayerViewCreated = new Subject_1.Subject();
	        this.dynamicLayerViewCreated$ = this._dynamicLayerViewCreated.asObservable();
	        this._searchToolShow = new Subject_1.Subject();
	        this.searchToolShow$ = this._searchToolShow.asObservable();
	        this._moduleSelect = new Subject_1.Subject();
	        this.moduleSelect$ = this._moduleSelect.asObservable();
	        this._mapUpdateShow = new Subject_1.Subject();
	        this.mapUpdateShow$ = this._mapUpdateShow.asObservable();
	        this._expandMenuToolbar = new Subject_1.Subject();
	        this.expandMenuToolbar$ = this._expandMenuToolbar.asObservable();
	        this._savedSearchSelect = new Subject_1.Subject();
	        this.savedSearchSelect$ = this._savedSearchSelect.asObservable();
	        this._startSaveSearch = new Subject_1.Subject();
	        this.startSaveSearch$ = this._startSaveSearch.asObservable();
	        this._setSavedGeometry = new Subject_1.Subject();
	        this.setSavedGeometry$ = this._setSavedGeometry.asObservable();
	        this._createAppURL = new Subject_1.Subject();
	        this.createAppURL$ = this._createAppURL.asObservable();
	        this._appURLCreated = new Subject_1.Subject();
	        this.appURLCreated$ = this._appURLCreated.asObservable();
	        this._ipaSetLocation = new Subject_1.Subject();
	        this.ipaSetLocation$ = this._ipaSetLocation.asObservable();
	        this._ipaSyncLocation = new Subject_1.Subject();
	        this.ipaSyncLocation$ = this._ipaSyncLocation.asObservable();
	        this._showObliqueImage = new Subject_1.Subject();
	        this.showObliqueImage$ = this._showObliqueImage.asObservable();
	        this._disableObliqueImage = new Subject_1.Subject();
	        this.disableObliqueImage$ = this._disableObliqueImage.asObservable();
	        this._showMapTooltip = new Subject_1.Subject();
	        this.showMapTooltip$ = this._showMapTooltip.asObservable();
	        this._parcelReportGenerated = new Subject_1.Subject();
	        this.parcelReportGenerated$ = this._parcelReportGenerated.asObservable();
	        this._identifyLocationChanged = new Subject_1.Subject();
	        this.identifyLocationChanged$ = this._identifyLocationChanged.asObservable();
	    }
	    // service command
	    EventsService.prototype.changeNav = function (Object) {
	        this._navItemSource.next(Object);
	    };
	    // service command
	    EventsService.prototype.mapClicked = function (evt) {
	        this._mapClicked.next(evt);
	    };
	    EventsService.prototype.mapDrag = function (evt) {
	        this._mapDrag.next(evt);
	    };
	    EventsService.prototype.mapPointerDown = function (evt) {
	        this._mapPointerDown.next(evt);
	    };
	    EventsService.prototype.mapPointerUp = function (evt) {
	        this._mapPointerUp.next(evt);
	    };
	    EventsService.prototype.mapPointerMove = function (evt) {
	        this._mapPointerMove.next(evt);
	    };
	    EventsService.prototype.mapDoubleClick = function (evt) {
	        this._mapDoubleClick.next(evt);
	    };
	    EventsService.prototype.addressSearchActivate = function (show) {
	        this._addressSearchActivate.next(show);
	    };
	    EventsService.prototype.dynamicLayerViewCreated = function () {
	        this._dynamicLayerViewCreated.next(null);
	    };
	    EventsService.prototype.searchToolShow = function (show) {
	        this._searchToolShow.next(show);
	    };
	    EventsService.prototype.moduleSelect = function (module) {
	        this._moduleSelect.next(module);
	    };
	    EventsService.prototype.mapUpdateShow = function (show) {
	        this._mapUpdateShow.next(show);
	    };
	    EventsService.prototype.expandMenuToolbar = function (show) {
	        this._expandMenuToolbar.next(show);
	    };
	    EventsService.prototype.savedSearchSelect = function (savedSearch) {
	        this._savedSearchSelect.next(savedSearch);
	    };
	    EventsService.prototype.startSaveSearch = function () {
	        this._startSaveSearch.next(null);
	    };
	    EventsService.prototype.setSavedGeometry = function (savedGeometry) {
	        this._setSavedGeometry.next(savedGeometry);
	    };
	    EventsService.prototype.createAppURL = function (shareMethod) {
	        this._createAppURL.next(shareMethod);
	    };
	    EventsService.prototype.appURLCreated = function (url) {
	        this._appURLCreated.next(url);
	    };
	    EventsService.prototype.ipaSetLocation = function (coordinates) {
	        this._ipaSetLocation.next(coordinates);
	    };
	    EventsService.prototype.ipaSyncLocation = function (view) {
	        this._ipaSyncLocation.next(view);
	    };
	    EventsService.prototype.showObliqueImage = function (show) {
	        this._showObliqueImage.next(show);
	    };
	    EventsService.prototype.disableObliqueImage = function () {
	        this._disableObliqueImage.next();
	    };
	    EventsService.prototype.showMapTooltip = function (parameters) {
	        this._showMapTooltip.next(parameters);
	    };
	    EventsService.prototype.parcelReportGenrated = function () {
	        this._parcelReportGenerated.next();
	    };
	    EventsService.prototype.identifyLocationChanged = function (parameters) {
	        this._identifyLocationChanged.next(parameters);
	    };
	    return EventsService;
	}());
	EventsService = __decorate([
	    core_1.Injectable()
	], EventsService);
	exports.EventsService = EventsService;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var http_1 = __webpack_require__(25);
	__webpack_require__(33);
	__webpack_require__(34);
	var EventsService_1 = __webpack_require__(31);
	//import { QueryTask, Query, Point } from 'esri';
	var QueryTask = __webpack_require__(36);
	var Query = __webpack_require__(37);
	var Point = __webpack_require__(38);
	var GeometryService = __webpack_require__(39);
	var BufferParameters = __webpack_require__(40);
	var ProjectParameters = __webpack_require__(41);
	var Polygon = __webpack_require__(42);
	var Polyline = __webpack_require__(43);
	var IdentifyParameters = __webpack_require__(44);
	var IdentifyTask = __webpack_require__(45);
	var EsriRequest = __webpack_require__(46);
	var EsriTasksService = (function () {
	    function EsriTasksService(_eventsService, http, jsonp) {
	        this._eventsService = _eventsService;
	        this.http = http;
	        this.jsonp = jsonp;
	    }
	    EsriTasksService.prototype.getAPIPResultsByLocation = function (url, location, wkid, layersArray) {
	        var layers = JSON.stringify(layersArray);
	        var point = JSON.stringify({ "x": location["X"], "y": location["Y"], "spatialReference": { "wkid": wkid } });
	        var search = new http_1.URLSearchParams();
	        search.set('f', 'json');
	        search.set('point', point);
	        search.set('layers', layers);
	        var request = {
	            'f': 'json',
	            'point': point,
	            'layers': layers
	        };
	        return EsriRequest(url, new Object({ query: request })).then(function (response) {
	            return response;
	        }, function (error) {
	            return Promise.reject(error.message || error);
	        });
	    };
	    EsriTasksService.prototype.soePolygonAnalysis = function (url, parcelGeometry, layersArray, wkid, spatialRelationship) {
	        var layers = JSON.stringify(layersArray);
	        var polygonObject = {
	            "type": "polygon",
	            "rings": parcelGeometry.rings,
	            "spatialReference": { "wkid": wkid }
	        };
	        var polygon = JSON.stringify(polygonObject);
	        var request = {
	            'f': 'json',
	            'polygon': polygon,
	            'layers': layers,
	            'returnGeometry': 'false',
	            'spatialRelationship': spatialRelationship
	        };
	        return EsriRequest(url, new Object({ query: request })).then(function (response) {
	            return response;
	        }, function (error) {
	            return Promise.reject(error.message || error);
	        });
	    };
	    EsriTasksService.prototype.createReport = function (url, textElementsObjectString, image1, image2, image3, image4) {
	        var request = {
	            "f": "json",
	            "TextElementsStrings": textElementsObjectString,
	            "Image1": image1,
	            "Image2": image2,
	            "Image3": image3,
	            "Image4": image4
	        };
	        return EsriRequest(url, new Object({ query: request })).then(function (response) {
	            return response;
	        }, function (error) {
	            return Promise.reject(error.message || error);
	        });
	    };
	    ///TEST
	    EsriTasksService.prototype.makeEsriRequest_TEST = function () {
	        return EsriRequest("http://gistv07:6080/arcgis/rest/services/DMDPortal/MapServer/identify", { "query": {
	                geometry: '{"x":246212.11805555556,"y":1616275.548611111}"',
	                geometryType: "esriGeometryPoint",
	                sr: '{"wkt":"PROJCS[\"NAD_1983_StatePlane_Indiana_East_FIPS_1301_USFeet\",GEOGCS[\"GCS_North_American_1983\",DATUM[\"D_North_American_1983\",SPHEROID[\"GRS_1980\",6378137.0,298.257222101]],PRIMEM[\"Greenwich\",0.0],UNIT[\"Degree\",0.0174532925199433]],PROJECTION[\"Transverse_Mercator\"],PARAMETER[\"False_Easting\",328083.3333333333],PARAMETER[\"False_Northing\",820208.3333333331],PARAMETER[\"Central_Meridian\",-85.66666666666667],PARAMETER[\"Scale_Factor\",0.9999666666666667],PARAMETER[\"Latitude_Of_Origin\",37.5],UNIT[\"Foot_US\",0.3048006096012192]]"}',
	                layers: "visible:0",
	                layerDefs: '{"0":"LANDUSE = \'PARK\'"}',
	                time: null,
	                layerTimeOptions: null,
	                tolerance: 0,
	                mapExtent: "84102.74305555553,1560285.9652777778,295257.2569444445,1733246.0347222222",
	                imageDisplay: "400,400,96",
	                returnGeometry: true,
	                maxAllowableOffset: null,
	                geometryPrecision: null,
	                dynamicLayers: null,
	                returnZ: false,
	                returnM: false,
	                gdbVersion: null,
	                f: "pjson"
	            } });
	    };
	    EsriTasksService.prototype.identifyFeatures = function (url, geometry, extent, tolerance, layerIds, layerOption, returnGeometry, definitionExpressions) {
	        var identifyParams = new IdentifyParameters();
	        identifyParams.tolerance = tolerance;
	        identifyParams.returnGeometry = returnGeometry;
	        identifyParams.layerIds = layerIds;
	        identifyParams.layerOption = layerOption;
	        identifyParams.geometry = geometry;
	        identifyParams.mapExtent = extent;
	        identifyParams.set("layerDefinitions", definitionExpressions);
	        var identifyTask = new IdentifyTask({ "url": url });
	        return identifyTask.execute(identifyParams).then(function (results) {
	            return results;
	        }, function (error) {
	            console.log(error);
	            return Promise.reject(error.message || error);
	        });
	    };
	    EsriTasksService.prototype.queryFeatures = function (url, geometry, whereClause, outFields, returnGeometry, orderFields) {
	        var queryTask = new QueryTask({ "url": url });
	        var query = new Query();
	        query.geometry = geometry;
	        query.returnGeometry = returnGeometry;
	        query.outFields = outFields;
	        query.orderByFields = orderFields;
	        query.where = whereClause;
	        return queryTask.execute(query).then(function (results) { return results; });
	    };
	    EsriTasksService.prototype.queryFeaturesForIDs = function (url, geometry, whereClause) {
	        var queryTask = new QueryTask({ "url": url });
	        var query = new Query();
	        query.geometry = geometry;
	        query.where = whereClause;
	        return queryTask.executeForIds(query).then(function (results) { return { "url": url, "results": results }; });
	    };
	    EsriTasksService.prototype.getFeaturesCounts = function (url) {
	        var queryTask = new QueryTask({ "url": url });
	        var query = new Query();
	        query.where = "1=1";
	        return queryTask.executeForCount(query).then(function (results) {
	            return results;
	        }, function (error) {
	            console.log(error);
	            return Promise.reject(error.message || error);
	        });
	    };
	    EsriTasksService.prototype.bufferFeatures = function (url, geometries, distances, unit, sr) {
	        var gsvc = new GeometryService(url);
	        var params = new BufferParameters();
	        var bufferGeometries = new Array();
	        for (var i = 0; i < geometries.length; i++) {
	            bufferGeometries.push(geometries[i]);
	        }
	        params.geometries = bufferGeometries;
	        params.unit = "feet";
	        params.outSpatialReference = sr;
	        params.distances = distances;
	        return gsvc.buffer(params).then(function (geometries) { return geometries; });
	    };
	    EsriTasksService.prototype.unionGeometries = function (url, geometries) {
	        var gsvc = new GeometryService(url);
	        return gsvc.union(geometries).then(function (unionGeometry) { return unionGeometry; });
	    };
	    EsriTasksService.prototype.projectGeometries = function (url, geometries, sr) {
	        var gsvc = new GeometryService(url);
	        var params = new ProjectParameters();
	        params.outSR = sr;
	        params.geometries = geometries;
	        return gsvc.project(params).then(function (geometries) { return geometries; });
	    };
	    EsriTasksService.prototype.geometryToGML = function (geom) {
	        var gml = '';
	        switch (geom.type) {
	            // case "point":
	            //     gml = pointToGML(geom);
	            //     if (buffer == true) {
	            //         gml = '<RequestGeometries><Geometries><BufferGeometry><Geometry>' + gml + '</Geometry></BufferGeometry></Geometries></RequestGeometries>';
	            //     }
	            //     break;
	            // case "multipoint": //not sure about this GML
	            //     gml = multipointToGML(geom);
	            //     break;
	            // case "polyline":
	            //     gml = lineToGML(geom);
	            //     break;
	            case "polygon":
	                var gml = this.polygonToGML(geom);
	                // if (buffer == true) {
	                //     gml = '<RequestGeometries><Geometries><BufferGeometry><Geometry>' + gml + '</Geometry></BufferGeometry></Geometries></RequestGeometries>';
	                // }
	                break;
	        }
	        return gml;
	    };
	    EsriTasksService.prototype.polygonToGML = function (geom) {
	        var rings = geom.rings;
	        var gml = '<gml:Polygon xmlns:gml="http://www.opengis.net/gml"><gml:PolygonPatch><gml:exterior>';
	        for (var ii = 0; ii < rings.length; ii++) {
	            var points = rings[ii];
	            gml = gml + '<gml:LinearRing><gml:posList>';
	            var pointStart = points[0];
	            var coordStart = pointStart[0] + ',' + pointStart[1];
	            for (var jj = 0; jj < points.length; jj++) {
	                var point = points[jj];
	                gml = gml + point[0] + ',' + point[1] + ' ';
	            }
	            gml = gml + coordStart + '</gml:posList></gml:LinearRing>';
	        }
	        gml = gml + '</gml:exterior></gml:PolygonPatch></gml:Polygon>';
	        return gml;
	    };
	    EsriTasksService.prototype.gmlToPoint = function (sr, gml) {
	        gml = gml.replace(', ', ',');
	        var positionPos = gml.indexOf('<gml:pos>', 0);
	        var positionStartPos = gml.indexOf('>', positionPos);
	        var positionEndPos = gml.indexOf('<', positionStartPos);
	        var pointString = gml.slice((positionStartPos + 1), positionEndPos);
	        var pointArray = pointString.split(',');
	        var geom = new Point();
	        geom.spatialReference = sr;
	        geom.x = Number(pointArray[0]);
	        geom.y = Number(pointArray[1]);
	        return geom;
	    };
	    EsriTasksService.prototype.gmlToPolygon = function (sr, gml) {
	        var geom = new Polygon();
	        geom.spatialReference = sr;
	        gml = gml.replace(', ', ',');
	        var positionRing = 0;
	        var positionPosList = 0;
	        var geomRingsArray = [];
	        while (positionRing != -1) {
	            //Get this rings XY coordinates
	            positionRing = gml.indexOf('<gml:LinearRing>', (positionRing + 1));
	            positionPosList = gml.indexOf('<gml:posList>', (positionPosList + 1));
	            var startRingValues = gml.indexOf('>', positionPosList);
	            var endRingValues = gml.indexOf('<', startRingValues);
	            var ringString = gml.slice((startRingValues + 1), (endRingValues));
	            var ringArray = ringString.split(' ');
	            //Create the ring
	            var ring = new Array();
	            for (var ii = 0; ii < ringArray.length; ii++) {
	                //Get the xy coordinates
	                var ringPoint = ringArray[ii];
	                var ringPointArray = ringPoint.split(',');
	                var x = ringPointArray[0];
	                var y = ringPointArray[1];
	                //Create the point and add it to the ring's array of points
	                var pt = new Point();
	                pt.x = Number(x);
	                pt.y = Number(y);
	                pt.spatialReference = sr;
	                ring.push(pt);
	            }
	            //add this ring to the polygon's rings
	            geom.addRing(ring);
	            //Get next ring if current position is not -1
	            if (positionRing != -1) {
	                positionRing = gml.indexOf('<gml:LinearRing>', (positionRing + 1));
	            }
	        }
	        return geom;
	    };
	    EsriTasksService.prototype.gmlToLine = function (sr, gml) {
	        gml = gml.replace(', ', ',');
	        var positionPos = gml.indexOf('<gml:posList>', 0);
	        var positionStartPos = gml.indexOf('>', positionPos);
	        var positionEndPos = gml.indexOf('<', positionStartPos);
	        var pointString = gml.slice((positionStartPos + 1), positionEndPos);
	        var pointsArray = [];
	        var pointsStringArray = pointString.split(' ');
	        for (var ii = 0; ii < pointsStringArray.length; ii++) {
	            var pointCoord = pointsStringArray[ii].split(',');
	            pointsArray.push(pointCoord);
	        }
	        var paths = [];
	        for (var jj = 0; jj < pointsArray.length; jj++) {
	            var point = new Point();
	            point.spatialReference = sr;
	            point.x = Number(pointsArray[0]);
	            point.x = Number(pointsArray[1]);
	            paths.push(point);
	        }
	        var geom = new Polyline();
	        geom.spatialReference = sr;
	        geom.addPath(paths);
	        return geom;
	    };
	    EsriTasksService.prototype.gmlToGeometry = function (spatialReference, gml) {
	        //Determine the type of geometry to be created
	        var typePolygon = gml.indexOf('gml:Polygon', 0);
	        var typePoint = gml.indexOf('gml:Point', 0);
	        var typeLine = gml.indexOf('gml:LineString', 0);
	        var geom;
	        if (typePolygon != -1) {
	            //Case when the geometry type supposed to be generated is Polygon
	            geom = this.gmlToPolygon(spatialReference, gml);
	        }
	        else if (typePoint != -1) {
	            //Case when the geometry type supposed to be generated is Point
	            geom = this.gmlToPoint(spatialReference, gml);
	        }
	        else if (typeLine != -1) {
	            //Case when the geometry type supposed to be generated is Polyline
	            geom = this.gmlToLine(spatialReference, gml);
	        }
	        return geom;
	    };
	    EsriTasksService.prototype.getServiceValues = function (url) {
	        return this.http.get(url)
	            .toPromise()
	            .then(this.extractData)
	            .catch(this.handleError);
	    };
	    EsriTasksService.prototype.extractData = function (res) {
	        var body = res.json();
	        return body || {};
	    };
	    EsriTasksService.prototype.handleError = function (error) {
	        console.error('An error occurred', error);
	        return Promise.reject(error.message || error);
	    };
	    return EsriTasksService;
	}());
	EsriTasksService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [EventsService_1.EventsService, http_1.Http, http_1.Jsonp])
	], EsriTasksService);
	exports.EsriTasksService = EsriTasksService;


/***/ },
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_36__;

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_37__;

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_38__;

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_40__;

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_41__;

/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_42__;

/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_43__;

/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_44__;

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_45__;

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_46__;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(4);
	var http_1 = __webpack_require__(25);
	var Map = __webpack_require__(48);
	var MapView = __webpack_require__(49);
	var Point = __webpack_require__(38);
	var Color = __webpack_require__(50);
	var MapImageLayer = __webpack_require__(51);
	var TileLayer = __webpack_require__(52);
	var Collection = __webpack_require__(53);
	var GraphicsLayer = __webpack_require__(54);
	var Graphic = __webpack_require__(55);
	var SimpleFillSymbol = __webpack_require__(56);
	var SimpleLineSymbol = __webpack_require__(57);
	var Basemap = __webpack_require__(58);
	var on = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var esriConfig = __webpack_require__(61);
	var map_service_1 = __webpack_require__(62);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var parcelReport_service_1 = __webpack_require__(63);
	var MapComponent = (function () {
	    function MapComponent(elRef, _mapService, _eventsService, _esriTasksService, prs, http) {
	        this.elRef = elRef;
	        this._mapService = _mapService;
	        this._eventsService = _eventsService;
	        this._esriTasksService = _esriTasksService;
	        this.http = http;
	        this.viewCreated = new core_1.EventEmitter();
	        this.view = null;
	        this.appSettings = null;
	        this.showTooltip = false;
	        this.mapTooltipText = "";
	        this.layerCollection = new Collection();
	        this._parcelReportService = prs;
	    }
	    MapComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.appSettings = config_1.Config.config[0];
	        this.setUp();
	        this._eventsService.showMapTooltip$.subscribe(function (parameters) {
	            _this.showTooltip = parameters["show"];
	            _this.mapTooltipText = parameters["tooltip"];
	            if (_this.showTooltip == true) {
	                _this.mouseMoveTooltip = on(_this._mapService.view.container, "mousemove", function (mmevt) {
	                    var x = (mmevt.clientX + 20) + 'px', y = (mmevt.clientY + 20) + 'px';
	                    if (_this.mapTooltipSpan) {
	                        _this.mapTooltipSpan.nativeElement["style"].top = y;
	                        _this.mapTooltipSpan.nativeElement["style"].left = x;
	                    }
	                });
	            }
	            else {
	                _this.mouseMoveTooltip.remove();
	            }
	        });
	        esriConfig.request.proxyUrl = "ESRIProxy/proxy.ashx";
	        // esriConfig.request.forceProxy = true;
	    };
	    MapComponent.prototype.setUp = function () {
	        var _this = this;
	        var baseMapServices = this.appSettings["Map"]["Layers"]["Base"];
	        this.createBaseMap(baseMapServices);
	        var statePlaneLayers = this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["layers"];
	        statePlaneLayers.forEach(function (ms) {
	            if (ms["id"] == _this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["default"]) {
	                ms["opacity"] = _this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["startOpacity"];
	                _this.createAndAddLayers([ms]);
	            }
	        });
	        var operationalLayers = this.appSettings["Map"]["Layers"]["OperationalLayers"];
	        operationalLayers.forEach(function (ms) {
	            _this.createAndAddLayers([ms]);
	        });
	        this._mapService.selGraphics = new GraphicsLayer({
	            id: "selGraphics"
	        });
	        this._mapService.tempSelPlgGraphics = new GraphicsLayer({
	            id: "tempSelPlgGraphics"
	        });
	        this._mapService.tempSelGraphics = new GraphicsLayer({
	            id: "tempSelGraphics"
	        });
	        this._mapService.obliquePointGraphicLayer = new GraphicsLayer({
	            id: "obliquePointGraphics"
	        });
	        this._mapService.popupSelectedFeatureGraphicLayer = new GraphicsLayer({
	            id: "popupSelectedFeatureGraphics"
	        });
	        this._mapService.applyGeometryQueryGraphic = new GraphicsLayer({
	            id: "applyGeometryQueryGraphic"
	        });
	        this.layerCollection.addMany([this._mapService.selGraphics, this._mapService.tempSelPlgGraphics, this._mapService.tempSelGraphics, this._mapService.obliquePointGraphicLayer, this._mapService.popupSelectedFeatureGraphicLayer, this._mapService.applyGeometryQueryGraphic]);
	        this.map = new Map({
	            "basemap": this.baseMap,
	            "layers": this.layerCollection
	        });
	        this.view = this._mapService.view = new MapView({
	            map: this.map
	        });
	        this.view.container = this.elRef.nativeElement.firstChild;
	        this.view.constraints = {
	            rotationEnabled: false
	        };
	        this.view.then(function (view) {
	            var pt = new Point({
	                x: _this.appSettings["Map"]["Center"]["x"],
	                y: _this.appSettings["Map"]["Center"]["y"],
	                //    x: -9589883.136,
	                //    y: 4835183.259,
	                spatialReference: view.spatialReference
	            });
	            view.center = pt;
	            view.zoom = 4;
	            //view.zoom = 11;
	            //Remove compass since map rotation is disabled
	            // var compasswidget = new Compass({
	            //     view:this._mapService.view
	            // });
	            // this._mapService.view.ui.add(compasswidget, "top-left");
	        });
	        this.view.on("click", function (evt) {
	            // evt is the event object returned after the event fires
	            _this._eventsService.mapClicked(evt);
	        });
	        this.view.on("layerview-create", function (event) {
	            operationalLayers.forEach(function (ms) {
	                if (event.layer.id === ms.id) {
	                    _this._eventsService.dynamicLayerViewCreated();
	                    return;
	                }
	            });
	        });
	        this.view.on("drag", function (evt) {
	            _this._eventsService.mapDrag(evt);
	        });
	        this.view.on("pointer-move", function (evt) {
	            _this._eventsService.mapPointerMove(evt);
	        });
	        this.view.on("pointer-down", function (evt) {
	            _this._eventsService.mapPointerDown(evt);
	        });
	        this.view.on("pointer-up", function (evt) {
	            _this._eventsService.mapPointerUp(evt);
	        });
	        this.view.on("double-click", function (evt) {
	            _this._eventsService.mapDoubleClick(evt);
	        });
	        this.view.watch("updating", function (value) {
	            // setTimeout(() =>
	            // {
	            //     value ? this._eventsService.showDialog("updating map") : this._eventsService.hideDialog();
	            // }, 200);
	            _this._eventsService.mapUpdateShow(value);
	        });
	        // Remove all popup actions cause for some reason Zoom To is not working (most likely because the spatial reference is messed up)
	        this.view.popup.actions.removeAll();
	        // Fires each time an action is clicked
	        this.view.popup.viewModel.on("trigger-action", function (event) {
	            // If the zoom-out action is clicked, then execute the following code
	            if (event.action.id === "zoom-to-addon") {
	                _this._mapService.view.extent = event.target.selectedFeature.geometry.extent;
	            }
	            else if (event.action.id === "see-document") {
	                var loadingImagePath = "./images/loading.gif";
	                event.action["title"] = "Please wait...";
	                event.action["className"] = "";
	                event.action["id"] = "report-wait";
	                _this._esriTasksService.getServiceValues(_this.appSettings["ResolutionFiles"]["serviceURL"] + "/" + event.action.extra.resolutionValue).then(function (resDocInfo) {
	                    window.open(resDocInfo["FileUrl"], '_blank');
	                    event.action["title"] = "See document";
	                    event.action["className"] = "esri-icon-link-external";
	                    event.action["id"] = "see-document";
	                });
	            }
	            else if (event.action.id === "prc-card") {
	                window.open(_this.appSettings["PropertyRecordCards"]["URL"] + event.target.selectedFeature.attributes["Parcel Number"], '_blank');
	            }
	            else if (event.action.id === "parcel-report") {
	                _this.parcelReportAction = event.action;
	                var loadingImagePath = "./images/loading.gif";
	                event.action["className"] = "";
	                event.action["title"] = "Generating report. Please wait...";
	                event.action["image"] = loadingImagePath;
	                event.action["id"] = "report-wait";
	                _this._parcelReportService = new parcelReport_service_1.ParcelReportService(_this._esriTasksService, _this._mapService, _this._eventsService);
	                _this._parcelReportService.activeProject.subscribe(function (thing) {
	                    if (thing["status"] != "ready") {
	                        alert("Report creation for parcel " + thing["parcelNumber"] + " has failed. Please try again later or contact the application support team if the issue repeats.");
	                    }
	                    var parcelReportIconPath = "./images/parcel-report-icon.png";
	                    event.action["image"] = parcelReportIconPath;
	                    event.action["id"] = "parcel-report";
	                    event.action["title"] = "Generate Parcel Report";
	                });
	                _this._parcelReportService.startParcelReport(event.target.selectedFeature);
	            }
	        });
	        this._mapService.view.watch("popup.selectedFeature", function (newValue, oldValue) {
	            if (newValue != null) {
	                try {
	                    _this._mapService.view.popup.location = _this.findPopupLocation(newValue.geometry);
	                    _this._mapService.popupSelectedFeatureGraphicLayer.graphics.removeAll();
	                    var targetGraphic = new Graphic();
	                    targetGraphic.geometry = newValue.geometry;
	                    var targetSymbol = new SimpleFillSymbol();
	                    targetSymbol.color = new Color(_this.appSettings["IdentifyTool"]["SelectionSymbol"]["color"]);
	                    targetSymbol.outline = new SimpleLineSymbol();
	                    targetSymbol.outline.color = new Color(_this.appSettings["IdentifyTool"]["SelectionSymbol"]["outline"]["color"]);
	                    targetSymbol.outline.width = _this.appSettings["IdentifyTool"]["SelectionSymbol"]["outline"]["width"];
	                    targetGraphic.symbol = targetSymbol;
	                    _this._mapService.popupSelectedFeatureGraphicLayer.graphics.add(targetGraphic);
	                }
	                catch (ex) {
	                    console.log(ex);
	                }
	            }
	        });
	        this._mapService.view.watch("popup.visible", function (newValue, oldValue) {
	            if (newValue == false) {
	                _this._mapService.popupSelectedFeatureGraphicLayer.graphics.removeAll();
	            }
	        });
	        this._eventsService.identifyLocationChanged$.subscribe(function (point) {
	            _this.identifyPoint = point;
	        });
	    };
	    MapComponent.prototype.findPopupLocation = function (geometry) {
	        var _this = this;
	        var point = new Point();
	        if (geometry.type == "polyline") {
	            var closestVertexDistance_1 = 1000000;
	            var closestVertex_1 = new Point({ spatialReference: this._mapService.view.spatialReference });
	            var polyline = geometry;
	            var paths = polyline.paths;
	            paths.forEach(function (multipoint) {
	                multipoint.forEach(function (point) {
	                    var distance = Math.sqrt(Math.pow((_this.identifyPoint.x - point[0]), 2) + Math.pow((_this.identifyPoint.y - point[1]), 2));
	                    if (closestVertexDistance_1 > distance) {
	                        closestVertexDistance_1 = distance;
	                        closestVertex_1.x = point[0];
	                        closestVertex_1.y = point[1];
	                    }
	                });
	            });
	            point = closestVertex_1;
	        }
	        else if (geometry.type == "polygon") {
	            if (geometry.contains(this.identifyPoint)) {
	                point = this.identifyPoint;
	            }
	            else {
	                var closestVertexDistance_2 = 1000000;
	                var closestVertex_2 = new Point({ spatialReference: this._mapService.view.spatialReference });
	                var polygon = geometry;
	                var rings = polygon.rings;
	                rings.forEach(function (ring) {
	                    ring.forEach(function (point) {
	                        var distance = Math.sqrt(Math.pow((_this.identifyPoint.x - point[0]), 2) + Math.pow((_this.identifyPoint.y - point[1]), 2));
	                        if (closestVertexDistance_2 > distance) {
	                            closestVertexDistance_2 = distance;
	                            closestVertex_2.x = point[0];
	                            closestVertex_2.y = point[1];
	                        }
	                    });
	                });
	                point = closestVertex_2;
	            }
	        }
	        return point;
	    };
	    MapComponent.prototype.createBaseMap = function (baseMapLayerObj) {
	        var baseMapLayer = new TileLayer({
	            id: baseMapLayerObj["id"],
	            url: baseMapLayerObj["url"],
	            "opacity": baseMapLayerObj["opacity"]
	        });
	        var layerCollection = new Collection();
	        layerCollection.add(baseMapLayer);
	        this.baseMap = new Basemap({
	            baseLayers: layerCollection
	        });
	    };
	    MapComponent.prototype.createAndAddLayers = function (layersToAdd) {
	        var _this = this;
	        layersToAdd.forEach(function (mapService) {
	            switch (mapService["type"]) {
	                case "tiled":
	                    _this.layerCollection.add(new TileLayer({
	                        id: mapService["id"],
	                        url: mapService["url"],
	                        "opacity": mapService["opacity"]
	                    }));
	                    break;
	                case "dynamic":
	                    var miLayer = new MapImageLayer();
	                    miLayer.id = mapService["id"];
	                    miLayer.url = mapService["url"];
	                    miLayer.visible = mapService["visible"];
	                    miLayer.opacity = mapService["opacity"];
	                    // var subLayers:Collection = new Collection();
	                    // var subLayer0:Object = {
	                    //     id:0,
	                    //     visible:true
	                    // };
	                    // var subLayer1:Object = {
	                    //     id:1,
	                    //     visible:false
	                    // };
	                    // var subLayer2:Sublayer = new Sublayer({
	                    //     id:2,
	                    //     visible:false
	                    // });
	                    // // var subSubLayers:Collection = new Collection();
	                    // // for(var i:number = 0; i < 173; i++){
	                    // //     var subSubLayer:Object = {
	                    // //         id:i,
	                    // //         visible:true
	                    // //     }
	                    // //     subSubLayers.add(subSubLayer);
	                    // // }
	                    // // subLayer2.sublayers = subSubLayers;
	                    // var subLayer3:Object = {
	                    //     id:3,
	                    //     visible:false
	                    // };
	                    // subLayers.addMany([subLayer0, subLayer1, subLayer2, subLayer3]);
	                    // //miLayer.sublayers = subLayers;
	                    _this.layerCollection.add(miLayer);
	                    // layers.add(new MapImageLayer({
	                    //     id:mapService["id"],
	                    //     url:mapService["url"]
	                    // }), mapService["order"]);
	                    break;
	            }
	        });
	    };
	    // openResolutionDocument(resolution:string){
	    //     return this.http.get(this.appSettings["ResolutionFiles"]["serviceURL"] + "/" + resolution)
	    //         .toPromise()
	    //         .then(res => {
	    //             return res;
	    //         })
	    //         .catch(error => {
	    //             alert("Error getting the resolution document. Please try again later.");
	    //             return error;
	    //         });
	    // }
	    MapComponent.prototype.eventsRegion = function () {
	        // //map is loaded, then do some stuff
	        // this.view.then(view => {
	        //     var pt:Point = new Point({
	        //        x: 189280,
	        //        y: 1651766,
	        //        spatialReference: 2965
	        //     });
	        //     view.center = pt;
	        //     view.zoom = this.zoom;
	        //     this.viewCreated.next(view);
	        // });
	        // this.view.on("click", evt => {
	        //     this._eventsService.mapClicked(evt);
	        // });
	        // this._eventsService.mapClicked$.subscribe(evt => {
	        //     var mapPoint:Point = evt.mapPoint;
	        //     this.view.popup.open({
	        //         title: "Location",
	        //         location: evt.mapPoint,
	        //         content: "X: " + mapPoint.x + "; " + "Y: " + mapPoint.y
	        //     });
	        // });
	    };
	    // destroy map
	    MapComponent.prototype.ngOnDestroy = function () {
	        if (this.map) {
	            this.map.destroy();
	        }
	    };
	    return MapComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Number)
	], MapComponent.prototype, "zoom", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], MapComponent.prototype, "viewCreated", void 0);
	__decorate([
	    core_1.ViewChild('mapTooltipSpan'),
	    __metadata("design:type", core_1.ElementRef)
	], MapComponent.prototype, "mapTooltipSpan", void 0);
	MapComponent = __decorate([
	    core_1.Component({
	        selector: 'map-view',
	        template: '<div class="mapViewDiv"><span #mapTooltipSpan *ngIf="showTooltip" class="mapTooltip">{{mapTooltipText}}</span><ng-content></ng-content></div>' // '<div style="position:fixed; height:100%; width:100%"></div>'
	    }),
	    __param(4, core_1.Inject(parcelReport_service_1.ParcelReportService)),
	    __metadata("design:paramtypes", [core_1.ElementRef, map_service_1.MapService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService, Object, http_1.Http])
	], MapComponent);
	exports.MapComponent = MapComponent;


/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_48__;

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_49__;

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_50__;

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_51__;

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_52__;

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_53__;

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_54__;

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_55__;

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_56__;

/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_57__;

/***/ },
/* 58 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_58__;

/***/ },
/* 59 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_59__;

/***/ },
/* 60 */
/***/ function(module, exports) {

	"use strict";
	var Config = (function () {
	    function Config() {
	    }
	    return Config;
	}());
	exports.Config = Config;


/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_61__;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var esriConfig = __webpack_require__(61);
	var MapService = (function () {
	    function MapService() {
	        this.currentDynamicLayers = [];
	        esriConfig.request.useCors = true;
	    }
	    return MapService;
	}());
	MapService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [])
	], MapService);
	exports.MapService = MapService;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var ReplaySubject_1 = __webpack_require__(64);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(74);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var map_service_1 = __webpack_require__(62);
	var config_1 = __webpack_require__(60);
	var MapView = __webpack_require__(49);
	var PrintTask = __webpack_require__(81);
	var PrintTemplate = __webpack_require__(82);
	var PrintParameters = __webpack_require__(83);
	var Map = __webpack_require__(48);
	var Collection = __webpack_require__(53);
	var TileLayer = __webpack_require__(52);
	var MapImageLayer = __webpack_require__(51);
	var Graphic = __webpack_require__(55);
	var SimpleFillSymbol = __webpack_require__(56);
	var SimpleLineSymbol = __webpack_require__(57);
	var Color = __webpack_require__(50);
	var GraphicsLayer = __webpack_require__(54);
	var TextSymbol = __webpack_require__(84);
	var ParcelReportService = (function () {
	    function ParcelReportService(_esriTasksService, _mapService, _eventsService) {
	        this._esriTasksService = _esriTasksService;
	        this._mapService = _mapService;
	        this._eventsService = _eventsService;
	        this.appSettings = null;
	        this.textElementsPage1 = "";
	        this.image1 = "";
	        this.image2 = "";
	        this.image3 = "";
	        this.image4 = "";
	        this.labelGraphicsLayer = new GraphicsLayer();
	        this.inProcess = false;
	        this.activeProject = new ReplaySubject_1.ReplaySubject(1);
	        if (this.appSettings == null) {
	            this.appSettings = config_1.Config.config[0];
	        }
	    }
	    ParcelReportService.prototype.startParcelReport = function (parcelFeature) {
	        var _this = this;
	        this.inProcess = true;
	        this.image1 = "";
	        this.image2 = "";
	        this.parcelFeature = parcelFeature;
	        this.parcelGeometry = parcelFeature["geometry"];
	        this._esriTasksService.bufferFeatures(this.appSettings["GeometryService"]["url"], [this.parcelGeometry], [200], "feet", this._mapService.view.spatialReference).then(function (geometries) {
	            if (geometries.length > 0) {
	                _this.parcelBufferGeometry = geometries[0];
	                _this.getTextValuesForReport();
	            }
	        }, function (error) {
	            _this.errorHandleFunction(error);
	        });
	    };
	    ParcelReportService.prototype.getTextValuesForReport = function () {
	        var _this = this;
	        var url = this.appSettings["ParcelReport"]["TextValuesPage1"]["url"];
	        var layersObject = this.appSettings["ParcelReport"]["TextValuesPage1"]["layersTexts"];
	        var textElementsNames = [];
	        var layersArray = [];
	        for (var key in layersObject) {
	            textElementsNames.push(key);
	            layersArray.push(layersObject[key]);
	        }
	        var centroidLocation = { "X": this.parcelGeometry["centroid"].x, "Y": this.parcelGeometry["centroid"].y };
	        //this._esriTasksService.soePolygonAnalysis(url, this.parcelGeometry["centroid"], layersArray, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], 'INTERSECTS').then(firstPageTextData => {
	        //this._esriTasksService.getAPIPResultsByLocation(url, centroidLocation, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], layersArray).then(firstPageTextData => {
	        this._esriTasksService.soePolygonAnalysis(url, this.parcelGeometry, layersArray, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], 'INTERSECTS').then(function (firstPageTextData) {
	            if (firstPageTextData) {
	                _this.processTextValuesForReportPage1(textElementsNames, firstPageTextData);
	            }
	        }, function (error) {
	            console.log(error);
	            _this.setParcelReportActionToInit();
	            alert("There was an error printing the document (zoning and land use). Please try again later.");
	        });
	    };
	    ParcelReportService.prototype.processTextValuesForReportPage1 = function (textElementsNames, firstPageTextData) {
	        var textElementsObject = new Object();
	        if (firstPageTextData.data.Errors.length == 0) {
	            var resultLayers = firstPageTextData.data.ResultLayers;
	            for (var i = 0; i < textElementsNames.length; i++) {
	                var records = resultLayers[i].Records;
	                var resultArray = [];
	                for (var _i = 0, records_1 = records; _i < records_1.length; _i++) {
	                    var record = records_1[_i];
	                    record.Values[0] == "" ? resultArray.push(this.appSettings["ParcelReport"]["TextValuesPage1"]["emptyStringValueDefault"]) : (resultArray.indexOf(record.Values[0]) == -1 ? resultArray.push(record.Values[0]) : null);
	                }
	                var textElValue = (resultArray.length > 0 ? resultArray.join('; ') : this.appSettings["ParcelReport"]["TextValuesPage1"]["emptyStringValueDefault"]);
	                var customPage1Values = this.appSettings["ParcelReport"]["TextValuesPage1"]["customValues"];
	                if (customPage1Values.hasOwnProperty(textElementsNames[i]) && textElValue != this.appSettings["ParcelReport"]["TextValuesPage1"]["emptyStringValueDefault"]) {
	                    textElValue = customPage1Values[textElementsNames[i]];
	                }
	                textElementsObject[textElementsNames[i]] = textElValue;
	            }
	        }
	        textElementsObject["ParcelNumber"] = this.parcelFeature.attributes["Parcel Number"];
	        textElementsObject["ParcelAddress"] = this.parcelFeature.attributes["Parcel Address"];
	        this.textElementsPage1 = JSON.stringify(textElementsObject);
	        this.printMap1();
	    };
	    ParcelReportService.prototype.generateLabelGraphic = function (labelSetting) {
	        var textSymbol = new TextSymbol();
	        textSymbol.color = new Color(labelSetting["textSymbol"]["color"]);
	        labelSetting["textSymbol"]["backgroundColor"] ? textSymbol.backgroundColor = new Color(labelSetting["textSymbol"]["backgroundColor"]) : null;
	        labelSetting["textSymbol"]["haloColor"] ? textSymbol.haloColor = new Color(labelSetting["textSymbol"]["haloColor"]) : null;
	        labelSetting["textSymbol"]["haloSize"] ? textSymbol.haloSize = labelSetting["textSymbol"]["haloSize"] : null;
	        var textLabelSetting = labelSetting["textSymbol"]["text"];
	        var labelText = (textLabelSetting.includes("{") && textLabelSetting.includes("}")) ? textLabelSetting.replace("{" + textLabelSetting.match(/\{(.*)\}/)[1] + "}", JSON.parse(this.textElementsPage1)[textLabelSetting.match(/\{(.*)\}/)[1]]) : labelSetting["textSymbol"]["text"];
	        textSymbol.text = labelText.split(";").join("\n");
	        var labelGraphic = new Graphic({
	            geometry: this.parcelGeometry["centroid"],
	            symbol: textSymbol
	        });
	        return labelGraphic;
	    };
	    ParcelReportService.prototype.printMap1 = function () {
	        var _this = this;
	        try {
	            var layerCollection = new Collection();
	            layerCollection.add(new TileLayer(this.appSettings["ParcelReport"]["BaseMap"]));
	            this.miLayer = new MapImageLayer({
	                "url": this.appSettings["ParcelReport"]["ZoningAndLandUseMapService"]["url"],
	                "id": this.appSettings["ParcelReport"]["ZoningAndLandUseMapService"]["id"]
	            });
	            this.miLayer.watch("loadError", function (value) {
	                if (value != null) {
	                    _this.errorHandleFunction(value);
	                }
	            });
	            this.miLayer.sublayers = new Collection([{ id: 0, "visible": true }, { id: 1, "visible": false }]);
	            layerCollection.add(this.miLayer);
	            var lineSymbol = new SimpleLineSymbol();
	            lineSymbol.color = new Color([255, 0, 0]);
	            lineSymbol.width = 2;
	            var fillSymbol = new SimpleFillSymbol();
	            fillSymbol.color = new Color([0, 0, 0, 0.3]);
	            fillSymbol.outline = lineSymbol;
	            var parcelGraphic = new Graphic({
	                geometry: this.parcelGeometry,
	                symbol: fillSymbol
	            });
	            var parcelGraphicLayer = new GraphicsLayer();
	            parcelGraphicLayer.add(parcelGraphic);
	            layerCollection.add(parcelGraphicLayer);
	            layerCollection.add(this.labelGraphicsLayer);
	            var labelGraphic = null;
	            this.appSettings["ParcelReport"]["ZoningAndLandUseMapService"]["labels"].forEach(function (element) {
	                if (element["sublayerId"] == 0) {
	                    labelGraphic = _this.generateLabelGraphic(element);
	                    return;
	                }
	            });
	            if (labelGraphic != null) {
	                this.labelGraphicsLayer.add(labelGraphic);
	            }
	            var map = new Map({
	                "layers": layerCollection
	            });
	            if (!this.mapView) {
	                this.mapView = new MapView({
	                    map: map
	                });
	                this.reportMapDiv = document.createElement("div");
	                var reportMapDivID = "reportMap" + Math.floor(Math.random() * 1000000000).toString();
	                this.reportMapDiv.setAttribute("id", reportMapDivID);
	                this.reportMapDiv.style.width = "500px";
	                this.reportMapDiv.style.height = "320px";
	                this.reportMapDiv.style.marginLeft = "-500px";
	                document.body.appendChild(this.reportMapDiv);
	                this.mapView.container = reportMapDivID;
	                this.mapView.then(function (event) {
	                    _this.mapView.extent = _this.parcelBufferGeometry.extent;
	                    _this.mapView.on("layerview-create", function (event) {
	                        if (event.layer.id == "zoningAndLandUse") {
	                            _this.printMapsForZoningAndLandUse();
	                        }
	                        else if (event.layer.id == "thoroughfares") {
	                            _this.printMapsForThoroughfares();
	                        }
	                        else if (event.layer.id == "bikeAndWalkways") {
	                            _this.getTextValuesForBikeAndWalkways();
	                        }
	                    }, function (error) {
	                        _this.errorHandleFunction(error);
	                    });
	                }, function (error) {
	                    _this.errorHandleFunction(error);
	                });
	            }
	            else {
	                this.mapView.set("map", map);
	            }
	        }
	        catch (ex) {
	            this.errorHandleFunction(ex);
	        }
	    };
	    ParcelReportService.prototype.printMapsForZoningAndLandUse = function () {
	        var _this = this;
	        //this.mapView.extent = this.parcelBufferGeometry.extent;
	        var printTask = new PrintTask(this.appSettings["ParcelReport"]["MapOnlyPrintService"]);
	        var template = new PrintTemplate(new Object({
	            "format": "png32",
	            "exportOptions": {
	                "dpi": 150,
	                "width": 500,
	                "height": 320
	            },
	            "layout": "map-only"
	        }));
	        var params = new PrintParameters();
	        params.view = this.mapView;
	        params.template = template;
	        printTask.execute(params).then(function (results) {
	            console.log(results);
	            var fileUrl = results.url;
	            var fileName = fileUrl.substr(fileUrl.lastIndexOf("/") + 1);
	            if (_this.image1 == "") {
	                _this.image1 = fileUrl;
	                _this.miLayer.sublayers = new Collection([{ id: 0, "visible": false }, {
	                        id: 1,
	                        "visible": true
	                    }]);
	                _this.labelGraphicsLayer.graphics.removeAll();
	                var labelGraphic = null;
	                _this.appSettings["ParcelReport"]["ZoningAndLandUseMapService"]["labels"].forEach(function (element) {
	                    if (element["sublayerId"] == 1) {
	                        labelGraphic = _this.generateLabelGraphic(element);
	                        return;
	                    }
	                });
	                if (labelGraphic != null) {
	                    _this.labelGraphicsLayer.add(labelGraphic);
	                }
	                _this.printMapsForZoningAndLandUse();
	                return;
	            }
	            _this.image2 = fileUrl;
	            _this.startReportPage2();
	        }, function (error) {
	            console.log(error);
	            _this.setParcelReportActionToInit();
	            alert("There was an error generating the document (polygon analysis for zoning and land use). Please try again later.");
	        });
	    };
	    ParcelReportService.prototype.startReportPage2 = function () {
	        var layerCollection = new Collection();
	        layerCollection.add(new TileLayer(this.appSettings["ParcelReport"]["BaseMap"]));
	        this.miLayer = new MapImageLayer(this.appSettings["ParcelReport"]["ThoroughfareMapService"]);
	        layerCollection.add(this.miLayer);
	        var lineSymbol = new SimpleLineSymbol();
	        lineSymbol.color = new Color([255, 0, 0]);
	        lineSymbol.width = 2;
	        var fillSymbol = new SimpleFillSymbol();
	        fillSymbol.color = new Color([0, 0, 0, 0.3]);
	        fillSymbol.outline = lineSymbol;
	        var parcelGraphic = new Graphic({
	            geometry: this.parcelGeometry,
	            symbol: fillSymbol
	        });
	        var parcelGraphicLayer = new GraphicsLayer();
	        parcelGraphicLayer.add(parcelGraphic);
	        layerCollection.add(parcelGraphicLayer);
	        var map = new Map({
	            "layers": layerCollection
	        });
	        this.mapView.set("map", map);
	    };
	    ParcelReportService.prototype.printMapsForThoroughfares = function () {
	        var _this = this;
	        //this.mapView.extent = this.parcelBufferGeometry.extent;
	        var printTask = new PrintTask({
	            "url": this.appSettings["ParcelReport"]["ThoroughfarePrintService"]["url"]
	        });
	        var template = new PrintTemplate(new Object({
	            "format": "png32",
	            "layout": this.appSettings["ParcelReport"]["ThoroughfarePrintService"]["layout"],
	            "layoutOptions": new Object({
	                "legendLayers": []
	            })
	        }));
	        var params = new PrintParameters();
	        params.view = this.mapView;
	        params.template = template;
	        printTask.execute(params).then(function (results) {
	            console.log(results);
	            var fileUrl = results.url;
	            _this.image3 = fileUrl;
	            _this.addBikesAndWalkwaysLayer();
	        }, function (error) {
	            console.log(error);
	            _this.setParcelReportActionToInit();
	            alert("There was an error printing the document (thoroughfares). Please try again later.");
	        });
	    };
	    ParcelReportService.prototype.addBikesAndWalkwaysLayer = function () {
	        var currentLayers = this.mapView.map.layers;
	        currentLayers.removeAt(1);
	        this.miLayer = new MapImageLayer(this.appSettings["ParcelReport"]["BikeAndWalkwaysMapService"]);
	        currentLayers.add(this.miLayer, 1);
	    };
	    ParcelReportService.prototype.getTextValuesForBikeAndWalkways = function () {
	        var _this = this;
	        var url = this.appSettings["ParcelReport"]["TextValuesPage2"]["url"];
	        var layersObject = this.appSettings["ParcelReport"]["TextValuesPage2"]["layersTexts"];
	        var textElementsNames = [];
	        var layersArray = [];
	        for (var key in layersObject) {
	            textElementsNames.push(key);
	            layersArray.push(layersObject[key]);
	        }
	        this._esriTasksService.soePolygonAnalysis(url, this.parcelBufferGeometry, layersArray, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], 'INTERSECTS').then(function (secondPageTextData) {
	            var printCustomTexts = [
	                { "PedestrianPlanText": "" },
	                { "PedestrianPlanValues": "" }
	            ];
	            if (secondPageTextData) {
	                var textElementsObject = new Object();
	                if (secondPageTextData.data.Errors.length == 0) {
	                    var resultLayers = secondPageTextData.data.ResultLayers;
	                    for (var i = 0; i < textElementsNames.length; i++) {
	                        var records = resultLayers[i].Records;
	                        if (records.length == 0) {
	                            continue;
	                        }
	                        var resultArray = [];
	                        for (var _i = 0, records_2 = records; _i < records_2.length; _i++) {
	                            var record = records_2[_i];
	                            resultArray.push(record.Values[0]);
	                        }
	                        textElementsObject[textElementsNames[i]] = (resultArray.length > 0 ? resultArray.join('; ') : "");
	                    }
	                    for (var key in textElementsObject) {
	                        if (printCustomTexts[0]["PedestrianPlanText"] == "") {
	                            printCustomTexts[0]["PedestrianPlanText"] = key;
	                        }
	                        else {
	                            printCustomTexts[0]["PedestrianPlanText"] = printCustomTexts[0]["PedestrianPlanText"] + "\r\n" + key;
	                        }
	                        if (printCustomTexts[1]["PedestrianPlanValues"] == "") {
	                            printCustomTexts[1]["PedestrianPlanValues"] = textElementsObject[key];
	                        }
	                        else {
	                            printCustomTexts[1]["PedestrianPlanValues"] = printCustomTexts[1]["PedestrianPlanValues"] + "\r\n" + textElementsObject[key];
	                        }
	                    }
	                }
	            }
	            _this.printMapForBikeAndWalkways(printCustomTexts);
	        });
	    };
	    ParcelReportService.prototype.printMapForBikeAndWalkways = function (printCustomTexts) {
	        var _this = this;
	        //this.mapView.extent = this.parcelBufferGeometry.extent;
	        var printTask = new PrintTask({
	            "url": this.appSettings["ParcelReport"]["BikeAndWalkwaysPrintService"]["url"]
	        });
	        var template = new PrintTemplate(new Object({
	            "format": "png32",
	            "layout": this.appSettings["ParcelReport"]["BikeAndWalkwaysPrintService"]["layout"],
	            "layoutOptions": new Object({
	                "legendLayers": [],
	                "customTextElements": printCustomTexts
	            })
	        }));
	        var params = new PrintParameters();
	        params.view = this.mapView;
	        params.template = template;
	        printTask.execute(params).then(function (results) {
	            console.log(results);
	            var fileUrl = results.url;
	            _this.image4 = fileUrl;
	            _this.createReport();
	        }, function (error) {
	            console.log(error);
	            _this.setParcelReportActionToInit();
	            alert("There was an error printing the document (print bike and walkways). Please try again later.");
	        });
	    };
	    ParcelReportService.prototype.createReport = function () {
	        var _this = this;
	        var url = this.appSettings["ParcelReport"]["ParcelReportGPService"]["url"];
	        this._esriTasksService.createReport(url, this.textElementsPage1, this.image1, this.image2, this.image3, this.image4).then(function (result) {
	            console.log(result);
	            _this.setParcelReportActionToInit();
	            try {
	                if (result.data.results[0].value.url) {
	                    window.open(result.data.results[0].value.url, '_blank');
	                }
	            }
	            catch (ex) {
	                alert("Error printing parcel report. Please try again later;");
	            }
	        }, function (error) {
	            _this.setParcelReportActionToInit();
	            console.log(error);
	            alert("Error printing parcel report (ReportGenerator service). Please try again later.");
	        });
	    };
	    ParcelReportService.prototype.setParcelReportActionToInit = function () {
	        document.body.removeChild(this.reportMapDiv);
	        this.inProcess = false;
	        this.mapView = null;
	        this.activeProject.next({
	            "status": "ready",
	            "parcelNumber": this.parcelFeature["attributes"]["Parcel Number"]
	        });
	        return this.activeProject;
	    };
	    ParcelReportService.prototype.errorHandleFunction = function (error) {
	        document.body.removeChild(this.reportMapDiv);
	        this.inProcess = false;
	        this.mapView = null;
	        this.activeProject.next({
	            "status": "error",
	            "details": "ERROR! " + error.toString(),
	            "parcelNumber": this.parcelFeature["attributes"]["Parcel Number"]
	        });
	        return this.activeProject;
	    };
	    return ParcelReportService;
	}());
	ParcelReportService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [esriTasks_service_1.EsriTasksService, map_service_1.MapService, EventsService_1.EventsService])
	], ParcelReportService);
	exports.ParcelReportService = ParcelReportService;


/***/ },
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_81__;

/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_82__;

/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_83__;

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_84__;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var config_1 = __webpack_require__(60);
	var map_service_1 = __webpack_require__(62);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var Point = __webpack_require__(38);
	var SimpleFillSymbol = __webpack_require__(56);
	var SimpleLineSymbol = __webpack_require__(57);
	var PictureMarkerSymbol = __webpack_require__(86);
	var Polygon = __webpack_require__(42);
	var Polyline = __webpack_require__(43);
	var on = __webpack_require__(59);
	var ScreenPoint = __webpack_require__(87);
	var Color = __webpack_require__(50);
	var Graphic = __webpack_require__(55);
	var PopupTemplate = __webpack_require__(88);
	var Collection = __webpack_require__(53);
	var SpatialReference = __webpack_require__(89);
	var NavToolsComponent = (function () {
	    function NavToolsComponent(elRef, _mapService, _eventsService, _esriTasksService) {
	        this.elRef = elRef;
	        this._mapService = _mapService;
	        this._eventsService = _eventsService;
	        this._esriTasksService = _esriTasksService;
	        this.appSettings = null;
	        this.zoomInInstructions = 'Press "Shift" button and drag area you want to zoom to or double click on the map.';
	        this.zoomOutInstruction = 'Scroll backward or press "Shift" and double click.';
	        this.identifyIterator = 0;
	        this.extendToolbar = false;
	        this.freeHandInstructions = "Click and hold on the map to start. Continue to hold the click and move mouse to draw a freehand polygon. Release the click to complete the freehand polygon.";
	        this.showFreeHandInstructions = true;
	        this.drawPolygonInstructions = "Click and release on the map to start drawing. Continue to click and release on the map to place additional vertices. Double-click on the map to complete the polygon.";
	        this.showDrawPolygonInstructions = true;
	        this.identifyInstructions = "Click on the map to find more information about the clicked feature.";
	        this.showIdentifyInstructions = true;
	        this.obliqueImageyInstructions = "Click on the map to place graphic on the map and see oblique image in the selected point. As you move the graphic on the map, it will update the oblique image view with the new location. Vice versa, the location of the graphic will change if you change the oblique view.";
	        this.showObliqueImageyInstructions = true;
	        this.toolsInstructions = "Select a tool to see instructions on how to use it.";
	        this.showToolsInstructions = true;
	        this.identifyToolListActive = false;
	        this.obliqueToolListActive = false;
	        this.freeHandToolListActive = false;
	        this.drawPolygonToolListActive = false;
	    }
	    NavToolsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.appSettings == null) {
	            this.appSettings = config_1.Config.config[0];
	        }
	        else {
	        }
	        this._eventsService.navItem$.subscribe(function (suggestion) {
	            if (_this.addressSearchIcon.nativeElement.checked == true) {
	                _this.addressSearchIcon.nativeElement.click();
	            }
	        });
	        this._eventsService.disableObliqueImage$.subscribe(function () {
	            _this.obliqueIcon.nativeElement.click();
	        });
	    };
	    NavToolsComponent.prototype.expandToolbarFunction = function () {
	        this.extendToolbar = !this.extendToolbar;
	        this._eventsService.expandMenuToolbar(this.extendToolbar);
	    };
	    NavToolsComponent.prototype.fullExtent = function () {
	        this._mapService.view.zoom = 4;
	        //map is loaded, then do some stuff
	        var pt = new Point({
	            x: this.appSettings["Map"]["Center"]["x"],
	            y: this.appSettings["Map"]["Center"]["y"],
	            spatialReference: this._mapService.view.spatialReference
	        });
	        this._mapService.view.center = pt;
	    };
	    NavToolsComponent.prototype.selectToolFromList = function (toolValue) {
	        var mapNavToolEls = document.getElementsByName("mapToolActive");
	        for (var k = 0; k < mapNavToolEls.length; k++) {
	            if (mapNavToolEls[k].value == toolValue) {
	                mapNavToolEls[k].click();
	                return;
	            }
	        }
	    };
	    NavToolsComponent.prototype.selectMapNavTool = function (event) {
	        if (event.checked == true) {
	            var mapNavToolEls = document.getElementsByName("mapToolActive");
	            for (var k = 0; k < mapNavToolEls.length; k++) {
	                if (mapNavToolEls[k].checked == true && mapNavToolEls[k].value != event.value) {
	                    mapNavToolEls[k].click();
	                }
	            }
	            //this._eventsService.mapNavigationTool({"name": event.currentTarget.value, "value":true});
	            this.hideSnackBar();
	            switch (event.value) {
	                // case "Zoom In":
	                //     setTimeout(() =>
	                //     {
	                //         this.showSnackBar(this.zoomInInstructions, 60000);
	                //     }, 800);
	                //     break;
	                // case "Zoom Out":
	                //     setTimeout(() =>
	                //     {
	                //         this.showSnackBar(this.zoomOutInstruction, 60000);
	                //     }, 800);
	                //     break;
	                case "Free Hand Draw":
	                    this.NEWFreeHandPolygonToolActivate();
	                    break;
	                case "Polygon Draw Tool":
	                    this.NEWdrawPolygonToolActivate();
	                    break;
	                case "Identify":
	                    this.identifyToolActivate();
	                    break;
	                case "Oblique Imagery":
	                    this.obliqueImageryActivate();
	                    break;
	            }
	        }
	        else {
	            //this._eventsService.mapNavigationTool({"name": event.currentTarget.value, "value":false});
	            this.hideSnackBar();
	            switch (event.value) {
	                // case "Zoom In":
	                //     setTimeout(() =>
	                //     {
	                //         this.showSnackBar({message:this.zoomInInstructions, 60000);
	                //     }, 800);
	                //     break;
	                // case "Zoom Out":
	                //     setTimeout(() =>
	                //     {
	                //         this.showSnackBar(this.zoomOutInstruction, 60000);
	                //     }, 800);
	                //     break;
	                case "Free Hand Draw":
	                    this.NEWFreeHandPolygonToolDeactivate();
	                    break;
	                case "Polygon Draw Tool":
	                    this.NEWdrawPolygonToolDeactivate();
	                    break;
	                case "Identify":
	                    this.identifyToolDeactivate();
	                    break;
	                case "Oblique Imagery":
	                    this.obliqueImageryDeactivate();
	                    break;
	            }
	        }
	    };
	    NavToolsComponent.prototype.identifyToolActivate = function () {
	        var _this = this;
	        this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to identify" });
	        this.identifyToolListActive = true;
	        if (this.showIdentifyInstructions == true) {
	            var dataSnack = {
	                message: this.identifyInstructions,
	                timeout: 15000,
	                actionHandler: function (e) {
	                    _this.hideSnackBar();
	                    _this.showIdentifyInstructions = false;
	                },
	                actionText: "Hide"
	            };
	            this.showSnackBar(dataSnack);
	        }
	        this.mapClickSubscription = this._eventsService.mapClicked$.subscribe(function (evt) {
	            _this._mapService.view.popup.clear();
	            _this._mapService.view.popup.actions.removeAll();
	            setTimeout(function () {
	                if (_this._mapService.view.popup.content == "" || _this._mapService.view.popup.content == null) {
	                    _this._mapService.view.popup.open({
	                        content: "Please wait...",
	                        location: evt.mapPoint
	                    });
	                }
	            }, 200);
	            _this.identifyPoint = evt.mapPoint;
	            _this._eventsService.identifyLocationChanged(_this.identifyPoint);
	            _this.identifyFeatureItems = [];
	            _this.identifyIterator = 0;
	            _this.doIdentifyTask();
	        });
	        this.mapPointerDownSubscription = this._eventsService.mapPointerDown$.subscribe(function (evt) {
	            _this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	        });
	    };
	    NavToolsComponent.prototype.doIdentifyTask = function () {
	        var _this = this;
	        var idMSUrl = this._mapService.currentDynamicLayers[this.identifyIterator].url;
	        var layersToIdentify = [];
	        var layers = this._mapService.currentDynamicLayers[this.identifyIterator].sublayers["items"];
	        var definitionExpressions = {};
	        for (var _i = 0, layers_1 = layers; _i < layers_1.length; _i++) {
	            var layer = layers_1[_i];
	            if (layer["visible"] == true) {
	                layersToIdentify.push(layer["id"]);
	                definitionExpressions[layer["id"]] = (layer["definitionExpression"]);
	            }
	        }
	        this._esriTasksService.identifyFeatures(idMSUrl, this.identifyPoint, this._mapService.view.extent, 1, layersToIdentify, "visible", true, definitionExpressions)
	            .then(function (item) {
	            _this._mapService.view.popup.open({
	                content: "Please wait...",
	                location: _this.identifyPoint
	            });
	            _this.processIdentifyResults(item.results, _this.identifyPoint);
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    NavToolsComponent.prototype.processIdentifyResults = function (results, point) {
	        var _this = this;
	        var _loop_1 = function (result) {
	            var feature = result.feature;
	            var layerName = result.layerName;
	            var popupTemplate = new PopupTemplate();
	            popupTemplate.title = layerName;
	            attributes = feature.attributes;
	            try {
	                switch (layerName) {
	                    case "Land Use Plan Base Typology":
	                        popupTemplate.content = "<b>Recommended Land Use: </b>" + attributes["USEDESC"] + "<br/>" + "<b>Adopting Resolution: </b>" + attributes["RESOLUTION"];
	                        break;
	                    case "Land Use Plan Overlays":
	                        popupTemplate.content = "<b>Overlay Type: </b>" + attributes["TypeName"] + "<br/>" + "<b>Overlay ID: </b>" + attributes["ID"] + "<br/>" + "<b>Adopting Resolution: </b>" + attributes["Resolution"];
	                        break;
	                    case "Specific Area Plan":
	                        this_1._esriTasksService.getServiceValues(this_1.appSettings["ResolutionFiles"]["serviceURL"] + "/" + attributes["Resolution"]).then(function (resDocInfo) {
	                            popupTemplate.content = "<b>Specific Area Plan Name: </b>" + resDocInfo["PlanName"] + "<br/>" + "<b>Adopting Resolution: </b>" + resDocInfo["Resolution"];
	                        }).catch(function (error) {
	                            popupTemplate.content = "<b>Adopting Resolution: </b>" + attributes["Resolution"];
	                        });
	                        break;
	                    case "DMD Certified Plans":
	                        popupTemplate.content = "<b>Certified Plan Name: </b>" + attributes["NAME"] + "<br/>" + "<b>Certification Period: </b>" + attributes["START_DATE"] + " to " + attributes["EXPIRE_DATE"];
	                        break;
	                    case "Redevelopment/Economic Development Areas":
	                        areaDescription = null;
	                        if (attributes["EDAorRDA"] == "RDA") {
	                            areaDescription = "Redevelopment Area";
	                        }
	                        else if (attributes["EDAorRDA"] == "EDA") {
	                            areaDescription = "Economic Development Area";
	                        }
	                        popupTemplate.content = "<b>Area Name: </b>" + attributes["NAME"] + ((areaDescription != null) ? ("<br/>" + "<b>Area Type: </b>" + areaDescription) : "");
	                        break;
	                    case "TIF Districts":
	                        popupTemplate.content = "<b>TIF Allocation Area Name: </b>" + attributes["TIF_NAME"] + "<br/>" + "<b>TIF Type: </b>" + attributes["TIF_TYPE"];
	                        break;
	                    case "CRED Districts":
	                        popupTemplate.content = "<b>CRED Name: </b>" + "Lafayette Square CRED";
	                        break;
	                    case "Certified Technology Parks":
	                        popupTemplate.content = "<b>CTP Name: </b>" + attributes["NAME"];
	                        break;
	                    case "Promise Zone":
	                        popupTemplate.content = "<b>Name: </b>IndyEast Promise Zone";
	                        break;
	                    case "Opportunity Zone":
	                        popupTemplate.content = "<b>Opportunity Zone: </b>Yes";
	                        break;
	                    case "Neighborhood Revitalization Strategy Area":
	                        popupTemplate.content = "<b>Name: </b>" + attributes["NAME"];
	                        break;
	                    case "Economic Improvement Districts":
	                        popupTemplate.content = "<b>Name: </b>" + attributes["NAME"];
	                        break;
	                    case "Market Value Analysis":
	                        popupTemplate.content = "<b>Market Value: </b>" + attributes["MVA_FINAL"];
	                        break;
	                    case "Neighborhood Investment Analysis":
	                        popupTemplate.content = "<b>Neighborhood Type: </b>" + attributes["NIA_FINAL"];
	                        break;
	                    case "Thoroughfare Plan":
	                        status = null;
	                        if (attributes["OPER_STATUS"] == "BUILT") {
	                            status = "Built";
	                        }
	                        else if (attributes["OPER_STATUS"] == "BUILT_EP" || attributes["OPER_STATUS"] == "BUILT_EP2") {
	                            status = "Proposed Expansion to " + attributes["LANES"] + "Travel Lanes";
	                        }
	                        else if (attributes["OPER_STATUS"] == "PLANNED TFARE") {
	                            status = "Planned New Terrain Street with " + attributes["LANES"] + "Travel Lanes";
	                        }
	                        else if (attributes["OPER_STATUS"] == "BUILT_MMEP") {
	                            status = "Planned Expansion for MultiModal Trail or Greenway";
	                        }
	                        else if (attributes["OPER_STATUS"] == "PLANNED MM") {
	                            status = "Planned MultiModal Trail or Greenway";
	                        }
	                        rowWidth = null;
	                        if (attributes["PROP_ROW"] == 0) {
	                            rowWidth = "Existing";
	                        }
	                        else {
	                            rowWidth = attributes["PROP_ROW"] + "'";
	                        }
	                        popupTemplate.content = "<b>Street Name: </b>" + attributes["FULL_STNAME"] +
	                            "<br/>" + "<b>Thoroughfare Class: </b>" + attributes["T_FARE"] +
	                            ((status != null) ? ("<br/>" + "<b>Status: </b>" + status) : "") +
	                            "<br/>" + "<b>Proposed Right-of-Way Width: </b>" + rowWidth;
	                        break;
	                    case "Bikeways and Greenways":
	                        popupTemplate.content = "<b>Name: </b>" + attributes["STREET_NAME"] +
	                            "<br/>" + "<b>Type: </b>" + attributes["TYPE"] +
	                            "<br/>" + "<b>Status: </b>" + attributes["STATUS"] +
	                            "<br/>" + "<b>Adopting Resolution: </b>" + attributes["RESOLUTION"];
	                        break;
	                    case "Pedestrian Plan Priority Areas":
	                        popupTemplate.content = "<b>Priority Tier: </b>" + attributes["TIER"];
	                        break;
	                }
	            }
	            catch (exc) {
	                console.log(exc);
	                content = "";
	                for (var attribute in attributes) {
	                    if (content == "") {
	                        content = attribute + ": " + attributes[attribute];
	                    }
	                    else {
	                        content = content + "<br/>" + attribute + ": " + attributes[attribute];
	                    }
	                }
	                popupTemplate.content = content;
	            }
	            feature.popupTemplate = popupTemplate;
	            feature.popupTemplate.actions = new Collection();
	            // Defines an action that zooms out from the selected feature
	            var zoomToAction = {
	                // This text is displayed as a tool tip
	                title: "Zoom to",
	                id: "zoom-to-addon",
	                // An icon font provided by the API
	                className: "esri-icon-zoom-in-magnifying-glass"
	            };
	            // Adds the action to the view's default popup.
	            feature.popupTemplate.actions.push(zoomToAction);
	            //Add action to open new page with .pdf document
	            if (this_1.appSettings["ResolutionFiles"]["resolutionLayerField"].hasOwnProperty(result.layerName)) {
	                if (feature.attributes.hasOwnProperty(this_1.appSettings["ResolutionFiles"]["resolutionLayerField"][result.layerName])) {
	                    openPDFDocAction = {
	                        title: "See document",
	                        id: "see-document",
	                        className: "esri-icon-link-external",
	                        extra: {
	                            resolutionValue: feature.attributes[this_1.appSettings["ResolutionFiles"]["resolutionLayerField"][result.layerName]]
	                        }
	                    };
	                    feature.popupTemplate.actions.push(openPDFDocAction);
	                }
	            }
	            this_1.identifyFeatureItems.push(feature);
	        };
	        var this_1 = this, attributes, areaDescription, status, rowWidth, content, openPDFDocAction;
	        for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
	            var result = results_1[_i];
	            _loop_1(result);
	        }
	        this.identifyIterator++;
	        if (this.identifyIterator < this._mapService.currentDynamicLayers.length) {
	            this.doIdentifyTask();
	        }
	        else {
	            var layersToIdentify = this.appSettings["IdentifyTool"]["Parcels"]["layers"];
	            this._esriTasksService.identifyFeatures(this.appSettings["IdentifyTool"]["Parcels"]["URL"], this.identifyPoint, this._mapService.view.extent, 1, layersToIdentify, this.appSettings["IdentifyTool"]["Parcels"]["searchOptions"], true, {})
	                .then(function (item) {
	                if (item.results && item.results[0]) {
	                    var resultFeature = item.results[0]["feature"];
	                    var parcelNumber = resultFeature["attributes"]["PARCEL_C"];
	                    var parcelAddress = resultFeature["attributes"]["STNUMBER"] + " " + ((resultFeature["attributes"]["PRE_DIR"] == "Null") ? "" : (resultFeature["attributes"]["PRE_DIR"] + " ")) + resultFeature["attributes"]["FULL_STNAME"] + " " + resultFeature["attributes"]["CITY"] + ", " + resultFeature["attributes"]["STATE"] + " " + resultFeature["attributes"]["ZIPCODE"];
	                    var parcelGraphic = new Graphic();
	                    parcelGraphic.attributes = { "Parcel Number": parcelNumber, "Parcel Address": parcelAddress };
	                    parcelGraphic.geometry = resultFeature.geometry;
	                    _this.createParcelPopup(parcelGraphic);
	                }
	                _this.showResultsPopup(point);
	            }, function (error) {
	                console.log(error);
	                _this.showResultsPopup(point);
	            });
	        }
	    };
	    NavToolsComponent.prototype.createParcelPopup = function (parcelGraphic) {
	        var parcelPopupTemplate = new PopupTemplate();
	        parcelPopupTemplate.title = "Parcels";
	        var parcelPopupContent = "";
	        for (var attribute in parcelGraphic.attributes) {
	            if (parcelPopupContent == "") {
	                parcelPopupContent = attribute + ": " + parcelGraphic.attributes[attribute];
	            }
	            else {
	                parcelPopupContent = parcelPopupContent + "<br/>" + attribute + ": " + parcelGraphic.attributes[attribute];
	            }
	        }
	        var parcelReportIconPath = "./images/parcel-report-icon.png";
	        var parcReportAction = {
	            title: "Generate Parcel Report",
	            id: "parcel-report",
	            //className: "esri-icon-documentation",
	            image: parcelReportIconPath
	        };
	        var prcAction = {
	            title: "Show property report card",
	            id: "prc-card",
	            className: "esri-icon-launch-link-external"
	        };
	        var zoomToAction = {
	            title: "Zoom to",
	            id: "zoom-to-addon",
	            className: "esri-icon-zoom-in-magnifying-glass"
	        };
	        parcelPopupTemplate.actions = new Collection();
	        parcelPopupTemplate.actions.addMany([zoomToAction, prcAction, parcReportAction]);
	        parcelPopupTemplate.content = parcelPopupContent;
	        parcelGraphic.popupTemplate = parcelPopupTemplate;
	        this.identifyFeatureItems.push(parcelGraphic);
	    };
	    NavToolsComponent.prototype.showResultsPopup = function (point) {
	        if (this.identifyFeatureItems.length > 0) {
	            this._mapService.view.popup.open({
	                features: this.identifyFeatureItems,
	                location: point
	            });
	        }
	        else {
	            this._mapService.view.popup.open({
	                content: "No features found at the specified location.",
	                location: point
	            });
	        }
	    };
	    NavToolsComponent.prototype.identifyToolDeactivate = function () {
	        this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	        this.mapClickSubscription.unsubscribe();
	        this.mapPointerDownSubscription.unsubscribe();
	        this.identifyToolListActive = false;
	    };
	    NavToolsComponent.prototype.obliqueImageryActivate = function () {
	        var _this = this;
	        var pointSym = new PictureMarkerSymbol();
	        pointSym.url = "./images/i_pin3.png";
	        pointSym.width = 24;
	        pointSym.height = 24;
	        pointSym.xoffset = 6;
	        pointSym.yoffset = 9;
	        this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to start" });
	        this.obliqueToolListActive = true;
	        if (this.showObliqueImageyInstructions == true) {
	            var dataSnack = {
	                message: this.obliqueImageyInstructions,
	                timeout: 20000,
	                actionHandler: function (e) {
	                    _this.hideSnackBar();
	                    _this.showObliqueImageyInstructions = false;
	                },
	                actionText: "Hide"
	            };
	            this.showSnackBar(dataSnack);
	        }
	        this.mapPointerDownSubscription = this._eventsService.mapPointerDown$.subscribe(function (mdevt) {
	            _this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	            _this._eventsService.showObliqueImage(true);
	            if (_this._mapService.obliquePointGraphicLayer.graphics.length == 0) {
	                mdevt.stopPropagation();
	                var point = _this._mapService.view.toMap(new ScreenPoint({
	                    x: mdevt.x,
	                    y: mdevt.y
	                }));
	                var newTestCenterGraphic = new Graphic({
	                    geometry: point,
	                    symbol: pointSym
	                });
	                _this._mapService.obliquePointGraphicLayer.graphics.add(newTestCenterGraphic);
	                _this.obliqueImageryPointerUp();
	            }
	            else {
	                var oblGraphic = _this._mapService.obliquePointGraphicLayer.graphics.getItemAt(0);
	                var oblScreenPoint = _this._mapService.view.toScreen(oblGraphic.geometry);
	                if (Math.round(oblScreenPoint.x) < (mdevt.x + 10) && Math.round(oblScreenPoint.x) > (mdevt.x - 10) && Math.round(oblScreenPoint.y) < (mdevt.y + 10) && Math.round(oblScreenPoint.y) > (mdevt.y - 10)) {
	                    _this.obliqueImageryPointerUp();
	                    _this._eventsService.showMapTooltip({ "show": true, "tooltip": "Drop pin to see oblique image" });
	                    _this.mapDragSubscription = _this._eventsService.mapDrag$.subscribe(function (evt) {
	                        evt.stopPropagation();
	                        var point = _this._mapService.view.toMap(new ScreenPoint({
	                            x: evt.x,
	                            y: evt.y
	                        }));
	                        var newTestCenterGraphic = new Graphic({
	                            geometry: point,
	                            symbol: pointSym
	                        });
	                        _this._mapService.obliquePointGraphicLayer.graphics.removeAll();
	                        _this._mapService.obliquePointGraphicLayer.graphics.add(newTestCenterGraphic);
	                    });
	                }
	            }
	        });
	        this.obliquePhotoSyncSubscription = this._eventsService.ipaSyncLocation$.subscribe(function (view) {
	            var point = new Point({
	                x: view.x,
	                y: view.y,
	                spatialReference: new SpatialReference({ wkid: 4326 })
	            });
	            _this._esriTasksService.projectGeometries(_this.appSettings["GeometryService"]["url"], [point], _this._mapService.view.spatialReference).then(function (result) {
	                if (result[0]) {
	                    var newPoint = result[0];
	                    var newGraphic = new Graphic({
	                        geometry: newPoint,
	                        symbol: pointSym
	                    });
	                    _this._mapService.obliquePointGraphicLayer.graphics.removeAll();
	                    _this._mapService.obliquePointGraphicLayer.graphics.add(newGraphic);
	                }
	            });
	        });
	    };
	    NavToolsComponent.prototype.obliqueImageryPointerUp = function () {
	        var _this = this;
	        this.mapPointerUpSubscription = this._eventsService.mapPointerUp$.subscribe(function (muevt) {
	            _this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	            if (_this.mapDragSubscription) {
	                _this.mapDragSubscription.unsubscribe();
	            }
	            var point = _this._mapService.view.toMap(new ScreenPoint({
	                x: muevt.x,
	                y: muevt.y
	            }));
	            _this._esriTasksService.projectGeometries(_this.appSettings["GeometryService"]["url"], [point], new SpatialReference({ wkid: 4326 })).then(function (result) {
	                if (result[0]) {
	                    var ipaCoords = {
	                        x: result[0].x,
	                        y: result[0].y
	                    };
	                    _this._eventsService.ipaSetLocation(ipaCoords);
	                }
	                _this.mapPointerUpSubscription.unsubscribe();
	            });
	        });
	    };
	    NavToolsComponent.prototype.obliqueImageryDeactivate = function () {
	        this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	        this.obliqueToolListActive = false;
	        this.mapPointerDownSubscription.unsubscribe();
	        if (this.mapDragSubscription) {
	            this.mapDragSubscription.unsubscribe();
	        }
	        this.mapPointerUpSubscription ? this.mapPointerUpSubscription.unsubscribe() : null;
	        this._mapService.obliquePointGraphicLayer.graphics.removeAll();
	        this._eventsService.showObliqueImage(false);
	    };
	    NavToolsComponent.prototype.selectAddressSearchTool = function (event) {
	        this._eventsService.addressSearchActivate(event.currentTarget.checked);
	    };
	    NavToolsComponent.prototype.selectFilterTool = function (event) {
	    };
	    NavToolsComponent.prototype.showSnackBar = function (dataSnack) {
	        var snackbarContainer = document.querySelector('#demo-toast-example');
	        setTimeout(function () {
	            snackbarContainer['MaterialSnackbar'].showSnackbar(dataSnack);
	        }, 600);
	    };
	    NavToolsComponent.prototype.hideSnackBar = function () {
	        var snackbarContainer = document.querySelector('#demo-toast-example');
	        snackbarContainer['MaterialSnackbar'].cleanup_();
	    };
	    NavToolsComponent.prototype.freeHandToolDeactivate = function () {
	        this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	        this.freeHandToolListActive = false;
	        if (this.drawHandler) {
	            this.drawHandler.remove();
	        }
	        // Enable movement of the map again
	        // setTimeout(() =>
	        // {
	        if (this._mapService.view.type === "3d") {
	            this._mapService.view['navigationControls'].mouseDragLeft = 'pan';
	        }
	        else {
	            //this._mapService.view['gestureManager'].inputManager.manager.options.enable = true;
	            var handlers = this._mapService.view["inputManager"]._handlers;
	            for (var i = 0; i < handlers.length; i++) {
	                handlers[i].active = true;
	            }
	        }
	        //}, 2000);
	    };
	    NavToolsComponent.prototype.freeHandToolActivate = function () {
	        var _this = this;
	        this._eventsService.showMapTooltip({ "show": true, "tooltip": "Press down to start and let go to finish" });
	        this.freeHandToolListActive = true;
	        if (this.showFreeHandInstructions == true) {
	            var dataSnack = {
	                message: this.freeHandInstructions,
	                timeout: 15000,
	                actionHandler: function (e) {
	                    _this.hideSnackBar();
	                    _this.showFreeHandInstructions = false;
	                },
	                actionText: "Hide"
	            };
	            this.showSnackBar(dataSnack);
	        }
	        var rings = new Array();
	        var currentGraphic;
	        var lineSymbol = new SimpleLineSymbol();
	        lineSymbol.color = new Color([255, 0, 0]);
	        lineSymbol.width = 1;
	        var fillSymbol = new SimpleFillSymbol();
	        fillSymbol.color = new Color([0, 0, 0, 0.5]);
	        fillSymbol.outline = lineSymbol;
	        var geometryEngine;
	        var currentClickPoint;
	        var curScreenPoint;
	        var screenPointForOffset = null;
	        var xOffset = 0;
	        var yOffset = -104;
	        // We temporarily disable the ability to move the map
	        if (this._mapService.view.type === "3d") {
	            this._mapService.view['navigationControls'].mouseDragLeft = 'select';
	        }
	        else {
	            //this._mapService.view['gestureManager'].inputManager.manager.options.enable = false;
	            var handlers = this._mapService.view["inputManager"]._handlers;
	            for (var i = 0; i < handlers.length; i++) {
	                handlers[i].active = false;
	            }
	        }
	        // this.freeHandDrawMapViewHandler = on(this._mapService.view, "click", evt => {
	        //     currentClickPoint = evt.mapPoint;
	        //     curScreenPoint = this._mapService.view.toScreen(currentClickPoint);
	        // });
	        this.drawHandler = on(this._mapService.view.container, "mousedown", function (evt) {
	            // if(screenPointForOffset == null){
	            //     screenPointForOffset = new ScreenPoint();
	            //     screenPointForOffset.x = evt.x;
	            //     screenPointForOffset.y = evt.y;
	            //     xOffset = curScreenPoint.x - screenPointForOffset.x;
	            //     yOffset = curScreenPoint.y - screenPointForOffset.y;
	            // }
	            _this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	            rings = [];
	            evt.preventDefault();
	            //Get screen point from evt
	            var screenPoint = new ScreenPoint();
	            screenPoint.x = evt.x + xOffset;
	            screenPoint.y = evt.y + yOffset;
	            // Get the start point for the temporary line
	            var drawStart = new Point();
	            _this._mapService.view.toMap(screenPoint, drawStart);
	            rings.push([drawStart.x, drawStart.y]);
	            // The next segment of the line is created by listening to the mousemove
	            // event on the view. For each event, we add to the resulting line.
	            var nextSegment = on(_this._mapService.view.container, "mousemove", function (mmevt) {
	                //mmevt.preventDefault();
	                // Remove the previous graphic, as we will update it
	                // with the new graphic
	                if (currentGraphic) {
	                    _this._mapService.selGraphics.remove(currentGraphic);
	                }
	                var mmScreenPoint = new ScreenPoint();
	                mmScreenPoint.x = mmevt.x + xOffset;
	                mmScreenPoint.y = mmevt.y + yOffset;
	                // Progressivly add new points to the line
	                var nextPoint = new Point();
	                _this._mapService.view.toMap(mmScreenPoint, nextPoint);
	                //this._mapService.selGraphics.graphics.add(new Graphic({"geometry":nextPoint, symbol: new SimpleMarkerSymbol()}));
	                if ((nextPoint.z !== undefined && _this._mapService.view.type === '3d') || _this._mapService.view.type === '2d') {
	                    rings.push([nextPoint.x, nextPoint.y]);
	                    // Update the graphic in the graphics layer
	                    currentGraphic = new Graphic({
	                        geometry: new Polyline({
	                            paths: rings,
	                            spatialReference: _this._mapService.view.spatialReference
	                        }),
	                        symbol: lineSymbol
	                    });
	                    _this._mapService.selGraphics.graphics.add(currentGraphic);
	                }
	            });
	            // The final segment is a mouseup event on the map.view. When this fires
	            // we complete the polygon.
	            var lastSegment = on(_this._mapService.view.container, "mouseup", function (muevt) {
	                //this.drawHandler.remove();
	                nextSegment.remove();
	                lastSegment.remove();
	                // Enable movement of the map again
	                if (_this._mapService.view.type === "3d") {
	                    _this._mapService.view['navigationControls'].mouseDragLeft = 'pan';
	                }
	                else {
	                    //this._mapService.view['gestureManager'].inputManager.manager.options.enable = false;
	                    var handlers = _this._mapService.view["inputManager"]._handlers;
	                    for (var i = 0; i < handlers.length; i++) {
	                        handlers[i].active = false;
	                    }
	                }
	                // Remove the previous line graphic
	                _this._mapService.selGraphics.remove(currentGraphic);
	                var muScreenPoint = new ScreenPoint();
	                muScreenPoint.x = muevt.x + xOffset;
	                muScreenPoint.y = muevt.y + yOffset;
	                // Construct the final point of the line
	                var lastPoint = new Point();
	                _this._mapService.view.toMap(muScreenPoint, lastPoint);
	                // Add the original point to the end of the line to
	                // complete the polygon
	                var firstPointCopy = [rings[0][0], rings[0][1]];
	                rings.push(firstPointCopy);
	                // Create the polygon and simplify
	                var polygon = new Polygon({
	                    rings: rings,
	                    spatialReference: _this._mapService.view.spatialReference
	                });
	                //var simplePolygon = geometryEngine.simplify(polygon);
	                var currentGraphic = new Graphic({
	                    geometry: polygon,
	                    symbol: fillSymbol
	                });
	                // Add the graphic
	                _this._mapService.selGraphics.add(currentGraphic);
	                var suggestion = {
	                    FullAddress: "Custom Polygon",
	                    FullName: "Custom Polygon",
	                    Geometry: polygon,
	                    SuggestionType: "FreeHandPolygon"
	                };
	                //Emit event to set selected geometry
	                var pickedGeometry = { addressSuggestion: suggestion, addressLocation: suggestion["Geometry"] };
	                _this._eventsService.changeNav(pickedGeometry);
	                _this._mapService.view.extent = polygon.extent;
	                _this._mapService.tempSelPlgGraphics.graphics.removeAll();
	                _this._mapService.selGraphics.graphics.removeAll();
	                _this._mapService.tempSelGraphics.graphics.removeAll();
	                var mapNavToolEls = document.getElementsByName("mapToolActive");
	                for (var k = 0; k < mapNavToolEls.length; k++) {
	                    if (mapNavToolEls[k].checked == true && mapNavToolEls[k].id == "free-hand-draw-icon") {
	                        mapNavToolEls[k].click();
	                    }
	                }
	                //this._eventsService.multipleSelectComplete(polygon);
	            });
	        });
	    };
	    //Draw polygon tool
	    NavToolsComponent.prototype.drawPolygonToolDeactivate = function () {
	        this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	        this.drawPolygonToolListActive = false;
	        if (this.drawPolygonHandler) {
	            this.drawPolygonHandler.remove();
	        }
	        if (this.polygonDrawMoveHandler) {
	            this.polygonDrawMoveHandler.remove();
	        }
	        if (this.polygonDrawDoubleClickHandler) {
	            this.polygonDrawDoubleClickHandler.remove();
	        }
	        if (this.drawPolygonScreenClickHandler) {
	            this.drawPolygonScreenClickHandler.remove();
	        }
	        this._mapService.tempSelPlgGraphics.graphics.removeAll();
	        this._mapService.selGraphics.graphics.removeAll();
	        this._mapService.tempSelGraphics.graphics.removeAll();
	        // Enable movement of the map again
	        if (this._mapService.view.type === "3d") {
	            this._mapService.view['navigationControls'].mouseDragLeft = 'pan';
	        }
	        else {
	            //this._mapService.view['gestureManager'].inputManager.manager.options.enable = true;
	            var handlers = this._mapService.view["inputManager"]._handlers;
	            for (var i = 0; i < handlers.length; i++) {
	                handlers[i].active = true;
	            }
	        }
	    };
	    NavToolsComponent.prototype.drawPolygonToolActivate = function () {
	        var _this = this;
	        this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to start drawing" });
	        this.drawPolygonToolListActive = true;
	        if (this.showDrawPolygonInstructions == true) {
	            var dataSnack = {
	                message: this.drawPolygonInstructions,
	                timeout: 15000,
	                actionHandler: function (e) {
	                    _this.hideSnackBar();
	                    _this.showDrawPolygonInstructions = false;
	                },
	                actionText: "Hide"
	            };
	            this.showSnackBar(dataSnack);
	        }
	        var rings = new Array();
	        var tempPolygonRings = new Array();
	        var currentGraphic;
	        var lineSymbol = new SimpleLineSymbol();
	        lineSymbol.color = new Color([255, 0, 0]);
	        lineSymbol.width = 1;
	        var fillSymbol = new SimpleFillSymbol();
	        fillSymbol.color = new Color([0, 0, 0, 0.5]);
	        fillSymbol.outline = null;
	        var geometryEngine;
	        var drawStart;
	        var currentClickPoint;
	        var screenPointForOffset = new ScreenPoint();
	        var xOffset;
	        var yOffset;
	        this.drawPolygonScreenClickHandler = on(this._mapService.view.container, "click", function (evt) {
	            _this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to continue drawing" });
	            // Get the start point for the temporary line
	            if (drawStart) {
	                //Get screen point from evt
	                var screenPoint = new ScreenPoint();
	                screenPoint.x = evt.x + xOffset;
	                screenPoint.y = evt.y + yOffset;
	                var drawPoint = _this._mapService.view.toMap(screenPoint);
	                rings.push([drawPoint.x, drawPoint.y]);
	                // Update the graphic in the graphics layer
	                currentGraphic = new Graphic({
	                    geometry: new Polyline({
	                        paths: rings,
	                        spatialReference: _this._mapService.view.spatialReference
	                    }),
	                    symbol: lineSymbol
	                });
	                _this._mapService.selGraphics.graphics.add(currentGraphic);
	            }
	            else {
	                screenPointForOffset.x = evt.x;
	                screenPointForOffset.y = evt.y;
	                return;
	            }
	            if (rings.length > 1) {
	                _this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to continue drawing. Double-click to complete." });
	                _this._mapService.tempSelPlgGraphics.graphics.removeAll();
	                tempPolygonRings = [];
	                for (var _i = 0, rings_1 = rings; _i < rings_1.length; _i++) {
	                    var ring = rings_1[_i];
	                    tempPolygonRings.push(ring);
	                }
	                var firstPointCopy = [rings[0][0], rings[0][1]];
	                tempPolygonRings.push(firstPointCopy);
	                // Update the graphic in the graphics layer
	                currentGraphic = new Graphic({
	                    geometry: new Polygon({
	                        rings: tempPolygonRings,
	                        spatialReference: _this._mapService.view.spatialReference
	                    }),
	                    symbol: fillSymbol
	                });
	                _this._mapService.tempSelPlgGraphics.graphics.add(currentGraphic);
	            }
	        });
	        this.drawPolygonHandler = on(this._mapService.view, "click", function (evt) {
	            if (drawStart) {
	                return;
	            }
	            currentClickPoint = evt.mapPoint;
	            var curScreenPoint = _this._mapService.view.toScreen(currentClickPoint);
	            drawStart = currentClickPoint;
	            rings.push([drawStart.x, drawStart.y]);
	            xOffset = curScreenPoint.x - screenPointForOffset.x;
	            yOffset = curScreenPoint.y - screenPointForOffset.y;
	            // We temporarily disable the ability to move the map
	            if (_this._mapService.view.type === "3d") {
	                _this._mapService.view['navigationControls'].mouseDragLeft = 'select';
	            }
	            else {
	                //this._mapService.view['gestureManager'].inputManager.manager.options.enable = false;
	                var handlers = _this._mapService.view["inputManager"]._handlers;
	                for (var i = 0; i < handlers.length; i++) {
	                    handlers[i].active = false;
	                }
	            }
	        });
	        this.polygonDrawMoveHandler = on(this._mapService.view.container, "mousemove", function (evt) {
	            if (drawStart) {
	                _this._mapService.tempSelGraphics.graphics.removeAll();
	                var paths = [];
	                paths[0] = rings[rings.length - 1];
	                //Get screen point from evt
	                var screenPoint = new ScreenPoint();
	                screenPoint.x = evt.x + xOffset;
	                screenPoint.y = evt.y + yOffset;
	                var nextPoint = new Point();
	                _this._mapService.view.toMap(screenPoint, nextPoint);
	                paths[1] = [nextPoint.x, nextPoint.y];
	                // Update the graphic in the graphics layer
	                currentGraphic = new Graphic({
	                    geometry: new Polyline({
	                        paths: paths,
	                        spatialReference: _this._mapService.view.spatialReference
	                    }),
	                    symbol: lineSymbol
	                });
	                _this._mapService.tempSelGraphics.graphics.add(currentGraphic);
	            }
	        });
	        this.polygonDrawDoubleClickHandler = on(this._mapService.view.container, "dblclick", function (evt) {
	            if (rings.length < 3) {
	                _this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to start drawing" });
	                return;
	            }
	            if (rings.length < 4) {
	                _this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to continue drawing" });
	                return;
	            }
	            //this._eventsService.multipleSelectComplete(new Polygon({rings:tempPolygonRings, spatialReference: this._mapService.view.spatialReference}));
	            rings = new Array();
	            tempPolygonRings = new Array();
	            drawStart = null;
	            var suggestion = {
	                FullAddress: "Custom Polygon",
	                FullName: "Custom Polygon",
	                Geometry: _this._mapService.tempSelPlgGraphics.graphics.getItemAt(0).geometry,
	                SuggestionType: "DrawPolygon"
	            };
	            //Emit event to set selected geometry
	            var pickedGeometry = { addressSuggestion: suggestion, addressLocation: suggestion["Geometry"] };
	            _this._eventsService.changeNav(pickedGeometry);
	            _this._mapService.view.extent = _this._mapService.tempSelPlgGraphics.graphics.getItemAt(0).geometry.extent;
	            _this._mapService.tempSelPlgGraphics.graphics.removeAll();
	            _this._mapService.selGraphics.graphics.removeAll();
	            _this._mapService.tempSelGraphics.graphics.removeAll();
	            // Enable default events
	            //this._mapService.view['gestureManager'].inputManager.manager.options.enable = true;
	            var handlers = _this._mapService.view["inputManager"]._handlers;
	            for (var i = 0; i < handlers.length; i++) {
	                handlers[i].active = true;
	            }
	            _this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to start drawing" });
	        });
	    };
	    NavToolsComponent.prototype.NEWFreeHandPolygonToolActivate = function () {
	        var _this = this;
	        this._eventsService.showMapTooltip({ "show": true, "tooltip": "Press down to start and let go to finish" });
	        this.freeHandToolListActive = true;
	        if (this.showFreeHandInstructions == true) {
	            var dataSnack = {
	                message: this.freeHandInstructions,
	                timeout: 15000,
	                actionHandler: function (e) {
	                    _this.hideSnackBar();
	                    _this.showFreeHandInstructions = false;
	                },
	                actionText: "Hide"
	            };
	            this.showSnackBar(dataSnack);
	        }
	        var paths = [];
	        var currentGraphic;
	        var lineSymbol = new SimpleLineSymbol();
	        lineSymbol.color = new Color([255, 0, 0]);
	        lineSymbol.width = 1;
	        this.mapPointerDownSubscription = this._eventsService.mapPointerDown$.subscribe(function (mdevt) {
	            _this._mapService.selGraphics.removeAll();
	            mdevt.stopPropagation();
	            var point = _this._mapService.view.toMap(new ScreenPoint({
	                x: mdevt.x,
	                y: mdevt.y
	            }));
	            paths.push([point.x, point.y]);
	            _this.mapDragSubscription = _this._eventsService.mapDrag$.subscribe(function (devt) {
	                _this._mapService.selGraphics.removeAll();
	                devt.stopPropagation();
	                var dragPoint = _this._mapService.view.toMap(new ScreenPoint({
	                    x: devt.x,
	                    y: devt.y
	                }));
	                paths.push([dragPoint.x, dragPoint.y]);
	                currentGraphic = new Graphic({
	                    geometry: new Polyline({
	                        paths: paths,
	                        spatialReference: _this._mapService.view.spatialReference
	                    }),
	                    symbol: lineSymbol
	                });
	                _this._mapService.selGraphics.graphics.add(currentGraphic);
	            });
	            _this.mapPointerUpSubscription = _this._eventsService.mapPointerUp$.subscribe(function (muevt) {
	                var endPoint = _this._mapService.view.toMap(new ScreenPoint({
	                    x: muevt.x,
	                    y: muevt.y
	                }));
	                paths.push([endPoint.x, endPoint.y]);
	                paths.push([point.x, point.y]);
	                var polygon = new Polygon({
	                    rings: paths,
	                    spatialReference: _this._mapService.view.spatialReference
	                });
	                var suggestion = {
	                    FullAddress: "Custom Polygon",
	                    FullName: "Custom Polygon",
	                    Geometry: polygon,
	                    SuggestionType: "FreeHandPolygon"
	                };
	                //Emit event to set selected geometry
	                var pickedGeometry = { addressSuggestion: suggestion, addressLocation: suggestion["Geometry"] };
	                _this._eventsService.changeNav(pickedGeometry);
	                _this._mapService.view.extent = polygon.extent;
	                _this._mapService.selGraphics.graphics.removeAll();
	                _this.mapDragSubscription.unsubscribe();
	                _this.mapPointerUpSubscription.unsubscribe();
	                _this.mapPointerDownSubscription.unsubscribe();
	                var mapNavToolEls = document.getElementsByName("mapToolActive");
	                for (var k = 0; k < mapNavToolEls.length; k++) {
	                    if (mapNavToolEls[k].checked == true && mapNavToolEls[k].id == "free-hand-draw-icon") {
	                        mapNavToolEls[k].click();
	                    }
	                }
	            });
	        });
	    };
	    NavToolsComponent.prototype.NEWFreeHandPolygonToolDeactivate = function () {
	        this.mapPointerDownSubscription.unsubscribe();
	        if (this.mapDragSubscription) {
	            this.mapDragSubscription.unsubscribe();
	        }
	        this.mapPointerUpSubscription ? this.mapPointerUpSubscription.unsubscribe() : null;
	        this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	        this.freeHandToolListActive = false;
	    };
	    NavToolsComponent.prototype.NEWdrawPolygonToolActivate = function () {
	        var _this = this;
	        this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to start drawing" });
	        this.drawPolygonToolListActive = true;
	        if (this.showDrawPolygonInstructions == true) {
	            var dataSnack = {
	                message: this.drawPolygonInstructions,
	                timeout: 15000,
	                actionHandler: function (e) {
	                    _this.hideSnackBar();
	                    _this.showDrawPolygonInstructions = false;
	                },
	                actionText: "Hide"
	            };
	            this.showSnackBar(dataSnack);
	        }
	        var rings = [];
	        var currentGraphic;
	        var lineSymbol = new SimpleLineSymbol();
	        lineSymbol.color = new Color([255, 0, 0]);
	        lineSymbol.width = 1;
	        this.mapPointerUpSubscription = this._eventsService.mapPointerUp$.subscribe(function (muevt) {
	            //this._mapService.selGraphics.removeAll();
	            muevt.stopPropagation();
	            _this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to continue drawing" });
	            var point = _this._mapService.view.toMap(new ScreenPoint({
	                x: muevt.x,
	                y: muevt.y
	            }));
	            rings.push([point.x, point.y]);
	            _this._mapService.selGraphics.add(new Graphic({
	                geometry: new Polyline({
	                    paths: rings,
	                    spatialReference: _this._mapService.view.spatialReference
	                }),
	                symbol: lineSymbol
	            }));
	            if (rings.length < 2) {
	                _this.mapPointerMoveSubscription = _this._eventsService.mapPointerMove$.subscribe(function (mmevt) {
	                    mmevt.stopPropagation();
	                    _this._mapService.tempSelGraphics.removeAll();
	                    var mmPoint = _this._mapService.view.toMap(new ScreenPoint({
	                        x: mmevt.x,
	                        y: mmevt.y
	                    }));
	                    var paths = [];
	                    paths[0] = rings[rings.length - 1];
	                    paths[1] = [mmPoint.x, mmPoint.y];
	                    currentGraphic = new Graphic({
	                        geometry: new Polyline({
	                            paths: paths,
	                            spatialReference: _this._mapService.view.spatialReference
	                        }),
	                        symbol: lineSymbol
	                    });
	                    _this._mapService.tempSelGraphics.add(currentGraphic);
	                });
	                _this.mapDoubleClickSubscription = _this._eventsService.mapDoubleClick$.subscribe(function (mdcevt) {
	                    mdcevt.stopPropagation();
	                    if (rings.length >= 2) {
	                        _this.mapPointerUpSubscription.unsubscribe();
	                        _this.mapPointerMoveSubscription.unsubscribe();
	                        _this.mapDoubleClickSubscription.unsubscribe();
	                        rings.push([mdcevt.mapPoint.x, mdcevt.mapPoint.y]);
	                        rings.push(rings[0]);
	                        // Create the polygon and simplify
	                        var polygon = new Polygon({
	                            rings: rings,
	                            spatialReference: _this._mapService.view.spatialReference
	                        });
	                        var suggestion = {
	                            FullAddress: "Custom Polygon",
	                            FullName: "Custom Polygon",
	                            Geometry: polygon,
	                            SuggestionType: "DrawPolygon"
	                        };
	                        //Emit event to set selected geometry
	                        var pickedGeometry = { addressSuggestion: suggestion, addressLocation: suggestion["Geometry"] };
	                        _this._eventsService.changeNav(pickedGeometry);
	                        _this._mapService.view.extent = polygon.extent;
	                        _this._mapService.selGraphics.graphics.removeAll();
	                        _this._mapService.tempSelGraphics.graphics.removeAll();
	                        var mapNavToolEls = document.getElementsByName("mapToolActive");
	                        for (var k = 0; k < mapNavToolEls.length; k++) {
	                            if (mapNavToolEls[k].checked == true && mapNavToolEls[k].id == "polygon-draw-icon") {
	                                mapNavToolEls[k].click();
	                            }
	                        }
	                    }
	                });
	            }
	            else {
	                _this._eventsService.showMapTooltip({ "show": true, "tooltip": "Click to continue drawing. Double-click to complete." });
	            }
	        });
	    };
	    NavToolsComponent.prototype.NEWdrawPolygonToolDeactivate = function () {
	        this.mapPointerMoveSubscription ? this.mapPointerMoveSubscription.unsubscribe() : null;
	        if (this.mapDoubleClickSubscription) {
	            this.mapDoubleClickSubscription.unsubscribe();
	        }
	        this.mapPointerUpSubscription ? this.mapPointerUpSubscription.unsubscribe() : null;
	        this._eventsService.showMapTooltip({ "show": false, "tooltip": "" });
	        this.drawPolygonToolListActive = false;
	    };
	    return NavToolsComponent;
	}());
	__decorate([
	    core_1.ViewChild('addressSearchIcon'),
	    __metadata("design:type", core_1.ElementRef)
	], NavToolsComponent.prototype, "addressSearchIcon", void 0);
	__decorate([
	    core_1.ViewChild('obliqueIcon'),
	    __metadata("design:type", core_1.ElementRef)
	], NavToolsComponent.prototype, "obliqueIcon", void 0);
	NavToolsComponent = __decorate([
	    core_1.Component({
	        selector: 'navTools-component',
	        template: __webpack_require__(90),
	        styles: [__webpack_require__(91)]
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, map_service_1.MapService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService])
	], NavToolsComponent);
	exports.NavToolsComponent = NavToolsComponent;


/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_86__;

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_87__;

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_88__;

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_89__;

/***/ },
/* 90 */
/***/ function(module, exports) {

	module.exports = "<!--<div style=\"padding-top: 0px; padding-bottom: 0px;\" class=\"mdl-textfield mdl-js-textfield mdl-textfield--expandable\">\r\n    <label class=\"mdl-button mdl-js-button mdl-button--icon\" style=\"top: 0px;\" for=\"sample-expandable\">\r\n        <i class=\"material-icons\" style=\"top: 14px;\">search</i>\r\n    </label>\r\n    <div class=\"mdl-textfield__expandable-holder\">\r\n        <input class=\"mdl-textfield__input\" type=\"text\" id=\"sample-expandable\">\r\n        <label class=\"mdl-textfield__label\" style=\"color:red; height:24px; left:2px; top:0px;\" for=\"sample-expandable\">Enter an address, parcel #, an intersection, or a neighborhood name</label>\r\n    </div>\r\n</div>-->\r\n\r\n<!--<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect toolbar-items\" [ngClass]=\"{'toolbar-items-extend': extendToolbar}\" id=\"pan-label\" for=\"pan-icon\">\r\n    <input type=\"checkbox\" id=\"pan-icon\" class=\"mdl-icon-toggle__input\" name=\"mapToolActive\" value=\"Pan\" (click)=\"selectMapNavTool($event)\">\r\n    <i class=\"mdl-icon-toggle__label material-icons\">pan_tool</i>\r\n    <div class=\"mdl-tooltip mdl-tooltip--large\" for=\"pan-label\">\r\n        Pan\r\n    </div>\r\n</label>-->\r\n<!--<label class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect toolbar-items\" [ngClass]=\"{'toolbar-items-extend': extendToolbar}\" id=\"full-extent-label\" for=\"full-extent-icon\" (click)=\"fullExtent()\">\r\n    <i class=\"material-icons\">zoom_out_map</i>\r\n    <div class=\"mdl-tooltip mdl-tooltip--large\" for=\"full-extent-label\">\r\n        Full Extent\r\n    </div>\r\n</label>-->\r\n\r\n<!--<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect\" id=\"zoom-out-label\" for=\"zoom-out-icon\">\r\n    <input type=\"checkbox\" id=\"zoom-out-icon\" class=\"mdl-icon-toggle__input\" name=\"mapToolActive\" value=\"Zoom Out\" (click)=\"selectMapNavTool($event)\">\r\n    <i class=\"mdl-icon-toggle__label material-icons\">zoom_out</i>\r\n    <div class=\"mdl-tooltip mdl-tooltip--large\" for=\"zoom-out-label\">\r\n        Zoom Out\r\n    </div>\r\n</label>-->\r\n\r\n\r\n<!--<span class=\"toolbar-items\" [ngClass]=\"{'toolbar-items-extend': extendToolbar}\">Search tools:</span>-->\r\n\r\n<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect toolbar-items\" [ngClass]=\"{'toolbar-items-extend': extendToolbar}\" id=\"address-search-label\" for=\"address-search-icon\" title=\"Search\">\r\n    <input type=\"checkbox\" id=\"address-search-icon\" #addressSearchIcon class=\"mdl-icon-toggle__input\" name=\"mapToolActive\" value=\"Address Search\" (click)=\"selectAddressSearchTool($event)\" checked>\r\n    <i class=\"mdl-icon-toggle__label material-icons\">search</i>\r\n    <!--<div class=\"mdl-tooltip mdl-tooltip--large\" for=\"address-search-label\">\r\n        Search\r\n    </div>-->\r\n</label>\r\n\r\n<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect toolbar-items\" [ngClass]=\"{'toolbar-items-extend': extendToolbar, 'toolBar_item_label_select': identifyToolListActive}\" id=\"identify-label\" for=\"identify-icon\" title=\"Identify\">\r\n    <input type=\"checkbox\" id=\"identify-icon\" class=\"mdl-icon-toggle__input\" name=\"mapToolActive\" value=\"Identify\" (click)=\"selectMapNavTool($event.currentTarget)\">\r\n    <i class=\"mdl-icon-toggle__label material-icons\">info</i>\r\n    <!--<div class=\"mdl-tooltip mdl-tooltip--large\" for=\"identify-label\">\r\n        Identify\r\n    </div>-->\r\n</label>\r\n<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect toolbar-items toolBar_item_label_display\" [ngClass]=\"{'toolbar-items-extend': extendToolbar, 'toolBar_item_label_select': obliqueToolListActive}\" id=\"oblique-label\" for=\"obliqueIcon\">\r\n    <input type=\"checkbox\" id=\"obliqueIcon\" #obliqueIcon class=\"mdl-icon-toggle__input\" name=\"mapToolActive\" value=\"Oblique Imagery\" (click)=\"selectMapNavTool($event.currentTarget)\">\r\n    <i class=\"mdl-icon-toggle__label material-icons\">photo</i>\r\n    <!--<div class=\"mdl-tooltip mdl-tooltip--large\" for=\"oblique-label\">\r\n        Oblique Imagery\r\n    </div>-->\r\n</label>\r\n<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect toolbar-items toolBar_item_label_display\" [ngClass]=\"{'toolbar-items-extend': extendToolbar, toolBar_item_label_select: freeHandToolListActive}\" id=\"free-hand-draw-label\" for=\"free-hand-draw-icon\">\r\n    <input type=\"checkbox\" id=\"free-hand-draw-icon\" class=\"mdl-icon-toggle__input\" name=\"mapToolActive\" value=\"Free Hand Draw\" (click)=\"selectMapNavTool($event.currentTarget)\">\r\n    <i class=\"mdl-icon-toggle__label material-icons\">mode_edit</i>\r\n    <!--<div class=\"mdl-tooltip mdl-tooltip--large\" for=\"free-hand-draw-label\">\r\n        Free Hand Draw Tool\r\n    </div>-->\r\n</label>\r\n<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect toolbar-items toolBar_item_label_display\" [ngClass]=\"{'toolbar-items-extend': extendToolbar, toolBar_item_label_select: drawPolygonToolListActive}\" id=\"polygon-draw-label\" for=\"polygon-draw-icon\">\r\n    <input type=\"checkbox\" id=\"polygon-draw-icon\" class=\"mdl-icon-toggle__input\" (click)=\"selectMapNavTool($event.currentTarget)\" name=\"mapToolActive\" value=\"Polygon Draw Tool\">\r\n    <i class=\"mdl-icon-toggle__label material-icons\">edit_location</i>\r\n    <!--<div class=\"mdl-tooltip mdl-tooltip--large\" for=\"polygon-draw-label\">\r\n        Polygon Draw Tool\r\n    </div>-->\r\n</label>\r\n\r\n<button id=\"tool-options\"\r\n        class=\"mdl-button mdl-js-button mdl-button--icon toolbar-items\" [ngClass]=\"{'toolbar-items-extend': extendToolbar}\" title=\"Tools\">\r\n    <!--<span style=\"color:white\">Tools</span>\r\n    <i class=\"material-icons\">arrow_drop_down</i>-->\r\n    <i class=\"material-icons\">more_vert</i>\r\n</button>\r\n<ul class=\"mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect\"\r\n    data-mdl-for=\"tool-options\">\r\n    <!-- <li class=\"mdl-menu__item\" (click)=\"selectToolFromList('Identify')\">\r\n        <label class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\" name=\"mapToolActiveList\" [ngClass]=\"{selectedMobileToolLabel: identifyToolListActive}\">\r\n            <i class=\"material-icons material-icons_menu_list\">info</i>\r\n        </label>\r\n        <span class=\"menu-list-item-content\">Identify</span>\r\n    </li> -->\r\n    <li class=\"mdl-menu__item\" (click)=\"selectToolFromList('Oblique Imagery')\">\r\n        <label class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\" name=\"mapToolActiveList\" [ngClass]=\"{selectedMobileToolLabel: obliqueToolListActive}\">\r\n            <i class=\"material-icons material-icons_menu_list\">photo</i>\r\n        </label>\r\n        <span class=\"menu-list-item-content\">Oblique Image</span>\r\n    </li>\r\n    <li class=\"mdl-menu__item\" (click)=\"selectToolFromList('Free Hand Draw')\">\r\n        <label class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\" name=\"mapToolActiveList\" [ngClass]=\"{selectedMobileToolLabel: freeHandToolListActive}\">\r\n            <i class=\"material-icons material-icons_menu_list\">mode_edit</i>\r\n        </label>\r\n        <span class=\"menu-list-item-content\">Free Hand Draw</span>\r\n    </li>\r\n    <li class=\"mdl-menu__item\" (click)=\"selectToolFromList('Polygon Draw Tool')\">\r\n        <label class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\" name=\"mapToolActiveList\" [ngClass]=\"{selectedMobileToolLabel: drawPolygonToolListActive}\">\r\n            <i class=\"material-icons material-icons_menu_list\">edit_location</i>\r\n        </label>\r\n        <span class=\"menu-list-item-content\">Draw Polygon</span>\r\n    </li>\r\n</ul>\r\n\r\n\r\n<!--<label class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\" id=\"extend-toolbar-label\" for=\"full-extent-icon\" (click)=\"expandToolbarFunction()\">\r\n    <span class=\"esri-icon-expand\" [ngClass]=\"{'esri-icon-collapse': extendToolbar}\" aria-label=\"show toolbar\" style=\"position: relative; top:3px;\"></span>\r\n</label>-->\r\n\r\n<!-- Deletable Chip -->\r\n<!--<span class=\"mdl-chip mdl-chip--deletable\">\r\n    <span class=\"mdl-chip__text\">Deletable Chip</span>\r\n    <button type=\"button\" class=\"mdl-chip__action\"><i class=\"material-icons\">cancel</i></button>\r\n</span>-->\r\n\r\n\r\n\r\n";

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports = ".mdl-icon-toggle.is-checked .mdl-icon-toggle__label { \r\n    color:#FFFFFF; \r\n    background-color:red; \r\n}\r\n\r\n.mdl-icon-toggle__label {\r\n    color:#A2A0A0\r\n}\r\n\r\n.mdl-button .material-icons {\r\n    color:#A2A0A0\r\n}\r\n\r\n.material-icons_menu_list{\r\n    color:black !important;\r\n}\r\n\r\n@media only screen and (min-width: 500px) {\r\n    #extend-toolbar-label{\r\n        display: none;\r\n    }\r\n\r\n    .toolbar-items{\r\n        display: inline-block;\r\n    }\r\n}\r\n\r\n/*@media only screen and (max-width: 500px) {\r\n    .toolbar-items{\r\n        display: none;\r\n    }\r\n}*/\r\n\r\n.toolbar-items-extend{\r\n    display: inline-block;\r\n}\r\n\r\n.toolbar-items-collapsed{\r\n    display: none !important;\r\n}\r\n\r\n.selectedMobileToolLabel{\r\n    background-color:red; \r\n}\r\n\r\n.selectedMobileToolLabel > .material-icons {\r\n    color: white !important;\r\n}\r\n\r\n.toolBar_item_label_display{\r\n    display: none;\r\n}\r\n\r\n.toolBar_item_label_select{\r\n    display: inline-block;\r\n}"

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var forms_1 = __webpack_require__(27);
	var config_1 = __webpack_require__(60);
	var map_service_1 = __webpack_require__(62);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var Observable_1 = __webpack_require__(6);
	var addressLocator_service_1 = __webpack_require__(93);
	var http_1 = __webpack_require__(25);
	var AddressLocatorComponent = (function () {
	    function AddressLocatorComponent(elRef, locationService, _eventsService, _esriTasksService, _mapService, http, jsonp) {
	        this.elRef = elRef;
	        this.locationService = locationService;
	        this._eventsService = _eventsService;
	        this._esriTasksService = _esriTasksService;
	        this._mapService = _mapService;
	        this.http = http;
	        this.jsonp = jsonp;
	        this.appSettings = null;
	        this.searchInProgress = false;
	        this.inputWidth = "";
	        this.inputPlaceHolderText = "Enter an address, parcel #, an intersection, or neighborhood name here...";
	        this.addressLocationOutput = new core_1.EventEmitter();
	        this.addressSuggestionsOutput = new core_1.EventEmitter();
	        this.values = '';
	        this.term = new forms_1.FormControl();
	        this.ignoreTextChange = false;
	        this.placeHolderText = "Type an address or intersection";
	        this.enableFallback = false;
	        this.fallbackRun = false;
	        this.dialogShow = false;
	        this.validRangesHeader = "";
	        this.oneSuggStreet = false;
	        this.neighborhoodsList = [];
	        this.parsedAddress = new Object;
	        this.jsonpCallback = "";
	        this.searchType = "";
	        this.locateServiceURL = "";
	        this.concatenators = [];
	        if (this.appSettings == null) {
	            this.appSettings = config_1.Config.config[0];
	        }
	    }
	    AddressLocatorComponent.prototype.ngOnInit = function () {
	        // create the map
	        //this._mapService.createMap(this.itemId, this.elRef.nativeElement.firstChild, this.options).then((response) => {
	        //  // get a reference to teh map and expose response to app
	        //  this.map = response.map;
	        //  this.mapLoaded.next(response);
	        //});
	        var _this = this;
	        this.term.valueChanges
	            .debounceTime(400)
	            .switchMap(function (term) { return _this.turnOnInProgress(term); })
	            .subscribe(function (suggestions) { return _this.suggestionsReceived(suggestions); }); //, err => this.handleError(err));
	        // this.locationService.navItem$.subscribe(item => 
	        //     item ? this.searchInProgress = true : this.searchInProgress = false
	        // );
	        this._esriTasksService.queryFeatures(this.appSettings["AddressLocator"]["neighborhoodsMapService"], null, "1=1", ["NAME"], false, null).then(function (results) {
	            results.features.forEach(function (element) {
	                _this.neighborhoodsList.push(element.attributes["NAME"]);
	            });
	        });
	        this.locateServiceURL = this.appSettings["AddressLocator"]["serviceUrl"];
	        this.concatenators = this.appSettings["AddressLocator"]["concatenators"];
	        this.jsonpCallback = this.appSettings["AddressLocator"]["jsonpCallback"];
	    };
	    AddressLocatorComponent.prototype.turnOnInProgress = function (term) {
	        //check if this is a parcel number
	        if (term.length == 7 && !isNaN(parseInt(term))) {
	            this.queryForParcelNumber(term);
	            return [];
	        }
	        //check if this is a neighborhood name
	        if (this.neighborhoodsList.some(function (element, index, array) {
	            return element.toUpperCase() == term.toUpperCase();
	        })) {
	            this.suggestions = [];
	            var neighbName = this.neighborhoodsList.find(function (x) { return x.toUpperCase() == term.toUpperCase(); });
	            this.suggestions.push({ "FullAddress": term.toUpperCase(), "FullName": neighbName, "SuggestionType": "Neighborhood" });
	            return [];
	        }
	        //Clear suggestions if this is either parcel or neighborhood
	        if (this.suggestions) {
	            if (this.suggestions.length > 0 && (this.suggestions[0]["SuggestionType"] == "ParcelNumber" || this.suggestions[0]["SuggestionType"] == "Neighborhood")) {
	                this.suggestions = [];
	            }
	        }
	        //(Might not be needed) clear suggestions
	        if (this.ignoreTextChange == false) {
	            this.searchInProgress = true;
	            //return this.locationService.getAddressSuggestions(term);
	            return this.getAddressSuggestions(term);
	        }
	        else {
	            return [];
	        }
	    };
	    AddressLocatorComponent.prototype.getAddressSuggestions = function (typedAddress) {
	        var _this = this;
	        if (!typedAddress) {
	            this.searchInProgress = false;
	            return new Array();
	        }
	        var urlAddress = this.constructURL(typedAddress);
	        // return this.jsonp.get(urlAddress + "?method=JSONP_CALLBACK")
	        //     .toPromise()
	        //     .then(
	        //         (response) => response.json()
	        //     ).catch(this.handleError);
	        if (urlAddress != "") {
	            this.searchInProgress = true;
	            return this.jsonp.get(urlAddress + this.jsonpCallback)
	                .map(function (response) {
	                var suggestionsArray = response.json();
	                for (var _i = 0, suggestionsArray_1 = suggestionsArray; _i < suggestionsArray_1.length; _i++) {
	                    var sug = suggestionsArray_1[_i];
	                    sug["SuggestionType"] = _this.searchType;
	                }
	                return suggestionsArray;
	            }).catch(this.handleObservableError);
	        }
	        this.searchInProgress = false;
	        return new Array();
	    };
	    AddressLocatorComponent.prototype.handleObservableError = function (error) {
	        return Observable_1.Observable.of([]);
	    };
	    AddressLocatorComponent.prototype.handleError = function (error) {
	        console.error('An error occurred', error);
	        return Promise.reject(error.message || error);
	    };
	    AddressLocatorComponent.prototype.constructURL = function (typedAddress) {
	        var url = "";
	        this.parsedAddress = new Object();
	        var parsedAddressArray = [typedAddress.substring(0, typedAddress.indexOf(" ")), typedAddress.substring(typedAddress.indexOf(" "))];
	        if (Number(parsedAddressArray[0])) {
	            this.parsedAddress["streetNumber"] = parsedAddressArray[0];
	            if (parsedAddressArray[1] != " ") {
	                parsedAddressArray[1] = parsedAddressArray[1].replace(/[ ]+/g, " ").trim();
	            }
	            this.parsedAddress["streetName"] = parsedAddressArray[1];
	            if (this.searchType == "Streets") {
	                this.parsedAddress["type"] = "Streets";
	                url = this.locateServiceURL + "StreetAddresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1];
	                return url;
	            }
	            this.parsedAddress["type"] = "Address";
	            url = this.locateServiceURL + "Addresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1] + "/true/true/true";
	            this.searchType = "Address";
	            return url;
	        }
	        for (var _i = 0, _a = this.concatenators; _i < _a.length; _i++) {
	            var conc = _a[_i];
	            if (typedAddress.toLowerCase().indexOf(" " + conc.toLowerCase() + " ") != -1 && typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ").length > 1 && typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ").indexOf("") == -1) {
	                var intersections = typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ");
	                url = this.locateServiceURL + "Intersections/" + intersections[0] + "/" + intersections[1] + "/" + conc.toLowerCase();
	                this.searchType = "Intersection";
	                return url;
	            }
	        }
	        return url;
	    };
	    AddressLocatorComponent.prototype.emptySuggestionsFallback = function () {
	        if (this.enableFallback == true) {
	            //this.locationService.searchType = "Streets";
	            this.searchType = "Streets";
	            this.fallbackRun = true;
	            this.term.setValue(this.searchinput.nativeElement.value);
	        }
	        else {
	            return;
	        }
	    };
	    // destroy map
	    AddressLocatorComponent.prototype.ngOnDestroy = function () {
	    };
	    AddressLocatorComponent.prototype.onKey = function (event) {
	        this.ignoreTextChange = false;
	        if (this.searchinput.nativeElement.value == "") {
	            this.suggestions = [];
	            this.searchInProgress = false;
	        }
	        if (event.keyCode == 13) {
	            this.enableFallback = true;
	            this.term.setValue(this.searchinput.nativeElement.value);
	        }
	        else if (event.keyCode == 27) {
	            this.suggestions = [];
	            this.searchInProgress = false;
	            this.fallbackRun = false;
	            this.searchinput.nativeElement.value = "";
	        }
	        else {
	            this.fallbackRun = false;
	        }
	        // setTimeout(() => {
	        //     if(this.typedAddress.length > 3 && this.locationService.constructURL(this.typedAddress) != ""){
	        // this.searchInProgress = true;
	        // this.locationService
	        //     .getAddressSuggestions(this.typedAddress)
	        //     .subscribe(suggestions => 
	        //         this.suggestionsReceived(suggestions))
	        //.catch(error => this.error = error); // TODO: Display error message
	        //     }else{
	        //         this.suggestions = [];
	        //     }
	        // }, 700);
	    };
	    AddressLocatorComponent.prototype.onKeyDown = function (event) {
	        this.fallbackRun = false;
	    };
	    AddressLocatorComponent.prototype.suggestionsReceived = function (suggestions) {
	        this.searchInProgress = false;
	        this.suggestions = [];
	        if (suggestions.length == 0) {
	            if (this.enableFallback == true) {
	                this.emptySuggestionsFallback();
	            }
	            else if (this.fallbackRun == true) {
	                this.findStreetRanges();
	                //this.locationService.searchType = "";
	                this.searchType = "";
	                this.fallbackRun = false;
	            }
	            this.enableFallback = false;
	            return;
	        }
	        else {
	            this.enableFallback = false;
	        }
	        suggestions.sort(function (n1, n2) {
	            if (n1["Level"] > n2["Level"]) {
	                return -1;
	            }
	            if (n1["Level"] < n2["Level"]) {
	                return 1;
	            }
	            return 0;
	        });
	        for (var _i = 0, suggestions_1 = suggestions; _i < suggestions_1.length; _i++) {
	            var suggestion = suggestions_1[_i];
	            if (this.weedoutDuplicateSuggestions(suggestion) == false) {
	                suggestion = this.constructFullAddress(suggestion);
	                this.suggestions.push(suggestion);
	            }
	        }
	        this.suggestions.sort(function (n1, n2) {
	            if (n1["FullAddress"] > n2["FullAddress"]) {
	                return 1;
	            }
	            if (n1["FullAddress"] < n2["FullAddress"]) {
	                return -1;
	            }
	            return 0;
	        });
	        this.locationService.searchType = "";
	        //emit event that suggestions were received
	        this.addressSuggestionsOutput.next(suggestions);
	    };
	    AddressLocatorComponent.prototype.queryForParcelNumber = function (parcelNumber) {
	        var _this = this;
	        this.searchInProgress = true;
	        this._esriTasksService.queryFeatures(this.appSettings["AddressLocator"]["parcelsMapService"], null, ("PARCEL_C = '" + parcelNumber + "'"), ["PARCEL_C", "STNUMBER", "PRE_DIR", "FULL_STNAME", "CITY", "STATE", "ZIPCODE"], true, null).then(function (results) {
	            _this.suggestions = [];
	            var parcelAttrs = results.features[0].attributes;
	            var fullAddress = parcelAttrs["STNUMBER"] + " " + parcelAttrs["PRE_DIR"] + " " + parcelAttrs["FULL_STNAME"] + " " + parcelAttrs["CITY"] + ", " + parcelAttrs["STATE"] + " " + parcelAttrs["ZIPCODE"];
	            _this.suggestions.push({ "FullAddress": parcelNumber, "SuggestionType": "ParcelNumber", "FullName": parcelNumber, "ShowAddress": fullAddress, "Geometry": results.features[0].geometry });
	            _this.searchInProgress = false;
	        });
	    };
	    AddressLocatorComponent.prototype.constructFullAddress = function (suggestion) {
	        if (suggestion["SuggestionType"] == "Streets") {
	            //var num = this.locationService.parsedAddress["streetNumber"];
	            var num = this.parsedAddress["streetNumber"];
	            var zip;
	            var city;
	            if (suggestion["FromLeft"] % 2 == num % 2 && suggestion["FromLeft"] <= num && suggestion["FromLeft"] >= num) {
	                city = suggestion["LeftCity"];
	                zip = suggestion["LeftZip"];
	            }
	            else {
	                city = suggestion["RightCity"];
	                zip = suggestion["RightZip"];
	            }
	            suggestion["FullAddress"] = num + " " + suggestion["FullName"] + ", " + city;
	            suggestion["StreetNumber"] = num;
	            suggestion["FullName"] = num + " " + suggestion["FullName"];
	            suggestion["Zip"] = zip;
	            suggestion["City"] = city;
	        }
	        else if (suggestion["SuggestionType"] == "Address") {
	            if (suggestion["Unit"]) {
	                suggestion["FullAddress"] = suggestion["FullName"] + (suggestion["Unit"] == "" ? "" : " #" + suggestion["Unit"]) + ", " + suggestion["City"];
	            }
	            else {
	                suggestion["FullAddress"] = suggestion["FullName"] + ", " + suggestion["City"];
	            }
	            suggestion["StreetNumber"] = suggestion["HouseNum"];
	        }
	        else {
	            suggestion["FullAddress"] = suggestion["FullName"] + ", " + suggestion["City"];
	        }
	        return suggestion;
	    };
	    AddressLocatorComponent.prototype.weedoutDuplicateSuggestions = function (suggestion) {
	        for (var _i = 0, _a = this.suggestions; _i < _a.length; _i++) {
	            var sug = _a[_i];
	            if (sug["FullName"] + " #" + sug["Unit"] == suggestion["FullName"] + " #" + suggestion["Unit"]) {
	                return true;
	            }
	        }
	        return false;
	    };
	    AddressLocatorComponent.prototype.findStreetRanges = function () {
	        var _this = this;
	        this.locationService
	            .getStreetRanges()
	            .then(function (addressRanges) {
	            return _this.processStreetRanges(addressRanges);
	        })
	            .catch(function (error) { return _this.error = error; }); // TODO: Display error message
	    };
	    AddressLocatorComponent.prototype.processStreetRanges = function (addressRanges) {
	        //Create some variables
	        var ranges = new Array();
	        var rangesObjArray = new Array();
	        //Flag if this is only one street
	        var _suggStreets = new Array();
	        for (var _i = 0, addressRanges_1 = addressRanges; _i < addressRanges_1.length; _i++) {
	            var street = addressRanges_1[_i];
	            //Get street & address ranges
	            var stname = street.FullName;
	            var lf = street.FromLeft;
	            var lt = street.ToLeft;
	            var rf = street.FromRight;
	            var rt = street.ToRight;
	            var min = Math.min(lf, lt, rf, rt);
	            var max = Math.max(lf, lt, rf, rt);
	            //See if this street already is in my list
	            var range = null;
	            for (var zz = 0; zz < ranges.length; zz++) {
	                if (ranges[zz].name == stname) {
	                    range = ranges[zz];
	                    break;
	                }
	            }
	            //Add range
	            if (range == null) {
	                //Create new street and add it to the list
	                range = { name: stname, min: min, max: max };
	                ranges.push(range);
	                _suggStreets.push(stname);
	            }
	            else {
	                //Update street range
	                if (min < range.min) {
	                    range.min = min;
	                }
	                if (max > range.max) {
	                    range.max = max;
	                }
	            }
	            //**Get the min max objects**///
	            rangesObjArray.push({ "name": stname, "min": min, "max": max });
	        }
	        if (_suggStreets.length == 1) {
	            //var sortedRanges = rangesObjArray.sortOn("min", Array.NUMERIC);
	            var sortedRanges = rangesObjArray.sort(function (obj1, obj2) {
	                return obj1.min - obj2.min;
	            });
	            var finalRanges = [{ "name": sortedRanges[0].name, "min": sortedRanges[0].min, "max": sortedRanges[0].max }];
	            for (var sr = 1; sr < sortedRanges.length; sr++) {
	                if (sortedRanges[sr].min - sortedRanges[sr - 1].max > 99) {
	                    finalRanges.push(sortedRanges[sr]);
	                }
	                else {
	                    finalRanges[(finalRanges.length - 1)]["max"] = sortedRanges[sr].max;
	                }
	            }
	            ranges = finalRanges;
	            this.validRangesHeader = "Valid address ranges for " + sortedRanges[0].name + " are:";
	            this.oneSuggStreet = true;
	        }
	        else {
	            this.oneSuggStreet = false;
	            this.validRangesHeader = "Valid address ranges are:";
	        }
	        if (addressRanges.length == 0) {
	            this.validRangesHeader = "The address you entered could not be found within Marion County.";
	        }
	        console.log(ranges);
	        this.validStreetRanges = ranges;
	        this.dialogShow = true;
	        this.searchinput.nativeElement.blur();
	    };
	    AddressLocatorComponent.prototype.suggestionClicked = function (suggestion) {
	        var _this = this;
	        this.searchInProgress = true;
	        this.pickedAddress = suggestion;
	        switch (suggestion["SuggestionType"]) {
	            case "ParcelNumber":
	                this.parcelOrNeighbPicked(suggestion);
	                break;
	            case "Address":
	                this.locationService
	                    .getAddressLocation(suggestion)
	                    .then(function (addressLocation) {
	                    return _this.addressLocationPicked(addressLocation);
	                })
	                    .catch(function (error) { return _this.error = error; }); // TODO: Display error message
	                break;
	            case "Streets":
	                this.locationService
	                    .getAddressLocation(suggestion)
	                    .then(function (addressLocation) {
	                    return _this.addressLocationPicked(addressLocation);
	                })
	                    .catch(function (error) { return _this.error = error; }); // TODO: Display error message
	                break;
	            case "Intersection":
	                this.locationService
	                    .getAddressLocation(suggestion)
	                    .then(function (addressLocation) {
	                    return _this.addressLocationPicked(addressLocation);
	                })
	                    .catch(function (error) { return _this.error = error; }); // TODO: Display error message
	                break;
	            case "Neighborhood":
	                this._esriTasksService.queryFeatures(this.appSettings["AddressLocator"]["neighborhoodsMapService"], null, "NAME = '" + suggestion["FullName"] + "'", [], true, null).then(function (results) {
	                    suggestion["Geometry"] = results["features"][0]["geometry"];
	                    _this.parcelOrNeighbPicked(suggestion);
	                });
	                break;
	        }
	    };
	    AddressLocatorComponent.prototype.parcelOrNeighbPicked = function (suggestion) {
	        this.ignoreTextChange = true;
	        this.searchInProgress = false;
	        var suggestionToPass = {};
	        for (var prop in suggestion) {
	            if (prop != "Geometry") {
	                suggestionToPass[prop] = suggestion[prop];
	            }
	        }
	        var pickedAddressLocation = { addressSuggestion: suggestionToPass, addressLocation: suggestion["Geometry"] };
	        //this._eventsService.changeNav(pickedAddressLocation);
	        this.addressLocationOutput.next(pickedAddressLocation);
	        this.searchinput.nativeElement.value = this.pickedAddress["FullName"];
	        this.suggestions = new Array();
	    };
	    // private queryFeaturesBasedOnGeometry(){
	    //     this._esriTasksService.queryFeatures
	    // }
	    AddressLocatorComponent.prototype.addressLocationPicked = function (addressLocation) {
	        this.ignoreTextChange = true;
	        this.searchInProgress = false;
	        var pickedAddressLocation = { addressSuggestion: this.pickedAddress, addressLocation: addressLocation[0] };
	        //this._eventsService.changeNav(pickedAddressLocation);
	        this.addressLocationOutput.next(pickedAddressLocation);
	        this.searchinput.nativeElement.value = this.pickedAddress["FullName"];
	        this.suggestions = new Array();
	    };
	    AddressLocatorComponent.prototype.tableRowClick = function (event) {
	        alert("row click");
	    };
	    return AddressLocatorComponent;
	}());
	__decorate([
	    core_1.ViewChild('searchinput'),
	    __metadata("design:type", core_1.ElementRef)
	], AddressLocatorComponent.prototype, "searchinput", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AddressLocatorComponent.prototype, "inputWidth", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AddressLocatorComponent.prototype, "inputPlaceHolderText", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], AddressLocatorComponent.prototype, "addressLocationOutput", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], AddressLocatorComponent.prototype, "addressSuggestionsOutput", void 0);
	AddressLocatorComponent = __decorate([
	    core_1.Component({
	        selector: 'addressLocator-component',
	        template: __webpack_require__(95),
	        styles: [__webpack_require__(96)]
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, addressLocator_service_1.LocationService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService, map_service_1.MapService, http_1.Http, http_1.Jsonp])
	], AddressLocatorComponent);
	exports.AddressLocatorComponent = AddressLocatorComponent;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var http_1 = __webpack_require__(25);
	// import { Http, Response,HTTP_PROVIDERS } from '@angular/http';
	var Observable_1 = __webpack_require__(6);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(74);
	var BehaviorSubject_1 = __webpack_require__(94);
	var config_1 = __webpack_require__(60);
	var LocationService = (function () {
	    function LocationService(http, jsonp) {
	        this.http = http;
	        this.jsonp = jsonp;
	        // Observable navItem source
	        this._navItemSource = new BehaviorSubject_1.BehaviorSubject(0);
	        // Observable navItem stream
	        this.navItem$ = this._navItemSource.asObservable();
	        this.locateServiceURL = "";
	        this.concatenators = ['and', '&', 'at'];
	        this.jsonpCallback = "?method=JSONP_CALLBACK";
	        this.parsedAddress = new Object;
	        this.searchType = "";
	        this.offset = 0;
	        this.appSettings = null;
	        if (this.appSettings == null) {
	            this.appSettings = config_1.Config.config[0];
	        }
	        this.locateServiceURL = this.appSettings["AddressLocator"]["serviceUrl"];
	    }
	    // service command
	    LocationService.prototype.changeNav = function (Object) {
	        this._navItemSource.next(Object);
	    };
	    // getAddressSuggestions(typedAddress):any{
	    //     if(!typedAddress){
	    //         this.changeNav(false);
	    //         return new Array<Object>();
	    //     }
	    //     var urlAddress:string = this.constructURL(typedAddress);
	    //     // return this.jsonp.get(urlAddress + "?method=JSONP_CALLBACK")
	    //     //     .toPromise()
	    //     //     .then(
	    //     //         (response) => response.json()
	    //     //     ).catch(this.handleError);
	    //     if(urlAddress != ""){
	    //         this.changeNav(true);
	    //         return this.jsonp.get(urlAddress + this.jsonpCallback)
	    //            .map(response => {
	    //                 var suggestionsArray = response.json();
	    //                 for (var sug of suggestionsArray){
	    //                     sug["SuggestionType"] = this.searchType;
	    //                 }
	    //                 return suggestionsArray;
	    //            }).catch(this.handleObservableError);
	    //     }
	    //     this.changeNav(false);
	    //     return new Array<Object>();
	    // }
	    LocationService.prototype.handleObservableError = function (error) {
	        return Observable_1.Observable.of([]);
	    };
	    LocationService.prototype.handleError = function (error) {
	        console.error('An error occurred', error);
	        return Promise.reject(error.message || error);
	    };
	    // constructURL(typedAddress:string):string{
	    //     var url:string = "";
	    //     this.parsedAddress = new Object();
	    //     var parsedAddressArray:Array<string> = [typedAddress.substring(0, typedAddress.indexOf(" ")), typedAddress.substring(typedAddress.indexOf(" "))];
	    //     if(Number(parsedAddressArray[0])){
	    //         this.parsedAddress["streetNumber"] = parsedAddressArray[0];
	    //         if(parsedAddressArray[1] != " "){
	    //             parsedAddressArray[1] = parsedAddressArray[1].replace(/[ ]+/g, " ").trim();
	    //         }
	    //         this.parsedAddress["streetName"] = parsedAddressArray[1];
	    //         if(this.searchType == "Streets"){
	    //             this.parsedAddress["type"] = "Streets";
	    //             url = this.locateServiceURL + "StreetAddresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1];
	    //             return url;
	    //         }
	    //         this.parsedAddress["type"] = "Address";
	    //         url = this.locateServiceURL + "Addresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1] + "/true/true/true";
	    //         this.searchType = "Address";
	    //         return url;
	    //     }
	    //     for (var conc of this.concatenators){
	    //         if(typedAddress.toLowerCase().indexOf(" " + conc.toLowerCase() + " ") != -1 && typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ").length > 1 && typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ").indexOf("") == -1){
	    //             var intersections:Array<string> = typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ");
	    //             url = this.locateServiceURL + "Intersections/" + intersections[0] + "/" + intersections[1] + "/" + conc.toLowerCase();
	    //             this.searchType = "Intersection";
	    //             return url;
	    //         }
	    //     }
	    //     return url;
	    // }
	    LocationService.prototype.getAddressLocation = function (suggestion) {
	        var locationUrl = "";
	        if (suggestion["SuggestionType"] == "Address") {
	            locationUrl = this.locateServiceURL + "AddressLocationWithParcelNumber/" +
	                suggestion["HouseNum"] + "/" + suggestion["Street"]["Tag"] + "/" + (suggestion["Unit"] == "" ? " " : suggestion["Unit"]) +
	                "/Unit/Parcel" + this.jsonpCallback;
	        }
	        else if (suggestion["SuggestionType"] == "Intersection") {
	            locationUrl = this.locateServiceURL + "IntersectionLocation/" + suggestion["ID"] + this.jsonpCallback;
	        }
	        else if (suggestion["SuggestionType"] == "Streets") {
	            locationUrl = this.locateServiceURL + "StreetLocation/" + suggestion["StreetNumber"] + "/" + suggestion["Tag"] + "/" + this.offset + this.jsonpCallback;
	        }
	        return this.jsonp.get(locationUrl)
	            .toPromise()
	            .then(function (response) { return response.json(); }).catch(this.handleError);
	    };
	    LocationService.prototype.getStreetRanges = function () {
	        var streetName = this.parsedAddress["streetName"];
	        var streetRangesURL = this.locateServiceURL + "Streets/" + streetName + this.jsonpCallback;
	        return this.jsonp.get(streetRangesURL)
	            .toPromise()
	            .then(function (response) { return response.json(); }).catch(this.handleError);
	    };
	    return LocationService;
	}());
	LocationService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [http_1.Http, http_1.Jsonp])
	], LocationService);
	exports.LocationService = LocationService;


/***/ },
/* 94 */,
/* 95 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <label class=\"locationSearchIcon mdl-button mdl-js-button mdl-button--icon\" for=\"searchinput\" disabled>\r\n        <div class=\"material-icons\" [style.visibility]=\"searchInProgress == false ? 'visible' : 'hidden'\">search</div>\r\n        <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\" [style.visibility]=\"searchInProgress == true ? 'visible' : 'hidden'\"></div>\r\n    </label>\r\n    <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label addressLocatorDiv\">\r\n        <input class=\"mdl-textfield__input addressLocatorInput\" type=\"text\" id=\"searchinput\" #searchinput (keyup)=\"onKey($event)\" (keydown)=\"onKeyDown($event)\" [formControl]=\"term\">\r\n        <ul class=\"mdl-list suggestionsList\" style=\"position:absolute\" [style.max-width]=\"inputWidth\">\r\n                <li class=\"mdl-list__item suggestionItem\" *ngFor=\"let suggestion of suggestions\" (click)=\"suggestionClicked(suggestion)\">\r\n                <!--<li class=\"mdl-list__item\" *ngFor=\"let item of items | async\" (click)=\"suggestionClicked(suggestion)\">-->\r\n                    <span class=\"mdl-list__item-primary-content\">\r\n                        {{suggestion.FullAddress}}\r\n                    </span>\r\n                </li>\r\n        </ul>\r\n        <label class=\"mdl-textfield__label addressLocatorPlaceholderLabel\" for=\"AddressInput\">{{inputPlaceHolderText}}</label>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"mblSimpleDialogCover\" *ngIf=\"dialogShow\"></div>\r\n<!-- Square card -->\r\n<div class=\"demo-card-square mdl-card mdl-shadow--2dp\" *ngIf=\"dialogShow\">\r\n  <div class=\"mdl-card__title\">\r\n    <h1 class=\"mdl-card__title-text\">The address you entered is not valid</h1>\r\n  </div>\r\n  <div class=\"mdl-card__supporting-text\" style=\"overflow-y:auto\">\r\n    <span><b>{{validRangesHeader}}</b></span>\r\n    <ul>\r\n        <li *ngFor=\"let range of validStreetRanges\">\r\n            <span><b *ngIf=\"!oneSuggStreet\">{{range.name}}: </b>{{range.min}} to {{range.max}}</span>\r\n        </li>\r\n    </ul>\r\n  </div>\r\n  <div class=\"mdl-card__actions mdl-card--border\">\r\n    <a (click)=\"dialogShow = false\" class=\"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect\">\r\n      OK\r\n    </a>\r\n  </div>\r\n</div>";

/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports = ".addressLocatorDiv{\r\n    left:40px;\r\n    position: relative;\r\n    top: 56px;\r\n    right: 5px;\r\n    background-color: rgba(255, 255, 255, 0.9);\r\n    z-index: 100;\r\n    border-radius: 3px;\r\n    padding-left: 5px;\r\n    z-index: 100;\r\n    border-style: solid;\r\n    padding-top: 10px;\r\n    padding-bottom: 0px;\r\n    margin-bottom: 0px;\r\n    border-width: 2px;\r\n    width: calc(100% - 60px);\r\n}\r\n\r\n.addressLocatorInput{\r\n    padding-bottom: 1px;\r\n    padding-left: 31px;\r\n}\r\n\r\n.addressLocatorPlaceholderLabel{\r\n    font-size: 14px;\r\n    top:10px;\r\n    padding-left: 35px;\r\n    color: rgba(0,0,0,.6);\r\n    max-width: calc(100% - 35px);\r\n}\r\n\r\n.mdl-textfield--floating-label.is-focused .mdl-textfield__label, .mdl-textfield--floating-label.is-dirty .mdl-textfield__label, .mdl-textfield--floating-label.has-placeholder .mdl-textfield__label{\r\n    top:-2px;\r\n    font-size: 11px;\r\n}\r\n\r\n.mdl-textfield.is-focused .mdl-textfield__label:after{\r\n    visibility: hidden;\r\n}\r\n\r\n.locationSearchIcon{\r\n    position: absolute;\r\n    top: 60px;\r\n    left: 44px;\r\n    z-index: 101;\r\n}\r\n\r\n.suggestionsList{\r\n    background-color: white; \r\n    padding: 0px 0px 0px 0px; \r\n    z-index:3;\r\n    margin-top: 2px;\r\n    width: 100%;\r\n    left: 0px;\r\n    /* border-bottom-style: solid;\r\n    border-right-style:solid;\r\n    border-left-style:solid;\r\n    border-top-style: none;\r\n    border-width: 1px; */\r\n}\r\n.suggestionItem:hover{\r\n    background-color: #ED1C24;\r\n}\r\n.suggestionItem{\r\n    cursor: pointer;\r\n    border-top-style: none;\r\n    border-style:solid;\r\n    border-color:rgba(0,0,0,.26);\r\n    border-width: 1px;\r\n}\r\n.demo-card-square.mdl-card {\r\n    width: 320px;\r\n    height: 330px;\r\n    z-index: 100;\r\n\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    margin-top: -160px;\r\n    margin-left: -160px;\r\n}\r\n.demo-card-square > .mdl-card__title {\r\n  color: #fff;\r\n  background: #14284B;\r\n}\r\n.mdl-card__supporting-text{\r\n    height:190px;\r\n    overflow-y: auto;\r\n}\r\n.mdl-card__title-text{\r\n    font-size: 14pt;\r\n}"

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var forms_1 = __webpack_require__(27);
	var config_1 = __webpack_require__(60);
	var map_service_1 = __webpack_require__(62);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var TileLayer = __webpack_require__(52);
	var BasemapNavComponent = (function () {
	    function BasemapNavComponent(elRef, _mapService, _eventsService, _esriTasksService) {
	        this.elRef = elRef;
	        this._mapService = _mapService;
	        this._eventsService = _eventsService;
	        this._esriTasksService = _esriTasksService;
	        this.appSettings = null;
	        this.arrowIcon = "arrow_drop_up";
	        this.selectYearTitle = "Select aerial year";
	        this.showOrthoList = false;
	        this.mapSliderControl = new forms_1.FormControl();
	        this.initTransparencyValue = 0;
	        this.statePlaneLayers = [];
	        this.IEbrowser = false;
	        this.internetExplorer = false;
	        if (this.appSettings == null) {
	            this.appSettings = config_1.Config.config[0];
	        }
	    }
	    BasemapNavComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.statePlaneLayers = this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["layers"];
	        this.statePlaneLayers.forEach(function (l) {
	            if (l["id"] == _this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["default"]) {
	                l["selected"] = true;
	                _this.currentStatePlane = l;
	            }
	            else {
	                l["selected"] = false;
	            }
	        });
	        this.currentStatePlane["opacity"] = this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["startOpacity"];
	        //Check if MSIE or Edge browser
	        try {
	            if (navigator.userAgent.indexOf("MSIE ") != -1 || navigator.userAgent.indexOf("Trident/") != -1 || navigator.userAgent.indexOf("Edge/") != -1) {
	                this.IEbrowser = true;
	            }
	            if (navigator.userAgent.indexOf("MSIE ") != -1 || navigator.userAgent.indexOf("Trident/") != -1) {
	                this.internetExplorer = true;
	            }
	        }
	        catch (error) {
	            console.log("Could not find browser type");
	        }
	    };
	    BasemapNavComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.mapSliderControl.valueChanges
	            .subscribe(function (n) { return _this.sliderChange(n); });
	    };
	    //function to run on slider change for toggleing aerial transparency 
	    BasemapNavComponent.prototype.sliderChange = function (slidervalue) {
	        var opacityValue = slidervalue;
	        this._mapService.view.map.findLayerById(this.currentStatePlane["id"]).opacity = opacityValue / 100;
	        this.currentStatePlane["opacity"] = opacityValue / 100;
	    };
	    BasemapNavComponent.prototype.basemapToggle = function (slidervalue) {
	        this.initTransparencyValue = slidervalue;
	    };
	    BasemapNavComponent.prototype.selectOrthoYear = function (event) {
	        (this.arrowIcon == "arrow_drop_up") ? this.showOrthoYearOptions() : this.hideOrthoYearOptions();
	    };
	    BasemapNavComponent.prototype.showOrthoYearOptions = function () {
	        this.arrowIcon = "arrow_drop_down";
	        this.showOrthoList = true;
	        this.selectYearTitle = "Hide";
	    };
	    BasemapNavComponent.prototype.hideOrthoYearOptions = function () {
	        this.arrowIcon = "arrow_drop_up";
	        this.showOrthoList = false;
	        this.selectYearTitle = "Select aerial year";
	    };
	    BasemapNavComponent.prototype.layerSelected = function (layerObject) {
	        if (this.currentStatePlane["id"] == layerObject["id"]) {
	            this.hideOrthoYearOptions();
	            return;
	        }
	        this._mapService.view.map.findLayerById(this.currentStatePlane["id"]).visible = false;
	        layerObject["opacity"] = this.currentStatePlane["opacity"];
	        if (!this._mapService.view.map.findLayerById(layerObject["id"])) {
	            var tl = new TileLayer({
	                id: layerObject["id"],
	                url: layerObject["url"],
	                "opacity": layerObject["opacity"]
	            });
	            this._mapService.view.map.add(tl, 1);
	        }
	        else {
	            for (var _i = 0, _a = this.statePlaneLayers; _i < _a.length; _i++) {
	                var l = _a[_i];
	                if (l["id"] == layerObject["id"]) {
	                    this._mapService.view.map.findLayerById(l["id"]).visible = true;
	                    // }//else{
	                    //     this._mapService.view.map.findLayerById(l["id"]).visible = false;
	                    // }
	                    break;
	                }
	            }
	        }
	        for (var _b = 0, _c = this.statePlaneLayers; _b < _c.length; _b++) {
	            var l = _c[_b];
	            if (l["id"] == layerObject["id"]) {
	                l["selected"] = true;
	            }
	            else {
	                l["selected"] = false;
	            }
	        }
	        this.currentStatePlane = layerObject;
	        this.hideOrthoYearOptions();
	    };
	    BasemapNavComponent.prototype.inputChange = function (event) {
	        if (this.internetExplorer) {
	            this.initTransparencyValue = event.currentTarget.value;
	            this.sliderChange(event.currentTarget.value);
	        }
	    };
	    return BasemapNavComponent;
	}());
	BasemapNavComponent = __decorate([
	    core_1.Component({
	        selector: 'basemapNav-component',
	        template: __webpack_require__(98),
	        styles: [__webpack_require__(99)]
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, map_service_1.MapService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService])
	], BasemapNavComponent);
	exports.BasemapNavComponent = BasemapNavComponent;


/***/ },
/* 98 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-card__actions mdl-card--border legendSliderActionsDiv\">\r\n    <div class=\"legendSliderDiv\">\r\n        <button id=\"maptoggle\" class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\" (click)=\"basemapToggle(0)\" title=\"Map View\">\r\n            <i class=\"material-icons blue\" >map</i>\r\n        </button>\r\n        <input class=\"mdl-slider mdl-js-slider map-transparency-slider\" [ngClass]=\"{iemdlslider: IEbrowser}\" type=\"range\" min=\"0\" max=\"100\" [(ngModel)]=\"initTransparencyValue\" value={{initTransparencyValue}} (change)=\"inputChange($event)\"\r\n            tabindex=\"0\" [formControl]=\"mapSliderControl\" style=\"z-index:99;\">\r\n        <!--<input class=\"mdl-slider mdl-js-slider\" type=\"range\" min=\"0\" max=\"100\"\r\n            tabindex=\"0\">-->\r\n        <button id=\"sattoggle\" class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\" (click)=\"basemapToggle(100)\" title=\"Aerial View\">\r\n            <i class=\"material-icons blue\">satellite</i>\r\n        </button>\r\n        <label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect\" id=\"change-aerial-label\" for=\"change-aerial-icon\" title=\"{{selectYearTitle}}\">\r\n            <input type=\"checkbox\" id=\"change-aerial-icon\" class=\"mdl-icon-toggle__input\" (click)=\"selectOrthoYear($event)\" name=\"mapToolActive\" value=\"Select Ortho Year\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">{{arrowIcon}}</i>\r\n            <!--<div class=\"mdl-tooltip mdl-tooltip--large\" for=\"change-aerial-label\">\r\n                Change aerial photo\r\n            </div>-->\r\n        </label>\r\n    </div>\r\n    <ul class=\"demo-list-item mdl-list orthoMapsList\" [style.visibility]=\"(showOrthoList == true) ? 'visible' : 'hidden'\">\r\n        <li class=\"mdl-list__item orthoMapsListItem\" *ngFor=\"let layer of statePlaneLayers\" (click)=\"layerSelected(layer)\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n                <i class=\"material-icons mdl-list__item-icon orthoMapsListCheckbox\" [style.visibility]=\"(layer.selected == true) ? 'inherit' : 'hidden'\">check</i>\r\n                {{layer.title}}\r\n            </span>\r\n        </li>\r\n    </ul>\r\n</div>";

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = ".legendSliderDiv {\r\n  display:flex; \r\n  margin-top: 0px; \r\n  margin-left: 0px;\r\n  z-index: 99;\r\n  align-items: center;\r\n}\r\n\r\n.legendSliderActionsDiv{\r\n    display: table-cell;\r\n    padding-top:4px;\r\n    padding-bottom:4px;\r\n}\r\n\r\n.orthoMapsList{\r\n    bottom: 30px;\r\n    position: absolute;\r\n    display: inline;\r\n    border-style: solid;\r\n    z-index: 10;\r\n    background-color:#FFFFFF;\r\n    max-height: 145px;\r\n    overflow-y: auto;\r\n    padding: 0px 0px 0px 0px;\r\n    border-radius: 8px;\r\n}\r\n\r\n.orthoMapsList > li:hover {\r\n    background-color: #ED1C24;\r\n    cursor: pointer;\r\n}\r\n\r\n.orthoMapsListItem{\r\n    padding: 2px;\r\n    min-height: 30px;\r\n    border-style: solid none none none;\r\n    border-width: 1px;\r\n}\r\n\r\n.orthoMapsListCheckbox{\r\n    margin-right:0px !important;\r\n}\r\n\r\n.map-transparency::-webkit-slider-thumb{\r\n    background-color: white;\r\n}\r\n\r\n.mdl-slider.is-upgraded{\r\n    z-index: 99;\r\n}\r\n\r\n.mdl-slider.is-upgraded::-ms-fill-upper{\r\n    padding:0;\r\n    background:linear-gradient(to left,transparent,transparent 16px,rgba(255,255,255,.56)16px,rgba(255,255,255,.56)0)\r\n}\r\n\r\n.mdl-slider::-ms-thumb{\r\n    background: white !important;\r\n    border-style: solid !important;\r\n    border-color: black !important;\r\n    border-width: 1px;\r\n}\r\n\r\n.mdl-slider.is-upgraded::-moz-range-thumb{\r\n    background-color: white;\r\n}\r\n\r\n.mdl-slider.is-upgraded{\r\n    width: calc(100% - 20px);\r\n    margin: 0 10px;\r\n}\r\n\r\n.iemdlslider {\r\n    height:20px !important;\r\n    width:130px !important;\r\n    margin-left:10px !important;\r\n    margin-right: 7px !important;\r\n}"

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(4);
	var config_1 = __webpack_require__(60);
	var map_service_1 = __webpack_require__(62);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var forms_1 = __webpack_require__(27);
	var Point = __webpack_require__(38);
	var SimpleFillSymbol = __webpack_require__(56);
	var SimpleLineSymbol = __webpack_require__(57);
	var PictureMarkerSymbol = __webpack_require__(86);
	var Polygon = __webpack_require__(42);
	var Color = __webpack_require__(50);
	var Graphic = __webpack_require__(55);
	var parcelReport_service_1 = __webpack_require__(63);
	var cloneDeep = __webpack_require__(101);
	var LegendComponent = (function () {
	    function LegendComponent(elRef, _mapService, _eventsService, _esriTasksService, prs) {
	        this.elRef = elRef;
	        this._mapService = _mapService;
	        this._eventsService = _eventsService;
	        this._esriTasksService = _esriTasksService;
	        this.dynamicLayers = [];
	        this.dynamicLayersForMS = [];
	        this.colorString = "rgb(255, 255, 0)";
	        this.appSettings = null;
	        this.moduleLayerItem = 0;
	        this.arrowIconValue = "keyboard_arrow_right";
	        this.searchModuleName = "";
	        this.searchModuleIcon = "";
	        this.showChip = false;
	        this.transPlanLogo = "./images/transportation.jpg";
	        this.landUsePlanLogo = "./images/land_use.png";
	        this.neighbLogo = "./images/icon_boundaries.png";
	        this.parcelLogo = "./images/Property_Icon3_100x100.png";
	        this.drawPolygonLogo = "./images/ic_edit_location_white_24dp_2x.png";
	        this.freeHandPolygonLogo = "./images/ic_mode_edit_white_24dp_2x.png";
	        this.mapPin = "./images/map_pin_red-128.png";
	        this.geometryFilterType = "";
	        this.geomFilterLogo = "";
	        this.obliqueImageLogo = "./images/ic_photo_white_24dp_2x.png";
	        this.loadingLegendImage = "./images/loading.gif";
	        this.showLegend = false;
	        this.mapLoading = false;
	        this.geoDefinitionExpressions = [];
	        this.filterGeometry = null;
	        this.geometryOptions = false;
	        this.queryIteration = 0;
	        this.queryMSIteration = 0;
	        this.onlyGeomControl = new forms_1.FormControl();
	        this.showOnlyWithinGeometry = false;
	        this.showObliqueImage = false;
	        this.displayObliqueImage = true;
	        this.bufferSliderValue = "0";
	        this.showAddressComponent = true;
	        this.parcelReportOption = false;
	        this.parcelReportIconPath = "./images/parcel-report-icon.png";
	        this.parcelReportIconLoading = "./images/loading.gif";
	        this.parcelReportElementTitle = "Generate Parcel Report";
	        this.reportGenerationInProgress = false;
	        this.reportID = 0;
	        this.IEbrowser = false;
	        this.internetExplorer = false;
	        this.operationalLayersCount = 0;
	        this.appURLCreated = new core_1.EventEmitter();
	        if (this.appSettings == null) {
	            this.appSettings = config_1.Config.config[0];
	        }
	        this._parcelReportService = prs;
	    }
	    LegendComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._eventsService.dynamicLayerViewCreated$.subscribe(function (show) {
	            _this.operationalLayersCount++;
	            if (_this.appSettings["Map"]["Layers"]["OperationalLayers"].length == _this.operationalLayersCount) {
	                _this._eventsService.moduleSelect$.subscribe(function (module) {
	                    for (var _i = 0, _a = _this.appSettings["Map"]["Layers"]["OperationalLayers"]; _i < _a.length; _i++) {
	                        var miLayer = _a[_i];
	                        _this._mapService.view.map.findLayerById(miLayer.id).visible = false;
	                    }
	                    _this.startLegendCreate(module);
	                });
	            }
	        });
	        this._eventsService.startSaveSearch$.subscribe(function () {
	            try {
	                var saveModule = _this.createObjectForSavedSearch();
	                window.localStorage.setItem("PlanIndy_saved_search", JSON.stringify({
	                    "module": saveModule,
	                    "geometry": _this.filterGeometryObject,
	                    "extent": _this._mapService.view.extent,
	                    "buffer": _this.bufferSliderValue,
	                    "showOnlyWithinGeometry": _this.showOnlyWithinGeometry
	                }));
	            }
	            catch (error) {
	                console.log(error);
	            }
	        });
	        this._eventsService.createAppURL$.subscribe(function (shareMethod) {
	            try {
	                var saveModule = _this.createObjectForSavedSearch();
	                var searchUrl = JSON.stringify({
	                    "module": saveModule,
	                    "geometry": _this.filterGeometryObject,
	                    "extent": _this._mapService.view.extent,
	                    "buffer": _this.bufferSliderValue,
	                    "showOnlyWithinGeometry": _this.showOnlyWithinGeometry
	                }); //.replace(new RegExp(' ', 'g'), '%20');
	                _this.appURLCreated.next(JSON.stringify({ "url": searchUrl, "method": shareMethod }));
	                console.log(searchUrl);
	            }
	            catch (error) {
	                console.log(error);
	            }
	        });
	        this._eventsService.navItem$.subscribe(function (suggestion) {
	            _this.filterGeometryObject = suggestion;
	            _this.removeGeometryFilter();
	            _this.queryMSIteration = 0;
	            ///Add parcel report option for "ParcelNumber" and "Address" types
	            switch (suggestion["addressSuggestion"]["SuggestionType"]) {
	                case "ParcelNumber":
	                    _this.parcelReportElementTitle = "Generate Parcel Report";
	                    _this.parcelReportOption = true;
	                    _this.reportGenerationInProgress = false;
	                    _this.reportID = 0;
	                    var graphic = new Graphic();
	                    graphic.geometry = suggestion["addressLocation"];
	                    graphic.attributes = {};
	                    graphic.attributes["Parcel Number"] = suggestion["addressSuggestion"]["FullName"];
	                    graphic.attributes["Parcel Address"] = suggestion["addressSuggestion"]["ShowAddress"];
	                    _this.parcelReportFeature = graphic;
	                    break;
	                case "Address":
	                    _this.parcelReportElementTitle = "Generate Parcel Report";
	                    _this.getParcelFeatureFromCoordinates(suggestion);
	                    break;
	                default:
	                    _this.parcelReportOption = false;
	                    break;
	            }
	            if (suggestion["addressSuggestion"]["SuggestionType"] == "Neighborhood" || suggestion["addressSuggestion"]["SuggestionType"] == "ParcelNumber" || suggestion["addressSuggestion"]["SuggestionType"] == "DrawPolygon" || suggestion["addressSuggestion"]["SuggestionType"] == "FreeHandPolygon") {
	                var filterPolygon = new Polygon();
	                filterPolygon.rings = suggestion["addressLocation"]["rings"];
	                filterPolygon.spatialReference = _this._mapService.view.spatialReference;
	                _this.filterGeometry = filterPolygon;
	                if (suggestion["addressSuggestion"]["SuggestionType"] == "ParcelNumber") {
	                    _this.geometryFilterType = "Parcel " + suggestion["addressSuggestion"]["FullName"];
	                }
	                else {
	                    _this.geometryFilterType = suggestion["addressSuggestion"]["FullName"];
	                }
	                _this.queryForFilterGeometry(_this.filterGeometry);
	                _this._mapService.view.extent = _this.filterGeometry.extent;
	                _this.showGeometryOnMap(_this.filterGeometry, "filterPolygon");
	            }
	            else {
	                if (suggestion["buffer"]) {
	                    _this.bufferSliderValue = suggestion["buffer"];
	                }
	                var point = new Point({
	                    x: suggestion["addressLocation"]["X"],
	                    y: suggestion["addressLocation"]["Y"],
	                    spatialReference: _this._mapService.view.spatialReference
	                });
	                _this.filterGeometry = point;
	                _this.geometryFilterType = suggestion["addressSuggestion"]["FullName"];
	                if (_this.bufferSliderValue == "0") {
	                    _this.queryForFilterGeometry(_this.filterGeometry);
	                    _this.showGeometryOnMap(_this.filterGeometry, "filterPolygon");
	                }
	                else {
	                    _this.showGeometryOnMap(_this.filterGeometry, "filterPolygon");
	                    _this._esriTasksService.bufferFeatures(_this.appSettings["GeometryService"]["url"], [_this.filterGeometry], [_this.bufferSliderValue], "feet", _this._mapService.view.spatialReference).then(function (geometries) {
	                        if (geometries.length > 0) {
	                            _this.geoDefinitionExpressions = [];
	                            _this.queryForFilterGeometry(geometries[0]);
	                            _this.showGeometryOnMap(geometries[0], "pointBuffer");
	                        }
	                    });
	                }
	            }
	            _this.setGeomFilterLogo(suggestion);
	        });
	        this._eventsService.setSavedGeometry$.subscribe(function (savedGeometry) {
	            _this.filterGeometryObject = savedGeometry.geometry;
	            _this.removeGeometryFilter();
	            _this.queryMSIteration = 0;
	            if (_this.filterGeometryObject["addressSuggestion"]["SuggestionType"] == "Neighborhood" || _this.filterGeometryObject["addressSuggestion"]["SuggestionType"] == "ParcelNumber" || _this.filterGeometryObject["addressSuggestion"]["SuggestionType"] == "DrawPolygon" || _this.filterGeometryObject["addressSuggestion"]["SuggestionType"] == "FreeHandPolygon") {
	                var filterPolygon = new Polygon();
	                filterPolygon.rings = _this.filterGeometryObject["addressLocation"]["rings"];
	                filterPolygon.spatialReference = _this.filterGeometryObject["addressLocation"]["spatialReference"];
	                _this.filterGeometry = filterPolygon;
	            }
	            else {
	                if (savedGeometry["buffer"]) {
	                    _this.bufferSliderValue = savedGeometry["buffer"];
	                }
	                var point = new Point({
	                    x: _this.filterGeometryObject["addressLocation"]["X"],
	                    y: _this.filterGeometryObject["addressLocation"]["Y"],
	                    spatialReference: _this._mapService.view.spatialReference
	                });
	                _this.filterGeometry = point;
	            }
	            _this.showOnlyWithinGeometry = savedGeometry["showOnlyWithinGeometry"];
	            _this.geometryFilterType = _this.filterGeometryObject["addressSuggestion"]["FullName"];
	            _this.setGeomFilterLogo(_this.filterGeometryObject);
	            _this.showGeometryOnMap(_this.filterGeometry, "filterPolygon");
	        });
	        this._eventsService.showObliqueImage$.subscribe(function (show) {
	            _this.showObliqueImage = show;
	        });
	        this._eventsService.addressSearchActivate$.subscribe(function (show) {
	            return _this.showAddressComponent = show;
	        });
	        this._eventsService.mapUpdateShow$.subscribe(function (show) {
	            _this.mapLoading = show;
	        });
	        //Determine if IE or Edge browser
	        try {
	            if (navigator.userAgent.indexOf("MSIE ") != -1 || navigator.userAgent.indexOf("Trident/") != -1 || navigator.userAgent.indexOf("Edge/") != -1) {
	                this.IEbrowser = true;
	            }
	            if (navigator.userAgent.indexOf("MSIE ") != -1 || navigator.userAgent.indexOf("Trident/") != -1) {
	                this.internetExplorer = true;
	            }
	        }
	        catch (error) {
	            console.log("Could not find browser type");
	        }
	    };
	    LegendComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.onlyGeomControl.valueChanges
	            .subscribe(function (toggleValue) {
	            _this.showOnlyWithinGeometry = toggleValue;
	            _this.applyExceptionsToDefinitionExpressions();
	            if (toggleValue == true) {
	                _this.applyGeoDefinitionExpressions();
	            }
	        });
	    };
	    LegendComponent.prototype.ngDoCheck = function () {
	        //this._mapService.currentCompPlanLayer = this.compPlanLayer;
	    };
	    LegendComponent.prototype.createObjectForSavedSearch = function () {
	        var saveModule = cloneDeep(this.searchModule);
	        var layerToDynamicLayers = {};
	        for (var _i = 0, _a = saveModule.Layers; _i < _a.length; _i++) {
	            var layer = _a[_i];
	            var sublayersArray = layer.SubLayers;
	            for (var _b = 0, sublayersArray_1 = sublayersArray; _b < sublayersArray_1.length; _b++) {
	                var subLayer = sublayersArray_1[_b];
	                for (var i = 0; i < this.dynamicLayers.length; i++) {
	                    if (this.dynamicLayers[i]["msId"] == layer["id"] && subLayer["id"] == this.dynamicLayers[i]["id"]) {
	                        subLayer.opacity = this._mapService.view.map.findLayerById(this.dynamicLayers[i]["msId"]).findSublayerById(this.dynamicLayers[i].id).opacity;
	                        subLayer.visible = this._mapService.view.map.findLayerById(this.dynamicLayers[i]["msId"]).findSublayerById(this.dynamicLayers[i].id).visible;
	                    }
	                }
	            }
	            layer.SubLayers = sublayersArray;
	        }
	        saveModule["dynamicLayers"] = this.dynamicLayers;
	        return saveModule;
	    };
	    LegendComponent.prototype.zoomToGeometry = function () {
	        switch (this.filterGeometry.type) {
	            case "polygon":
	                this._mapService.view.extent = this.filterGeometry.extent;
	                break;
	            case "point":
	                this._mapService.view.center = this.filterGeometry;
	                this._mapService.view.zoom = 12;
	                break;
	        }
	    };
	    LegendComponent.prototype.setGeomFilterLogo = function (suggestion) {
	        switch (suggestion["addressSuggestion"]["SuggestionType"]) {
	            case "Neighborhood":
	                this.geomFilterLogo = this.neighbLogo;
	                break;
	            case "ParcelNumber":
	                this.geomFilterLogo = this.parcelLogo;
	                break;
	            case "Address":
	                this.geomFilterLogo = this.mapPin;
	                break;
	            case "Intersection":
	                this.geomFilterLogo = this.mapPin;
	                break;
	            case "DrawPolygon":
	                this.geomFilterLogo = this.drawPolygonLogo;
	                break;
	            case "FreeHandPolygon":
	                this.geomFilterLogo = this.freeHandPolygonLogo;
	                break;
	            default:
	                this.geomFilterLogo = this.mapPin;
	                break;
	        }
	    };
	    LegendComponent.prototype.queryForFilterGeometry = function (geometryToFilter) {
	        if (this.dynamicLayers.length > 0) {
	            this.queryIteration = 0;
	            this.queryForFilterGeometryProcess(geometryToFilter);
	        }
	    };
	    // private queryForFilterGeometryProcess(dynamicLayersForMS:Array<any>, geometryToFilter:Geometry){
	    //     this.getGeometryFilterDefExpressions(dynamicLayersForMS[this.queryIteration], geometryToFilter)
	    //     // if(this.geoDefinitionExpressions.length == this.dynamicLayers.length){
	    //     //     this._eventsService.mapUpdateShow(false);
	    //     //     this.applyExceptionsToDefinitionExpressions();
	    //     //     this.applyGeoDefinitionExpressions();
	    //     // }else{
	    //     //     this.queryMSIteration++;
	    //     //     if(this.searchModule.Layers.length > this.queryMSIteration){
	    //     //         this.queryForFilterGeometryProcess(0, geometryToFilter);
	    //     //     }
	    //     // }
	    // }
	    LegendComponent.prototype.queryForFilterGeometryProcess = function (geometryToFilter) {
	        var _this = this;
	        try {
	            var dynamicLayer = this.dynamicLayers[this.queryIteration];
	            var queryLayerUrl = this._mapService.view.map.findLayerById(dynamicLayer.msId).url + "/" + dynamicLayer["id"];
	            this._eventsService.mapUpdateShow(true);
	            this._esriTasksService.queryFeaturesForIDs(queryLayerUrl, geometryToFilter, "1=1").then(function (result) {
	                //var id:string = result["url"].toString();
	                var defExpression = "1 <> 1";
	                if (result.results) {
	                    var resCount = result.results.length;
	                    defExpression = "";
	                    if (resCount > 999) {
	                        var thousandsCount = Math.floor(resCount / 999);
	                        var countRemainder = resCount % 999;
	                        for (var i = 0; i < thousandsCount; i++) {
	                            if (i == 0) {
	                                defExpression = defExpression + dynamicLayer["objectIDField"] + " in (" + result.results.splice(0, 999) + ")";
	                            }
	                            else {
	                                defExpression = defExpression + " OR " + dynamicLayer["objectIDField"] + " in (" + result.results.splice(0, 999) + ")";
	                            }
	                        }
	                        defExpression = defExpression + " OR " + dynamicLayer["objectIDField"] + " in (" + result.results.splice(0) + ")";
	                    }
	                    else {
	                        defExpression = dynamicLayer["objectIDField"] + " in (" + result.results.toString() + ")";
	                    }
	                }
	                _this.geoDefinitionExpressions.push({
	                    "msId": dynamicLayer["msId"],
	                    "id": dynamicLayer["id"],
	                    "definitionExpression": defExpression
	                });
	                if (_this.geoDefinitionExpressions.length == _this.dynamicLayers.length) {
	                    _this._eventsService.mapUpdateShow(false);
	                    _this.applyExceptionsToDefinitionExpressions();
	                    if (_this.showOnlyWithinGeometry == true) {
	                        _this.applyGeoDefinitionExpressions();
	                    }
	                    return;
	                }
	                else {
	                    _this._eventsService.mapUpdateShow(true);
	                }
	                _this.queryIteration++;
	                if (_this.queryIteration < _this.dynamicLayers.length) {
	                    _this.queryForFilterGeometryProcess(geometryToFilter);
	                }
	                // else{
	                //     this.queryMSIteration++;
	                //     this.queryForFilterGeometry(geometryToFilter)
	                // }
	            });
	        }
	        catch (err) {
	            console.log(err);
	            this._eventsService.mapUpdateShow(false);
	        }
	    };
	    LegendComponent.prototype.startLegendCreate = function (module) {
	        this.searchModule = module;
	        this.searchModuleName = module["Name"];
	        this.searchModuleIcon = module["Icon"];
	        this.showChip = true;
	        this.dynamicLayers = [];
	        this.moduleLayerItem = 0;
	        this.moduleLayers = module.Layers;
	        this._mapService.currentDynamicLayers = [];
	        for (var _i = 0, _a = this.moduleLayers; _i < _a.length; _i++) {
	            var layer = _a[_i];
	            this._mapService.currentDynamicLayers.push(this._mapService.view.map.findLayerById(layer["id"]));
	        }
	        if (module.dynamicLayers && module.dynamicLayers != null) {
	            this.dynamicLayers = module.dynamicLayers;
	            for (var _b = 0, _c = this.moduleLayers; _b < _c.length; _b++) {
	                var moduleLayer = _c[_b];
	                var miLayer = this._mapService.view.map.findLayerById(moduleLayer.id);
	                miLayer.visible = true;
	                miLayer.sublayers = moduleLayer.SubLayers;
	                this.applyExceptionsToDefinitionExpressions();
	            }
	            this.getLegendSwatches();
	        }
	        else {
	            this.preProcessLegendCreate(this.moduleLayers[this.moduleLayerItem]);
	        }
	    };
	    LegendComponent.prototype.preProcessLegendCreate = function (moduleLayer) {
	        var _this = this;
	        var miLayer = this._mapService.view.map.findLayerById(moduleLayer.id);
	        miLayer.visible = true;
	        miLayer.sublayers = moduleLayer.SubLayers;
	        this._esriTasksService.getServiceValues(moduleLayer.URL + "/layers?f=pjson").then(function (item) { return _this.processLegendCreate(item); }).catch(function (error) { return console.log(error); });
	    };
	    LegendComponent.prototype.processLegendCreate = function (item) {
	        try {
	            for (var _i = 0, _a = item.layers; _i < _a.length; _i++) {
	                var layer = _a[_i];
	                var miLayer = this._mapService.view.map.findLayerById(this.moduleLayers[this.moduleLayerItem]["id"]);
	                if (!miLayer.sublayers.find(function (slyr) { return slyr.id == layer.id; })) {
	                    continue;
	                }
	                var layerDefExpr = miLayer.findSublayerById(layer.id)["definitionExpression"];
	                var dynamicLayer = {};
	                dynamicLayer["msId"] = this.moduleLayers[this.moduleLayerItem]["id"];
	                dynamicLayer["id"] = layer.id;
	                var drawingInfo = layer.drawingInfo;
	                var fields = layer.fields;
	                var objectIDField = fields.find(function (x) { return x["type"] == "esriFieldTypeOID"; });
	                dynamicLayer["objectIDField"] = objectIDField["name"];
	                dynamicLayer["title"] = layer.name;
	                dynamicLayer["minScale"] = layer.minScale;
	                dynamicLayer["maxScale"] = layer.maxScale;
	                //dynamicLayer["drawingInfo"] = layer.drawingInfo;
	                switch (layer.geometryType) {
	                    case "esriGeometryPolygon":
	                        dynamicLayer["type"] = "polygon";
	                        break;
	                }
	                var layerDrawingInfos = [];
	                switch (drawingInfo["renderer"]["type"]) {
	                    case "uniqueValue":
	                        var rendererFields = [];
	                        if (drawingInfo["renderer"]["field1"] != null) {
	                            rendererFields.push(drawingInfo["renderer"]["field1"]);
	                        }
	                        if (drawingInfo["renderer"]["field2"] != null) {
	                            rendererFields.push(drawingInfo["renderer"]["field2"]);
	                        }
	                        if (drawingInfo["renderer"]["field3"] != null) {
	                            rendererFields.push(drawingInfo["renderer"]["field3"]);
	                        }
	                        var uniqueValueInfos = drawingInfo["renderer"]["uniqueValueInfos"];
	                        //var uniqueValueInfoValues:Array<string> = [];
	                        var uniqueValueInfoLabels = [];
	                        uniqueValueInfos.forEach(function (element) {
	                            // if(uniqueValueInfoValues.indexOf(element["value"]) == -1){
	                            //     uniqueValueInfoValues.push(element["value"]);
	                            // }
	                            if (uniqueValueInfoLabels.indexOf(element["label"]) == -1) {
	                                uniqueValueInfoLabels.push(element["label"]);
	                            }
	                        });
	                        var uniqueValueInfosMultipleValues = [];
	                        uniqueValueInfoLabels.forEach(function (label) {
	                            var labelValues = [];
	                            uniqueValueInfos.forEach(function (uvi) {
	                                if (uvi["label"] == label) {
	                                    var uviValues_1;
	                                    if (rendererFields.length > 1) {
	                                        uviValues_1 = uvi["value"].split(drawingInfo["renderer"]["fieldDelimiter"]);
	                                    }
	                                    else {
	                                        uviValues_1 = [uvi["value"]];
	                                    }
	                                    uviValues_1.forEach(function (uviValue, ind) {
	                                        if (fields.find(function (f) { return f["name"] == rendererFields[ind]; })["type"] == "esriFieldTypeString") {
	                                            uviValues_1[ind] = "'" + uviValue + "'";
	                                        }
	                                        else if (fields.find(function (f) { return f["name"] == rendererFields[ind]; })["type"] == "esriFieldTypeInteger") {
	                                            uviValues_1[ind] = uviValue;
	                                        }
	                                        else {
	                                            uviValues_1[ind] = "'" + uviValue + "'";
	                                        }
	                                    });
	                                    labelValues.push(uviValues_1.toString());
	                                }
	                            });
	                            uniqueValueInfosMultipleValues.push({
	                                "label": label,
	                                "value": labelValues
	                            });
	                        });
	                        uniqueValueInfos = uniqueValueInfosMultipleValues;
	                        dynamicLayer["rendererFields"] = rendererFields;
	                        dynamicLayer["exceptions"] = [];
	                        dynamicLayer["fieldDelimiter"] = drawingInfo["renderer"]["fieldDelimiter"];
	                        for (var _b = 0, uniqueValueInfos_1 = uniqueValueInfos; _b < uniqueValueInfos_1.length; _b++) {
	                            var uvi = uniqueValueInfos_1[_b];
	                            var visibleDef;
	                            if (layerDefExpr == null) {
	                                visibleDef = true;
	                            }
	                            else if (layerDefExpr.indexOf(uvi["value"]) > -1) {
	                                dynamicLayer["exceptions"].push(uvi["value"]);
	                                visibleDef = false;
	                            }
	                            else {
	                                visibleDef = true;
	                            }
	                            layerDrawingInfos.push({
	                                "label": uvi["label"],
	                                "value": uvi["value"],
	                                "visible": visibleDef
	                            });
	                        }
	                        break;
	                    case "simple":
	                        var visibleDef;
	                        if (layerDefExpr == null) {
	                            visibleDef = true;
	                        }
	                        else if (layerDefExpr.indexOf(uvi["value"]) > -1) {
	                            dynamicLayer["exceptions"].push(uvi["value"]);
	                            visibleDef = false;
	                        }
	                        else {
	                            visibleDef = true;
	                        }
	                        layerDrawingInfos.push({
	                            "label": "",
	                            "value": "",
	                            "visible": visibleDef
	                        });
	                        break;
	                }
	                dynamicLayer["drawingInfo"] = layerDrawingInfos;
	                dynamicLayer["expanded"] = true;
	                this.dynamicLayers.push(dynamicLayer);
	            }
	            this.moduleLayerItem++;
	            if (this.moduleLayerItem < this.moduleLayers.length) {
	                this.preProcessLegendCreate(this.moduleLayers[this.moduleLayerItem]);
	            }
	            else {
	                this.moduleLayerItem = 0;
	                this.getLegendSwatches();
	            }
	        }
	        catch (err) {
	            console.log(err);
	        }
	    };
	    LegendComponent.prototype.getLegendSwatches = function () {
	        var _this = this;
	        this._esriTasksService.getServiceValues(this.moduleLayers[this.moduleLayerItem].URL + "/legend?f=pjson").then(function (item) {
	            var legendSwatches = [];
	            for (var _i = 0, _a = item.layers; _i < _a.length; _i++) {
	                var layer = _a[_i];
	                var currentLayer;
	                for (var i = 0; i < _this.dynamicLayers.length; i++) {
	                    if (_this.dynamicLayers[i]["title"] == layer.layerName) {
	                        currentLayer = _this.dynamicLayers[i];
	                        for (var j = 0; j < layer.legend.length; j++) {
	                            _this.dynamicLayers[i]["drawingInfo"][j]["imageUrl"] = _this.moduleLayers[_this.moduleLayerItem].URL + "/" + layer.layerId + "/images/" + layer.legend[j].url;
	                        }
	                        break;
	                    }
	                }
	            }
	            _this.moduleLayerItem++;
	            if (_this.moduleLayerItem < _this.moduleLayers.length) {
	                _this.getLegendSwatches();
	            }
	            else {
	                if (_this.filterGeometry != null) {
	                    _this.geoDefinitionExpressions = [];
	                    _this.queryMSIteration = 0;
	                    if (_this.filterGeometry.type == "point" && _this.bufferSliderValue != "0") {
	                        _this._esriTasksService.bufferFeatures(_this.appSettings["GeometryService"]["url"], [_this.filterGeometry], [_this.bufferSliderValue], "feet", _this._mapService.view.spatialReference).then(function (geometries) {
	                            if (geometries.length > 0) {
	                                _this.geoDefinitionExpressions = [];
	                                _this.queryForFilterGeometry(geometries[0]);
	                                _this.showGeometryOnMap(geometries[0], "pointBuffer");
	                            }
	                        });
	                    }
	                    else {
	                        _this.queryForFilterGeometry(_this.filterGeometry);
	                    }
	                }
	            }
	        }, function (error) { console.log(error); });
	    };
	    LegendComponent.prototype.legendDefinitionChange = function (valueFilter, checked, dynamicLayer) {
	        if (checked == false) {
	            var _loop_1 = function (dl) {
	                if (dl["id"] == dynamicLayer["id"] && dl["msId"] == dynamicLayer["msId"]) {
	                    valueFilter.forEach(function (value) {
	                        dl["exceptions"].push(value);
	                    });
	                }
	            };
	            for (var _i = 0, _a = this.dynamicLayers; _i < _a.length; _i++) {
	                var dl = _a[_i];
	                _loop_1(dl);
	            }
	        }
	        else {
	            var _loop_2 = function (dl) {
	                if (dl["id"] == dynamicLayer["id"] && dl["msId"] == dynamicLayer["msId"]) {
	                    valueFilter.forEach(function (value) {
	                        var indexToDelete = dl["exceptions"].indexOf(value);
	                        dl["exceptions"].splice(indexToDelete, 1);
	                    });
	                }
	            };
	            for (var _b = 0, _c = this.dynamicLayers; _b < _c.length; _b++) {
	                var dl = _c[_b];
	                _loop_2(dl);
	            }
	        }
	        this.applyExceptionsToDefinitionExpressions();
	        if (this.geoDefinitionExpressions.length == this.dynamicLayers.length) {
	            this.applyGeoDefinitionExpressions();
	        }
	    };
	    LegendComponent.prototype.applyExceptionsToDefinitionExpressions = function () {
	        for (var _i = 0, _a = this.dynamicLayers; _i < _a.length; _i++) {
	            var dynamicLayer = _a[_i];
	            var subLayer = this._mapService.view.map.findLayerById(dynamicLayer.msId).findSublayerById(dynamicLayer["id"]);
	            if (!dynamicLayer["exceptions"]) {
	                subLayer.definitionExpression = null;
	                continue;
	            }
	            if (dynamicLayer["exceptions"].length > 0) {
	                var definitionExpression = this.generateDefinitionExpression(dynamicLayer);
	                subLayer.definitionExpression = definitionExpression;
	            }
	            else {
	                subLayer.definitionExpression = null;
	            }
	        }
	    };
	    LegendComponent.prototype.generateDefinitionExpression = function (dynamicLayer) {
	        var rendererFields = dynamicLayer["rendererFields"];
	        var exceptionsArray = dynamicLayer["exceptions"];
	        var exceptionsComprArray = [];
	        exceptionsArray.forEach(function (exc) {
	            var excArray;
	            if (dynamicLayer["rendererFields"].length > 1) {
	                excArray = exc.split(dynamicLayer["fieldDelimiter"]);
	            }
	            else {
	                excArray = [exc];
	            }
	            var excArrCorrected = [];
	            excArray.forEach(function (indExc, ind) {
	                indExc = indExc.trim();
	                excArrCorrected.push(indExc);
	            });
	            exceptionsComprArray.push(excArrCorrected);
	        });
	        var definitionExpression = "";
	        exceptionsComprArray.forEach(function (excArr, arrInd) {
	            if (arrInd == 0) {
	                definitionExpression = "NOT (";
	            }
	            else {
	                definitionExpression = definitionExpression + " AND NOT (";
	            }
	            excArr.forEach(function (exc, ind) {
	                if (ind == 0) {
	                    definitionExpression = definitionExpression + rendererFields[ind] + " = " + exc;
	                }
	                else {
	                    definitionExpression = definitionExpression + " AND " + rendererFields[ind] + " = " + exc;
	                }
	            });
	            definitionExpression = definitionExpression + ")";
	        });
	        return definitionExpression;
	    };
	    LegendComponent.prototype.applyGeoDefinitionExpressions = function () {
	        if (this.showOnlyWithinGeometry == true) {
	            for (var _i = 0, _a = this.geoDefinitionExpressions; _i < _a.length; _i++) {
	                var defObject = _a[_i];
	                var subLayer = this._mapService.view.map.findLayerById(defObject["msId"]).findSublayerById(parseInt(defObject["id"]));
	                subLayer.definitionExpression = (subLayer.definitionExpression == "" || subLayer.definitionExpression == null) ? defObject["definitionExpression"] : subLayer.definitionExpression + " AND (" + defObject["definitionExpression"] + ")";
	            }
	        }
	    };
	    LegendComponent.prototype.expandSubLayers = function (dynamicLayer) {
	        for (var i = 0; i < this.dynamicLayers.length; i++) {
	            if (this.dynamicLayers[i]["msId"] == dynamicLayer.msId && this.dynamicLayers[i]["id"] == dynamicLayer.id) {
	                this.dynamicLayers[i]["expanded"] = !dynamicLayer.expanded;
	                return;
	            }
	        }
	    };
	    LegendComponent.prototype.openLegend = function () {
	        this.showLegend = true;
	    };
	    LegendComponent.prototype.removeGeometryFilter = function () {
	        for (var _i = 0, _a = this.dynamicLayers; _i < _a.length; _i++) {
	            var dynamicLayer = _a[_i];
	            if (!dynamicLayer["exceptions"]) {
	                this._mapService.view.map.findLayerById(dynamicLayer["msId"]).findSublayerById(dynamicLayer["id"]).definitionExpression = null;
	                continue;
	            }
	            if (dynamicLayer["exceptions"].length > 0) {
	                var definitionExpression = this.generateDefinitionExpression(dynamicLayer);
	                this._mapService.view.map.findLayerById(dynamicLayer["msId"]).findSublayerById(dynamicLayer["id"]).definitionExpression = definitionExpression;
	            }
	            else {
	                this._mapService.view.map.findLayerById(dynamicLayer["msId"]).findSublayerById(dynamicLayer["id"]).definitionExpression = null;
	            }
	        }
	        this.geoDefinitionExpressions = [];
	        this.filterGeometry = null;
	        this.clearGeomFilterGraphics(["filterPolygon", "pointBuffer"]);
	        //this.showOnlyWithinGeometry = true;
	        this.geometryOptions = false;
	    };
	    LegendComponent.prototype.showGeometryOptions = function () {
	        this.geometryOptions = !this.geometryOptions;
	    };
	    LegendComponent.prototype.clearGeomFilterGraphics = function (graphicTypes) {
	        var mapGraphics = this._mapService.applyGeometryQueryGraphic.graphics["items"];
	        for (var j = (mapGraphics.length - 1); j >= 0; j--) {
	            if (mapGraphics[j].attributes.hasOwnProperty("graphicType") && graphicTypes.indexOf(mapGraphics[j].attributes.graphicType) != -1) {
	                this._mapService.applyGeometryQueryGraphic.graphics.remove(mapGraphics[j]);
	            }
	        }
	    };
	    LegendComponent.prototype.showGeometryOnMap = function (geometry, graphicType) {
	        var graphic = new Graphic();
	        graphic.geometry = geometry;
	        switch (geometry.type) {
	            case "polygon":
	                var fillSymbol = new SimpleFillSymbol();
	                fillSymbol.color = new Color([255, 255, 0, 0.0]);
	                var lineSymbol = new SimpleLineSymbol();
	                lineSymbol.color = new Color([0, 0, 0]);
	                lineSymbol.width = 2;
	                fillSymbol.outline = lineSymbol;
	                graphic.symbol = fillSymbol;
	                graphic.attributes = {};
	                graphic.attributes["graphicType"] = graphicType;
	                break;
	            case "point":
	                var pointSymbol = new PictureMarkerSymbol();
	                pointSymbol.height = 24;
	                pointSymbol.width = 24;
	                pointSymbol.url = this.mapPin;
	                pointSymbol.yoffset = 12;
	                graphic = new Graphic({
	                    geometry: geometry,
	                    symbol: pointSymbol
	                });
	                graphic.attributes = {};
	                graphic.attributes["graphicType"] = graphicType;
	                this._mapService.view.center = geometry;
	                this._mapService.view.zoom = 12;
	                break;
	        }
	        this._mapService.applyGeometryQueryGraphic.graphics.addMany([graphic]);
	    };
	    LegendComponent.prototype.bufferSliderMouseUp = function (event) {
	        var _this = this;
	        this.clearGeomFilterGraphics(["pointBuffer"]);
	        var bufferValue = event.currentTarget.value;
	        this.queryMSIteration = 0;
	        if (bufferValue == "0") {
	            this.geoDefinitionExpressions = [];
	            this.queryForFilterGeometry(this.filterGeometry);
	            return;
	        }
	        this._eventsService.mapUpdateShow(true);
	        this._esriTasksService.bufferFeatures(this.appSettings["GeometryService"]["url"], [this.filterGeometry], [bufferValue], "feet", this._mapService.view.spatialReference).then(function (geometries) {
	            _this._eventsService.mapUpdateShow(false);
	            if (geometries.length > 0) {
	                _this.geoDefinitionExpressions = [];
	                _this._mapService.view.extent = geometries[0].extent;
	                _this.queryForFilterGeometry(geometries[0]);
	                _this.showGeometryOnMap(geometries[0], "pointBuffer");
	            }
	        }, function (error) {
	            _this._eventsService.mapUpdateShow(false);
	            console.log(error);
	        });
	    };
	    LegendComponent.prototype.removePictometry = function () {
	        this._eventsService.disableObliqueImage();
	    };
	    LegendComponent.prototype.generateParcelReport = function () {
	        var _this = this;
	        this.reportID = Math.floor(Math.random() * 1000000000);
	        var currentReportID = this.reportID;
	        this.reportGenerationInProgress = true;
	        this._parcelReportService = new parcelReport_service_1.ParcelReportService(this._esriTasksService, this._mapService, this._eventsService);
	        this.parcelReportElementTitle = "Generating report. Please wait...";
	        this._parcelReportService.activeProject.subscribe(function (thing) {
	            if (_this.reportID == currentReportID) {
	                _this.reportGenerationInProgress = false;
	            }
	        });
	        this._parcelReportService.startParcelReport(this.parcelReportFeature);
	    };
	    LegendComponent.prototype.getParcelFeatureFromCoordinates = function (suggestion) {
	        var _this = this;
	        var layersArray = [{ "Name": "CCGIS.PARCELS", "QueryFilter": "", "Fields": ["PARCEL_C", "STNUMBER", "PRE_DIR", "FULL_STNAME", "CITY", "STATE", "ZIPCODE"], "ReturnGeometry": true }];
	        this._esriTasksService.getAPIPResultsByLocation(this.appSettings["APIPSOEService"]["url"], { "X": suggestion.addressLocation.X, "Y": suggestion.addressLocation.Y }, this.appSettings["Map"]["DefaultSpatialReference"]["wkid"], layersArray).then(function (apipResultsData) {
	            var apipResult = apipResultsData.data;
	            var parcelNumber = apipResult["ResultLayers"][0]["Records"][0]["Values"][0];
	            var parcelAddress = apipResult["ResultLayers"][0]["Records"][0]["Values"][1] + " " + apipResult["ResultLayers"][0]["Records"][0]["Values"][2] + " " + apipResult["ResultLayers"][0]["Records"][0]["Values"][3] + " " + apipResult["ResultLayers"][0]["Records"][0]["Values"][4] + ", " + apipResult["ResultLayers"][0]["Records"][0]["Values"][5] + " " + apipResult["ResultLayers"][0]["Records"][0]["Values"][6];
	            var parcelGraphic = new Graphic();
	            parcelGraphic.attributes = { "Parcel Number": parcelNumber, "Parcel Address": parcelAddress };
	            parcelGraphic.geometry = _this._esriTasksService.gmlToGeometry(_this._mapService.view.spatialReference, apipResult["ResultLayers"][0]["Records"][0]["Geometry"]);
	            _this.parcelReportFeature = parcelGraphic;
	            _this.parcelReportOption = true;
	            _this.reportGenerationInProgress = false;
	            _this.reportID = 0;
	        }, function (error) {
	            console.log(error);
	            _this.parcelReportOption = false;
	        });
	    };
	    LegendComponent.prototype.calculateLegendMaxHeight = function () {
	        var offset = 160;
	        if (this.showAddressComponent) {
	            offset = offset + 40;
	        }
	        if (this.showObliqueImage) {
	            offset = offset + 34;
	        }
	        if (this.showObliqueImage && this.displayObliqueImage) {
	            offset = offset + 300;
	        }
	        if (this.filterGeometry) {
	            offset = offset + 34;
	        }
	        if (this.filterGeometry && this.geometryOptions) {
	            offset = offset + 110;
	        }
	        return 'calc(100% - ' + offset.toString() + 'px)';
	    };
	    LegendComponent.prototype.calculateLegendHeight = function () {
	        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	        if (iOS) {
	            var offset = 160;
	            if (this.showAddressComponent) {
	                offset = offset + 40;
	            }
	            if (this.showObliqueImage) {
	                offset = offset + 34;
	            }
	            if (this.showObliqueImage && this.displayObliqueImage) {
	                offset = offset + 300;
	            }
	            if (this.filterGeometry) {
	                offset = offset + 34;
	            }
	            if (this.filterGeometry && this.geometryOptions) {
	                offset = offset + 110;
	            }
	            return 'calc(100% - ' + offset.toString() + 'px)';
	        }
	        else {
	            return "auto";
	        }
	    };
	    LegendComponent.prototype.legendDivClicked = function () {
	        componentHandler.upgradeAllRegistered();
	        var legendDiv = document.querySelector('.legend-interactive-content');
	    };
	    LegendComponent.prototype.calculateActualElHeight = function () {
	        var totHeight = 0;
	        var legendDivs = document.querySelectorAll('.dynamicLayerDiv');
	        legendDivs.forEach(function (legendDiv) {
	            totHeight = totHeight + legendDiv.clientHeight;
	        });
	        return totHeight + 10 + "px";
	    };
	    return LegendComponent;
	}());
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], LegendComponent.prototype, "appURLCreated", void 0);
	LegendComponent = __decorate([
	    core_1.Component({
	        selector: 'legend-component',
	        template: __webpack_require__(103),
	        styles: [__webpack_require__(104)]
	    }),
	    __param(4, core_1.Inject(parcelReport_service_1.ParcelReportService)),
	    __metadata("design:paramtypes", [core_1.ElementRef, map_service_1.MapService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService, Object])
	], LegendComponent);
	exports.LegendComponent = LegendComponent;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = cloneDeep;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(102)(module)))

/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 103 */
/***/ function(module, exports) {

	module.exports = "<div [style.width]=\"showLegend == true || geometryOptions == true ? '100%' : null\" [style.top]=\"showAddressComponent == true ? '40px' : '2px'\" class=\"legendMainDiv\">\r\n\r\n    <div class=\"obliqueImgChipDiv\" *ngIf=\"showObliqueImage\" [ngClass]=\"{'obliqueImgChipDivMargin': !displayObliqueImage}\">\r\n        <span class=\"mdl-chip mdl-chip--contact mdl-chip--deletable spanChipClass\">\r\n            <div style=\"background-color: rgb(20,40,75); width: 32px; margin-right: 8px; border-radius: 18px; display: inline-block;\">\r\n                <img class=\"mdl-chip__contact\" style=\"padding-left:4px; width:24px; height:24px;\" src=\"{{obliqueImageLogo}}\">\r\n            </div>\r\n            <span class=\"mdl-chip__text geometry-chip_text\">Oblique Image</span>\r\n            <span class=\"mdl-chip__action\">\r\n                <i class=\"material-icons\"  (click)=\"displayObliqueImage = !displayObliqueImage\">{{displayObliqueImage ? \"arrow_drop_up\" : \"arrow_drop_down\"}}</i>\r\n            </span>\r\n            <span class=\"mdl-chip__action\">\r\n                <i class=\"material-icons\" (click)=\"removePictometry()\">cancel</i>\r\n            </span>\r\n        </span>\r\n    </div>\r\n    <div class=\"obliqueImg-card-square mdl-card mdl-shadow--2dp\"  *ngIf=\"showObliqueImage\" [style.display]=\"displayObliqueImage == true ? 'block' : 'none'\">\r\n        <obliquePhoto-component></obliquePhoto-component>\r\n    </div>\r\n\r\n\r\n    <div class=\"legendChipDiv\" [style.display]=\"filterGeometry == null ? 'none' : 'block'\">\r\n        <span class=\"mdl-chip mdl-chip--contact mdl-chip--deletable spanChipClass\" [ngClass]=\"{'geometry-chip-opt-ext':geometryOptions}\">\r\n            <!--<span class=\"mdl-chip__image\">\r\n                <img style=\"width: 32px; height: 32px;\" src=\"{{landUsePlanLogo}}\">\r\n            </span>-->\r\n            <div style=\"background-color: rgb(20,40,75); width: 32px; margin-right: 8px; border-radius: 18px; display: inline-block;\">\r\n                <img class=\"mdl-chip__contact\" src=\"{{geomFilterLogo}}\">\r\n            </div>\r\n            <span class=\"mdl-chip__text geometry-chip_text\">{{geometryFilterType}}</span>\r\n            <span class=\"mdl-chip__action\">\r\n                <i class=\"material-icons\" (click)=\"zoomToGeometry()\">zoom_in</i>\r\n            </span>\r\n            <span *ngIf=\"parcelReportOption\" class=\"mdl-chip__image\" [style.cursor]=\"reportGenerationInProgress == false ? 'pointer' : 'auto'\" title=\"{{parcelReportElementTitle}}\">\r\n                <img style=\"width: 20px; height: 20px;\" src=\"{{reportGenerationInProgress == false ? parcelReportIconPath : parcelReportIconLoading}}\" (click)=\"reportGenerationInProgress == false ? generateParcelReport() : null\">\r\n            </span>\r\n            <span class=\"mdl-chip__action\">\r\n                <i class=\"material-icons\" (click)=\"showGeometryOptions()\">{{geometryOptions ? \"arrow_drop_up\" : \"arrow_drop_down\"}}</i>\r\n            </span>\r\n            <span class=\"mdl-chip__action\">\r\n                <i class=\"material-icons\" (click)=\"removeGeometryFilter($event); filterGeometryObject = null;\">cancel</i>\r\n            </span>\r\n            <!--<img class=\"mdl-chip__contact\" src=\"{{landUsePlanLogo}}\">-->\r\n        </span>\r\n    </div>\r\n    <div class=\"legend-card-square mdl-card mdl-shadow--2dp\" [style.display]=\"geometryOptions == true ? 'block' : 'none'\">\r\n        <div class=\"mdl-card__actions legend-interactive\" style=\"overflow: hidden;\">\r\n            <label class=\"mdl-switch mdl-js-switch mdl-js-ripple-effect\" for=\"geomOnlySwitch\" *ngIf=\"filterGeometry != null\">\r\n                <input type=\"checkbox\" id=\"geomOnlySwitch\" [formControl]=\"onlyGeomControl\" class=\"mdl-switch__input\" [(ngModel)]=\"showOnlyWithinGeometry\">\r\n                <span class=\"mdl-switch__label\">Show only within selected area</span>\r\n            </label>\r\n        </div>\r\n        <div [style.display]=\"filterGeometry != null && filterGeometry.type == 'point' ? 'block' : 'none'\">\r\n            <label>Buffer Radius</label>\r\n            <div class=\"buffer-radius-div\">\r\n                <label style=\"display: table-cell;\">0</label>\r\n                <input class=\"mdl-slider mdl-js-slider\" [ngClass]=\"{iemdlslider: IEbrowser}\" style=\"width:130px\" type=\"range\" min=\"0\" max=\"5280\" value=\"0\" tabindex=\"0\" (mouseup)=\"bufferSliderMouseUp($event)\" (touchend)=\"bufferSliderMouseUp($event)\" [(ngModel)]=\"bufferSliderValue\">\r\n                <label style=\"display: table-cell;\">1 mile</label>\r\n            </div>\r\n        </div>\r\n        <div [style.display]=\"parcelReportOption == true ? 'block' : 'none'\">\r\n            <button class=\"mdl-button mdl-js-button generate-report-button\" [disabled]=\"reportGenerationInProgress\" (click)=\"generateParcelReport()\">\r\n                <span>Generate Report</span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"legendChipDiv\" [style.display]=\"showChip ? 'block' : 'none'\">\r\n        <span class=\"mdl-chip mdl-chip--contact mdl-chip--deletable spanChipClass\">\r\n            <!--<span class=\"mdl-chip__image\">\r\n                <img style=\"width: 32px; height: 32px;\" src=\"{{landUsePlanLogo}}\">\r\n            </span>-->\r\n            <!--<img class=\"mdl-chip__contact\" src=\"{{landUsePlanLogo}}\">-->\r\n            <div [style.background-color]=\"mapLoading ? 'white' : 'rgb(20,40,75)'\" style=\"width: 32px; height:32px; margin-right: 8px; border-radius: 18px; display: inline-block;\">\r\n                <i class=\"material-icons\" [style.height]=\"mapLoading ? '0px' : ''\" [style.padding-top]=\"mapLoading ? '3px' : '3px'\" style=\"color:white; padding-left:4px;\">{{searchModuleIcon}}</i>\r\n                <img [style.display]=\"mapLoading ? 'block' : 'none'\" class=\"loadingImage\" src=\"{{loadingLegendImage}}\">\r\n                <!-- <div [style.display]=\"mapLoading ? 'block' : 'none'\" class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\" style=\"top:2px; left:2px;\"></div> -->\r\n            </div>\r\n            <span class=\"mdl-chip__text geometry-chip_text\" style=\"height:110%\">{{mapLoading ? 'LOADING...' : searchModuleName}}</span>\r\n            <span class=\"mdl-chip__action\" style=\"vertical-align: sub\">\r\n                <!--<i class=\"material-icons\" [ngClass]=\"{showLegendClass:showLegend}\" (click)=\"showLegend = !showLegend\">{{showLegend ? \"arrow_drop_up\" : \"arrow_drop_down\"}}</i>-->\r\n                <i class=\"material-icons\" (click)=\"showLegend = !showLegend\">{{showLegend ? \"arrow_drop_up\" : \"arrow_drop_down\"}}</i>\r\n            </span>\r\n            <!--<img class=\"mdl-chip__contact\" src=\"{{landUsePlanLogo}}\">-->\r\n        </span>\r\n    </div>\r\n\r\n    <div class=\"legend-card-square mdl-card mdl-shadow--2dp legend-content\" style=\"height:auto;\" [ngStyle]=\"{'max-height': calculateLegendMaxHeight(), 'height': calculateLegendHeight()}\" [style.display]=\"showLegend == true ? 'block' : 'none'\">\r\n        <!--<div class=\"mdl-card__title\">\r\n            <h2 class=\"mdl-card__title-text\">Map Legend</h2>\r\n            <i class=\"material-icons close-icon\" (click)=\"hideLegend()\">highlight_off</i>\r\n        </div>-->\r\n        <div class=\"mdl-card__actions mdl-card--border legend-interactive\">\r\n            <div>\r\n                <span [style.display]=\"(legendLoading == true) ? 'block' : 'none'\" style=\"position:absolute; top:50%; left:130px;font-weight:bold;\">Loading...</span>\r\n                <div [style.display]=\"(legendLoading == true) ? 'block' : 'none'\" class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\" style=\"left:150px; top:170px; position:absolute\"></div>\r\n            </div>\r\n            \r\n\r\n            <div *ngFor=\"let dynamicLayer of dynamicLayers\" class=\"dynamicLayerDiv\">\r\n                <div style=\"display: flex;\">\r\n                    <i class=\"mdl-icon-toggle__label material-icons legendExpandIcon\" [style.visibility]=\"(_mapService.view.map.findLayerById(dynamicLayer.msId).findSublayerById(dynamicLayer.id).visible == true) ? 'visible' : 'hidden'\" (click)=\"expandSubLayers(dynamicLayer)\">{{dynamicLayer.expanded == false ? 'keyboard_arrow_right' : 'keyboard_arrow_down'}}</i>\r\n                    <label [style.display]=\"(_mapService.view.scale <= dynamicLayer.minScale || dynamicLayer.minScale == 0) ? 'block' : 'none'\" class=\"mdl-checkbox mdl-js-checkbox legendCheckBox\">\r\n                        <input type=\"checkbox\" class=\"mdl-checkbox__input\" value=\"dynamicLayer.id\" [(ngModel)]=\"_mapService.view.map.findLayerById(dynamicLayer.msId).findSublayerById(dynamicLayer.id).visible\">\r\n\r\n                        <!--<div class=\"colorSquare\" [ngStyle]=\"{'background-color': colorString}\"></div>-->\r\n                        <span class=\"mdl-checkbox__label\" style=\"display:inline;\">{{dynamicLayer.title}}</span>\r\n                        <br/>\r\n                        <!--<br/><img src=\"{{dynamicLayer.symbolUrl}}\"/><span>{{dynamicLayer.count}}</span>-->\r\n                    </label>\r\n                </div>\r\n\r\n                <div [style.display]=\"_mapService.view.map.findLayerById(dynamicLayer.msId).findSublayerById(dynamicLayer.id).visible ? 'block' : 'none'\" style=\"text-align: center\">\r\n                    <label>Opacity</label>\r\n                    <i class=\"mdl-icon-toggle__label material-icons\">opacity</i>\r\n                    <div style=\"display: table; width: 100%;\">\r\n                        <i class=\"mdl-icon-toggle__label material-icons\" style=\"display: table-cell; cursor:default\">panorama_fish_eye</i>\r\n                        <input class=\"mdl-slider mdl-js-slider\" [ngClass]=\"{iemdlslider: IEbrowser}\" type=\"range\" min=\"0\" max=\"1\" value=\"0\" tabindex=\"0\" step=\"0.1\" [(ngModel)]=\"_mapService.view.map.findLayerById(dynamicLayer.msId).findSublayerById(dynamicLayer.id).opacity\">\r\n                        <i class=\"mdl-icon-toggle__label material-icons\" style=\"display: table-cell; cursor:default\">lens</i>\r\n                    </div>\r\n                </div>\r\n                \r\n                <div [style.display]=\"dynamicLayer.expanded == true ? 'block' : 'none'\">\r\n                    <div [style.display]=\"(_mapService.view.map.findLayerById(dynamicLayer.msId).findSublayerById(dynamicLayer.id).visible == true) ? 'block' : 'none'\" class=\"drawLabels\" *ngFor=\"let di of dynamicLayer.drawingInfo\">\r\n                        <label class=\"mdl-checkbox mdl-js-checkbox legendCheckBox\" *ngIf=\"di.value != ''\">\r\n                            <input type=\"checkbox\" class=\"mdl-checkbox__input\" value=\"{{di.value}}\" checked=\"false\" [(ngModel)]=\"di.visible\" (change)=\"legendDefinitionChange(di.value, $event.currentTarget.checked, dynamicLayer)\">\r\n                            <img src=\"{{di.imageUrl}}\"/><span>{{di.label}}</span>\r\n                        </label>\r\n                        <img *ngIf=\"di.value == ''\" src=\"{{di.imageUrl}}\"/>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            \r\n        </div>\r\n    </div>\r\n\r\n</div>";

/***/ },
/* 104 */
/***/ function(module, exports) {

	module.exports = ".legendMainDiv{\r\n    position: absolute; \r\n    right:5px; \r\n    z-index: 14; \r\n    max-height:calc(100% - 100px); \r\n    max-width: 460px;\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n    .legendMainDiv {\r\n        max-width: 310px;\r\n    }\r\n}\r\n\r\n.legend-card-square.mdl-card {\r\n    width: 308px;\r\n    /*height: 320px;*/\r\n    /*position: absolute;*/\r\n    /*right: 0px;\r\n    top: 57px;*/\r\n    background: rgba(250, 250, 250, 0.92);\r\n    min-height: 0px;\r\n    /*height:100%;*/\r\n    overflow: auto;\r\n    /* max-height: calc(100% - 310px); */\r\n    word-wrap: break-word;\r\n    border-radius: 4px;\r\n    margin-left: 150px;\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n    .legend-card-square.mdl-card {\r\n        margin-left: 0px;\r\n    }\r\n}\r\n\r\n.obliqueImg-card-square.mdl-card {\r\n    width: 458px;\r\n    background: rgba(250, 250, 250, 0.92);\r\n    min-height: 0px;\r\n    overflow: auto;\r\n    max-height: calc(100% - 310px);\r\n    word-wrap: break-word;\r\n    border-radius: 4px;\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n    .obliqueImg-card-square.mdl-card {\r\n        width: 308px;\r\n    }\r\n}\r\n\r\n.legend-oblique-active{\r\n    max-height: calc(100% - 470px) !important;\r\n}\r\n\r\n.legend-content{\r\n    position: fixed;\r\n}\r\n\r\n.legend-card-square > .mdl-card__title {\r\n    color: #fff;\r\n    background:rgba(20, 40, 90, 0.99);\r\n    padding-bottom: 5px;\r\n    padding-top: 5px;\r\n    padding-left: 5px;\r\n}\r\n\r\n.legend-card-square {\r\n  /*max-height:calc(100% - 150px);*/\r\n  background-color: rgba(250, 250, 250, 0.99);\r\n  z-index: 10;\r\n}\r\n\r\n.legend-interactive{\r\n  overflow-y: auto;\r\n  padding-top: 2px;\r\n  padding-bottom: 2px;\r\n  /*max-height:500px;*/\r\n  height: 100%;\r\n}\r\n\r\n.legend-interactive-content{\r\n    overflow-y: auto;\r\n    padding-top: 2px;\r\n    padding-bottom: 2px;\r\n    max-height:400px;\r\n    height:1000px;\r\n    min-height: 200px;\r\n}\r\n\r\n.legendCheckBox{\r\n    margin-bottom: 0px;\r\n    height:auto;\r\n    padding-left: 24px;\r\n}\r\n\r\n.drawLabels{\r\n    margin-left:40px;\r\n}\r\n\r\n.legendExpandIcon{\r\n    height:16px;\r\n    line-height:24px;\r\n    min-width:8px;\r\n    width:10px;\r\n    padding-right: 15px;\r\n}\r\n\r\n.showLegendClass{\r\n    color: #14284B;\r\n    background-color: #ED1C24;\r\n    border-radius: 50%;\r\n}\r\n\r\n.legendChipDiv{\r\n    max-width: 310px; \r\n    z-index: 14; \r\n    top: 60px;\r\n    margin-left: 150px;\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n    .legendChipDiv {\r\n        margin-left: 0px;\r\n    }\r\n}\r\n\r\n.obliqueImgChipDiv{\r\n    max-width: 410px; \r\n    z-index: 14; \r\n    top: 60px;\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n    .obliqueImgChipDiv {\r\n        max-width: 310px;\r\n    }\r\n}\r\n\r\n.obliqueImgChipDivMargin{\r\n    margin-left: 150px;\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n    .obliqueImgChipDivMargin {\r\n        margin-left: 0px;\r\n    }\r\n}\r\n\r\n.geometry-chip_text{\r\n    white-space: normal;\r\n    line-height: normal;\r\n    max-width: 165px;\r\n}\r\n\r\n.geometry-chip-opt-ext{\r\n    /* border-bottom-left-radius: 0px;\r\n    border-bottom-right-radius: 0px;\r\n    width:calc(100% - 4px); */\r\n}\r\n\r\n.geometry-chip-opt-ext > .geometry-chip_text{\r\n    /* width: calc(100% - 70px); */\r\n}\r\n\r\n.spanChipClass{\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\r\n    background-color: white; \r\n    max-width: 100%; \r\n    margin: 1px;\r\n}\r\n\r\n.generate-report-button{\r\n    color: white;\r\n    max-width: 180px;\r\n    width: auto;\r\n    line-break: auto;\r\n    height: auto;\r\n    /* line-height: 17px; */\r\n    cursor: pointer;\r\n    background-color: rgb(192, 11, 11);\r\n    border-style: outset;\r\n}\r\n\r\n.buffer-radius-div{\r\n    display: flex; \r\n    width: 100%; \r\n    align-items:center;\r\n}\r\n\r\n.loadingImage{\r\n    width:32px; \r\n    height:32px; \r\n    background-color:white; \r\n    border-radius:16px; \r\n    top:-43px;\r\n    position: relative;\r\n}\r\n\r\n.dynamicLayerDiv{\r\n    display: block;\r\n}\r\n\r\n.iemdlslider {\r\n    height:20px;\r\n    width:200px;\r\n    margin-left:20px;\r\n    margin-right: 7px;\r\n}\r\n\r\n.mdl-slider::-ms-thumb{\r\n    background: white !important;\r\n    border-style: solid !important;\r\n    border-color: black !important;\r\n    border-width: 1px;\r\n}\r\n\r\n.mdl-slider::-webkit-slider-thumb{\r\n    background: white !important;\r\n    border-style: solid !important;\r\n    border-color: black !important;\r\n    border-width: 1px;\r\n    height:15px !important;\r\n    width:15px !important;\r\n}"

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var map_service_1 = __webpack_require__(62);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var SearchModuleComponent = (function () {
	    function SearchModuleComponent(elRef, _mapService, _eventsService, _esriTasksService) {
	        this.elRef = elRef;
	        this._mapService = _mapService;
	        this._eventsService = _eventsService;
	        this._esriTasksService = _esriTasksService;
	        this.appSettings = null;
	        this.searchComponentOn = true;
	    }
	    SearchModuleComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._eventsService.searchToolShow$.subscribe(function (evt) {
	            if (evt == false) {
	                setTimeout(function () {
	                    _this.searchComponentOn = evt;
	                }, 1000);
	            }
	        });
	    };
	    SearchModuleComponent.prototype.selectFilterTool = function (ev) {
	        if (this.searchComponentOn == true) {
	            this._eventsService.searchToolShow(false);
	            this.searchComponentOn = false;
	        }
	        else {
	            this._eventsService.searchToolShow(true);
	            this.searchComponentOn = true;
	        }
	    };
	    return SearchModuleComponent;
	}());
	SearchModuleComponent = __decorate([
	    core_1.Component({
	        selector: 'searchModule-component',
	        template: __webpack_require__(106),
	        styles: [__webpack_require__(107)]
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, map_service_1.MapService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService])
	], SearchModuleComponent);
	exports.SearchModuleComponent = SearchModuleComponent;


/***/ },
/* 106 */
/***/ function(module, exports) {

	module.exports = "<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect\" id=\"filter-label\" title=\"Show available modules\" [ngClass]=\"{'is-checked':searchComponentOn}\">\r\n    <input type=\"\" id=\"filter-icon\" class=\"mdl-icon-toggle__input\" name=\"filterActive\" value=\"Filter\" checked style=\"visibility: hidden\" (click)=\"selectFilterTool($event)\">\r\n    <i class=\"mdl-icon-toggle__label material-icons\">menu</i>\r\n    <!--<div class=\"mdl-tooltip mdl-tooltip--large\" for=\"filter-label\">\r\n        Search Module\r\n    </div>-->\r\n</label>\r\n\r\n<!-- <button class=\"mdl-button mdl-js-button search-modules-button\">\r\n    <span>Search Modules</span>\r\n</button> -->\r\n\r\n<div class=\"listDiv\" style=\"visibility: hidden\">\r\n    <div class=\"anchorDiv\"></div>\r\n    <!--<div class=\"anchorDivHelper\"></div>-->\r\n    <div class=\"arrow-up\"></div>\r\n    <ul class=\"demo-list-item mdl-list filterModuleList\">\r\n        <li class=\"mdl-list__item filterModuleListItem\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n                <i class=\"material-icons mdl-list__item-icon\">check</i>\r\n                Transportation Plan\r\n            </span>\r\n        </li>\r\n        <li class=\"mdl-list__item filterModuleListItem\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n                <i class=\"material-icons mdl-list__item-icon\">check</i>\r\n                Land Use Plan\r\n            </span>\r\n        </li>\r\n        <li class=\"mdl-list__item filterModuleListItem\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n                <i class=\"material-icons mdl-list__item-icon\">check</i>\r\n                Special Districts Plan\r\n            </span>\r\n        </li>\r\n        <li class=\"mdl-list__item filterModuleListItem\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n                <i class=\"material-icons mdl-list__item-icon\">check</i>\r\n                Current Initiatives\r\n            </span>\r\n        </li>\r\n        <li class=\"mdl-list__item filterModuleListItem\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n                <i class=\"material-icons mdl-list__item-icon\">check</i>\r\n                Custom Selection\r\n            </span>\r\n        </li>\r\n    </ul>\r\n</div>\r\n";

/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports = ".mdl-icon-toggle.is-checked .mdl-icon-toggle__label { \r\n    color:#FFFFFF; \r\n    background-color:red; \r\n}\r\n\r\n.mdl-icon-toggle__label {\r\n    color:#A2A0A0\r\n}\r\n\r\n.mdl-button .material-icons {\r\n    color:#A2A0A0\r\n}\r\n\r\n.filterModuleList{\r\n    top: 25px;\r\n    position: absolute;\r\n    display: block;\r\n    border-style: solid;\r\n    z-index: 10;\r\n    background-color:#FFFFFF;\r\n    max-height: 240px;\r\n    overflow-y: auto;\r\n    border-color: gray;\r\n    margin-top: 5px;\r\n    margin-bottom: 5px; \r\n    padding-top:0px;\r\n    padding-bottom:0px;\r\n}\r\n\r\n.filterModuleList > li:hover {\r\n    background-color: #ED1C24;\r\n    cursor: pointer;\r\n}\r\n\r\n.filterModuleListItem{\r\n    padding-top:5px;\r\n    padding-bottom:5px;\r\n}\r\n\r\n.listDiv{\r\n    position: absolute; \r\n    top: 11px;\r\n}\r\n\r\n.anchorDiv{\r\n    width: 13px;\r\n    height: 13px;\r\n    position: absolute;\r\n    top: 25px;\r\n    left:7px;\r\n    transform:rotate(45deg);\r\n    background-color: white;\r\n    border-style: solid;\r\n    border-color: gray;\r\n}\r\n\r\n.anchorDivHelper{\r\n    /*position: absolute;\r\n    width:16px;\r\n    background-color: white;\r\n    z-index: 12;\r\n    height: 5px;\r\n    top: 30px;\r\n    left: 9px;*/\r\n    width: 12px;\r\n    height: 12px;\r\n    position: absolute;\r\n    top: 27px;\r\n    left:10px;\r\n    transform:rotate(45deg);\r\n    background-color: white;\r\n    border-style: none;\r\n    border-color: gray;\r\n    z-index: 12;\r\n}\r\n\r\n.arrow-up {\r\n    position: absolute;\r\n    top: 25px;\r\n    left: 8px;\r\n    z-index: 12;\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 8px solid transparent;\r\n    border-right: 8px solid transparent;\r\n    border-bottom: 8px solid white;\r\n}\r\n\r\n.search-modules-button{\r\n    color: white;\r\n    max-width: 100px;\r\n    width: auto;\r\n    line-break: auto;\r\n    height: auto;\r\n    cursor: pointer;\r\n    background-color: rgb(192, 11, 11);\r\n    border-style: outset;\r\n    line-height:16px;\r\n}"

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var config_1 = __webpack_require__(60);
	var map_service_1 = __webpack_require__(62);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var http_1 = __webpack_require__(25);
	var SearchToolComponent = (function () {
	    function SearchToolComponent(elRef, _mapService, _eventsService, _esriTasksService, http, jsonp) {
	        this.elRef = elRef;
	        this._mapService = _mapService;
	        this._eventsService = _eventsService;
	        this._esriTasksService = _esriTasksService;
	        this.http = http;
	        this.jsonp = jsonp;
	        this.appSettings = null;
	        this.searchModules = [];
	        this.showSearchOptions = false;
	        this.logoImageSource = "./images/DMD-Logo.png";
	        this.spinningImg = "./images/InternetSlowdown_Day.gif";
	        this.operationalLayersCount = 0;
	        this.localStorage = window.localStorage;
	        this.urlSearchObject = "";
	        this.showParcelReportWidget = new core_1.EventEmitter();
	        this.disclaimerText = "";
	    }
	    SearchToolComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.appSettings = config_1.Config.config[0];
	        this.disclaimerText = this.appSettings["WelcomeDisclaimer"];
	        this.searchModules = this.appSettings["SearchModules"];
	        this._eventsService.dynamicLayerViewCreated$.subscribe(function (show) {
	            _this.operationalLayersCount++;
	            if (_this.appSettings["Map"]["Layers"]["OperationalLayers"].length == _this.operationalLayersCount) {
	                _this._eventsService.savedSearchSelect$.subscribe(function (savedSearch) {
	                    _this.showSelectedModule(savedSearch);
	                });
	                if (_this.urlSearchObject == "") {
	                    _this.showSearchOptions = true;
	                }
	                else {
	                    _this.getSearchObjectByQueryID();
	                }
	            }
	        });
	    };
	    SearchToolComponent.prototype.getSearchObjectByQueryID = function () {
	        var _this = this;
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        var options = new http_1.RequestOptions({ headers: headers });
	        var msgBody = { "queryCode": this.urlSearchObject };
	        this.http.post(this.appSettings["URLShortener"]["getQueryURL"], msgBody, options).toPromise().then(function (response) {
	            var queryString = response.json();
	            console.log(queryString);
	            if (queryString != "") {
	                try {
	                    var urlSearchObject = JSON.parse(queryString);
	                }
	                catch (err) {
	                    urlSearchObject = undefined;
	                    _this.showSearchOptions = true;
	                }
	                if (urlSearchObject != undefined && urlSearchObject["module"] && urlSearchObject["extent"]) {
	                    if (urlSearchObject["geometry"] != null) {
	                        var geometryObject = {};
	                        geometryObject["geometry"] = urlSearchObject["geometry"];
	                        geometryObject["buffer"] = urlSearchObject["buffer"];
	                        geometryObject["showOnlyWithinGeometry"] = urlSearchObject["showOnlyWithinGeometry"];
	                        _this._eventsService.setSavedGeometry(geometryObject);
	                    }
	                    _this.showSelectedModule(urlSearchObject["module"]);
	                    _this._mapService.view.extent = urlSearchObject["extent"];
	                }
	                _this.showSearchOptions = true;
	            }
	        }).catch(function (e) {
	            console.log(e);
	            _this.showSearchOptions = true;
	        });
	    };
	    SearchToolComponent.prototype.showSelectedModule = function (moduleObject) {
	        this._eventsService.moduleSelect(moduleObject);
	        this.hideSearchTool();
	    };
	    SearchToolComponent.prototype.hideSearchTool = function () {
	        this._eventsService.searchToolShow(false);
	    };
	    SearchToolComponent.prototype.getLastSavedSearch = function () {
	        var savedSearch = JSON.parse(window.localStorage.getItem("PlanIndy_saved_search"));
	        if (savedSearch["geometry"] != null) {
	            var geometryObject = {};
	            geometryObject["geometry"] = savedSearch["geometry"];
	            geometryObject["buffer"] = savedSearch["buffer"];
	            geometryObject["showOnlyWithinGeometry"] = savedSearch["showOnlyWithinGeometry"];
	            this._eventsService.setSavedGeometry(geometryObject);
	        }
	        this._eventsService.savedSearchSelect(savedSearch["module"]);
	        this._mapService.view.extent = savedSearch["extent"];
	    };
	    return SearchToolComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], SearchToolComponent.prototype, "urlSearchObject", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], SearchToolComponent.prototype, "showParcelReportWidget", void 0);
	SearchToolComponent = __decorate([
	    core_1.Component({
	        selector: 'searchTool-component',
	        template: __webpack_require__(109),
	        styles: [__webpack_require__(110)]
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, map_service_1.MapService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService, http_1.Http, http_1.Jsonp])
	], SearchToolComponent);
	exports.SearchToolComponent = SearchToolComponent;


/***/ },
/* 109 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mblSimpleDialogCover\"></div>\r\n\r\n\r\n<div class=\"mdlGrid-searchTool-container\">\r\n    \r\n    <!--<div class=\"mdlGrid-searchTool\">-->\r\n        <!--<div style=\"position:fixed; width:calc(90% - 15px);  margin: 0 auto; background-color:whitesmoke; z-index:100\">-->\r\n        <div class=\"mdlGrid-searchTool-container-top-part\">\r\n            <!--<i class=\"material-icons close-icon\" style=\"float:right; cursor: pointer;\" (click)=\"hideSearchTool()\">highlight_off</i>-->\r\n            <img style=\"width:200px; height:145px;\" src=\"{{logoImageSource}}\"/><br/>\r\n            <span>{{disclaimerText}}</span><br>\r\n            <button class=\"mdl-button mdl-js-button mdl-button--raised mdl-button--colored\" (click)=\"showParcelReportWidget.next()\">\r\n                    Generate Parcel Report\r\n            </button>\r\n        </div>\r\n        <!-- Search options buttons-->\r\n        <div class=\"content-grid mdl-grid grid-content-searchTool\" style=\"margin-top:20px;\">\r\n            <div class=\"mdl-cell mdl-cell-searchTool\" style=\"width:100%\" [style.display]=\"(showSearchOptions == true) ? 'none' : 'block'\">\r\n                <img style=\"max-height:100%; max-width:100%;\" src=\"{{spinningImg}}\"/>\r\n            </div>\r\n            <div class=\"mdl-cell mdl-cell-searchTool\" *ngFor=\"let module of searchModules\" [style.display]=\"(showSearchOptions == true) ? 'block' : 'none'\">\r\n                <button (click)=\"showSelectedModule(module)\" class=\"mdl-button mdl-js-button mdl-button--raised searchTool-button\" style=\"color:white;\" [style.background]=\"module.BackgroundColor ? module.BackgroundColor : 'rgb(20, 40, 75)'\">\r\n                    <span>\r\n                        <i class=\"material-icons\">{{module.Icon}}</i>\r\n                    </span><br/>\r\n                    <span>{{module.Name}}</span><br/>\r\n                    <span class=\"module-subtitle\">{{module.Subtitle}}</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"mdl-cell mdl-cell-searchTool\" *ngIf=\"localStorage.getItem('PlanIndy_saved_search') != null\" [style.display]=\"(showSearchOptions == true) ? 'block' : 'none'\">\r\n                <button (click)=\"getLastSavedSearch()\" class=\"mdl-button mdl-js-button mdl-button--raised searchTool-button\" style=\"background:#dc863a; color:white;\">\r\n                    <span>\r\n                        <i class=\"material-icons\">collections_bookmark</i>\r\n                    </span><br/>\r\n                    <span>Last Saved Search</span><br/>\r\n                    <span class=\"module-subtitle\">The last search saved in this browser</span>\r\n                </button>\r\n            </div>\r\n            <!-- <div class=\"mdl-cell mdl-cell-searchTool\" [style.display]=\"(showSearchOptions == true) ? 'block' : 'none'\">\r\n                <button (click)=\"generateParcelReport()\" class=\"mdl-button mdl-js-button mdl-button--raised searchTool-button\" style=\"background:#dc863a; color:white; border-style:outset;\">\r\n                    <span>\r\n                        <i class=\"material-icons\">collections_bookmark</i>\r\n                    </span><br/>\r\n                    <span>Generate Parcel Report</span><br/>\r\n                    <span style=\"font-size: 10px;\">Generate a comprehensive report for selected parcel</span>\r\n                </button>\r\n            </div> -->\r\n        </div>\r\n    <!--</div>-->\r\n</div>\r\n";

/***/ },
/* 110 */
/***/ function(module, exports) {

	module.exports = ".mdlGrid-searchTool{\r\n    /*position: relative;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    z-index: 100;\r\n    vertical-align: middle;\r\n    width: 90%;\r\n    background-color: whitesmoke;\r\n    margin:0 auto;*/\r\n}\r\n\r\n.mdl-cell-searchTool{\r\n    text-align: center;\r\n}\r\n\r\n/*.mdl-cell-searchTool > span{\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n}*/\r\n\r\n.mdlGrid-searchTool-container{\r\n    max-width:1000px;\r\n    width:90%;\r\n    position: relative;\r\n    background-color: whitesmoke;\r\n    z-index: 102;\r\n    /*top: 50%;\r\n    transform: translateY(-50%);*/\r\n    max-height:90%;\r\n    height:auto;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    margin-top: 50px;\r\n    margin-bottom: 50px;\r\n    overflow: auto;\r\n    border-style: inset;\r\n}\r\n\r\n.mdlGrid-searchTool-container-top-part{\r\n    top: 5px;\r\n    position:relative; \r\n    width:calc(90% - 15px);  \r\n    margin: 0 auto; \r\n    background-color:whitesmoke; \r\n    z-index:100; \r\n    text-align:center;\r\n}\r\n\r\n.grid-content-searchTool{\r\n    overflow: auto;\r\n    max-height: 100%;\r\n    /*height: 400px;*/\r\n    padding-bottom: 0px;\r\n    padding-top: 0px;\r\n}\r\n\r\n.searchTool-button{\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n@keyframes bounceIn {\r\n  0% {\r\n    transform: scale(0.1);\r\n    opacity: 0;\r\n  }\r\n  60% {\r\n    transform: scale(0.8);\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.module-subtitle{\r\n    font-size: 10px;\r\n    line-height: 25px;\r\n    display: inline-block;\r\n}\r\n\r\n/*.mdlGrid-searchTool-container {\r\n  animation-duration: 2s;\r\n  animation-name: bounceIn;\r\n}*/\r\n\r\n"

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var config_1 = __webpack_require__(60);
	var http_1 = __webpack_require__(25);
	var EmailComponent = (function () {
	    //  inject necessary services
	    function EmailComponent(elRef, http) {
	        this.elRef = elRef;
	        this.http = http;
	        this.displayStatus = new core_1.EventEmitter();
	        this.isDisplayed = false;
	        this.jsonpCallback = "?method=JSONP_CALLBACK";
	    }
	    //initialize email objects 
	    EmailComponent.prototype.ngOnInit = function () {
	        this.appSettings = config_1.Config.config[0];
	        //update chnages in the DOM
	        componentHandler.upgradeAllRegistered();
	        //get email inputs
	        var fromInput = document.getElementById('fromemail');
	        var toInput = document.getElementById('toemail');
	        // //if there is an address in local storage
	        this.fromAddress = window.localStorage.getItem("planIndyFromEmail");
	        this.fromAddress ? toInput.focus() : fromInput.focus();
	        //update chnages in the DOM
	        componentHandler.upgradeAllRegistered();
	        //set necessary styles
	        fromInput ? fromInput.parentElement.classList.add('is-dirty') : console.log("from email input is undefined");
	        fromInput ? fromInput.parentElement.classList.remove('is-invalid') : console.log("from email input is undefined");
	    };
	    // destroy 
	    EmailComponent.prototype.ngOnDestroy = function () {
	    };
	    //emit the event telling the parent component to show the panel
	    EmailComponent.prototype.showPanel = function () {
	        //this.isDisplayed = true;
	        this.displayStatus.emit(true);
	    };
	    //emit the event telling the parent component to hide the panel
	    EmailComponent.prototype.closePanel = function () {
	        this.displayStatus.emit(false);
	    };
	    //trigger the send email
	    EmailComponent.prototype.sendEmail = function () {
	        //create the message object to send to the service
	        this.message = JSON.stringify({
	            "toAddress": this.toAddress,
	            "fromAddress": this.fromAddress,
	            "subject": this.emailSubject,
	            "body": this.emailBody
	        });
	        ///The proxy.ashx does not work on the node, needs to be on IIS
	        var urlEndpoint = this.appSettings["EmailService"]["url"] + this.jsonpCallback;
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        var options = new http_1.RequestOptions({ headers: headers });
	        this.http.post(urlEndpoint, this.message, options)
	            .toPromise()
	            .then(function (response) {
	            var responseObj = response.json();
	        })
	            .catch(function (error) {
	            console.log(error);
	        });
	        window.localStorage.setItem("planIndyFromEmail", this.fromAddress);
	        // window.localStorage.setItem("planIndyToEmail",this.toAddress );
	        //close the dialog
	        this.displayStatus.emit(false);
	    };
	    return EmailComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], EmailComponent.prototype, "emailSubject", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], EmailComponent.prototype, "emailBody", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], EmailComponent.prototype, "displayStatus", void 0);
	EmailComponent = __decorate([
	    core_1.Component({
	        selector: 'email-panel',
	        template: __webpack_require__(112)
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, http_1.Http])
	], EmailComponent);
	exports.EmailComponent = EmailComponent;


/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports = "<div id=\"emailModal\" class=\"modal-dialog\" >\r\n<!--header-->\r\n  <div class=\"demo-card-square mdl-card mdl-shadow--2dp\" style=\"margin: 0 auto\">\r\n    <div class=\"mdl-card__title\">\r\n        <h1 class=\"mdl-card__title-text\">Share selection via email:</h1>\r\n                <div class=\"mdl-layout-spacer\"></div>\r\n                  <button id=\"btnCloseDialog\" class=\"mdl-button mdl-js-button mdl-button--icon\" (click)=\"closePanel()\">    \r\n                    <i class=\"material-icons\">cancel</i>\r\n                </button>\r\n    </div>\r\n  <!--from/to email inputs-->\r\n    <div class=\"mdl-card__supporting-text\" >\r\n        <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label\">\r\n          <input class=\"mdl-textfield__input\" type=\"email\" id=\"fromemail\" [(ngModel)]=\"fromAddress\" value={{fromAddress}} required />\r\n          <label class=\"mdl-textfield__label\" for=\"fromemail\">From Email Address</label>\r\n        </div>\r\n          <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label\">\r\n          <input class=\"mdl-textfield__input\" type=\"email\" id=\"toemail\" [(ngModel)]=\"toAddress\" value={{toAddress}} required />\r\n          <label class=\"mdl-textfield__label\" for=\"toemail\">To Email Address</label>\r\n        </div>\r\n    </div>\r\n  <!--footer and submit button-->\r\n      <div class=\"mdl-card__actions mdl-card--border\">\r\n          <button  class=\"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect\" [disabled]=\"!fromAddress || !toAddress\" (click)=\"sendEmail()\">Send\r\n          </button>\r\n      </div>\r\n  </div>\r\n</div> ";

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var config_1 = __webpack_require__(60);
	var http_1 = __webpack_require__(25);
	var EventsService_1 = __webpack_require__(31);
	var ObliquePhotoComponent = (function () {
	    function ObliquePhotoComponent(elRef, http, _eventsService) {
	        this.elRef = elRef;
	        this.http = http;
	        this._eventsService = _eventsService;
	        this.appSettings = null;
	        this.iFrameSource = "";
	        this.ipa = null;
	        this.coordinates = null;
	        this.showWindow = true;
	    }
	    ObliquePhotoComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.appSettings == null) {
	            this.appSettings = config_1.Config.config[0];
	        }
	        //var dndMover:any = new move.constrainedMoveable(dom.byId("pictometry_ipa_div"));
	        /**In case if floating and movable are enabled**/
	        // var dnd:dojo.dnd.Moveable = new Moveable(dom.byId("pictometry_ipa_div"));
	        // define(["dojox/layout/ResizeHandle"], function(resizeHandle){
	        //     var handle = document.createElement('div');
	        //     dom.byId("pictometry_ipa_div").appendChild(handle);
	        //     var resizer = new resizeHandle({
	        //         targetId: "pictometry_ipa_div",
	        //         activeResize: false
	        //     },handle);
	        //     resizer.startup();
	        // });
	        this.locationSubscription = this._eventsService.ipaSetLocation$.subscribe(function (coordinates) {
	            _this.coordinates = coordinates;
	            if (_this.ipa) {
	                _this.ipa.setPreferences({
	                    enableSynchronization: false
	                });
	            }
	            _this.setLocation();
	        });
	        if (typeof window["PictometryHost"] === 'undefined') {
	            this.loadPictometryScript();
	        }
	        else {
	            this.loadPictometryIPA();
	        }
	    };
	    ObliquePhotoComponent.prototype.loadPictometryScript = function () {
	        var newScript = document.createElement('script');
	        newScript.setAttribute('type', 'text/javascript');
	        newScript.setAttribute('src', this.appSettings["ObliquePhotos"]["polScript"]);
	        newScript.onload = this.loadPictometryIPA.bind(this);
	        // if (newScript.addEventListener) {
	        //     newScript.addEventListener('load', this.loadPictometryIPA, false);
	        // }
	        document.getElementsByTagName('head')[0].appendChild(newScript);
	    };
	    ObliquePhotoComponent.prototype.loadPictometryIPA = function () {
	        var _this = this;
	        var headers = new http_1.Headers({ 'Content-Type': 'application/xml' });
	        var options = new http_1.RequestOptions({ headers: headers });
	        this.http.get(this.appSettings["ObliquePhotos"]["polService"]).toPromise().then(function (response) {
	            console.log(response);
	            if (DOMParser) {
	                var parser = new DOMParser();
	                var xmlDoc = parser.parseFromString(response["_body"], "text/xml");
	            }
	            else {
	                xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
	                xmlDoc.async = false;
	                xmlDoc.loadXML(response["_body"]);
	            }
	            console.log(xmlDoc.getElementsByTagName("string")[0].childNodes[0].nodeValue);
	            var ifrSource = xmlDoc.getElementsByTagName("string")[0].childNodes[0].nodeValue + "&app_id=" + 'pictometry_ipa';
	            _this.pictometry_ipa.nativeElement.setAttribute('src', ifrSource);
	            if (!_this.ipa) {
	                _this.ipa = new window["PictometryHost"]('pictometry_ipa', _this.appSettings["ObliquePhotos"]["polWindow"]);
	                _this.ipa.ready = _this.ipaReady.bind(_this);
	                _this.ipa.error = _this.ipaError.bind(_this);
	            }
	        }).catch(function (err) {
	            console.log(err);
	        });
	    };
	    ObliquePhotoComponent.prototype.ipaReady = function () {
	        this.ipa.showDashboard({ dualPane: false });
	        this.ipa.showDashboard({
	            dualPane: false
	        });
	        this.ipa.setPreferences({
	            enableSynchronization: true
	        });
	        this.ipa.addListener('synchronize', this.ipaSynchronize.bind(this));
	        this.ipa.addListener('onchangeview', this.changeView.bind(this));
	        this.setLocation();
	        // this.ipa.setLocation({
	        //     y: 39.768883,       // Latitude
	        //     x: -86.158220,      // Longitude
	        //     zoom: 17            // Optional Zoom level
	        // })
	    };
	    ObliquePhotoComponent.prototype.ipaError = function (error) {
	        console.log(error);
	    };
	    ObliquePhotoComponent.prototype.ipaSynchronize = function (view) {
	        this._eventsService.ipaSyncLocation(view);
	    };
	    ObliquePhotoComponent.prototype.changeView = function (view) {
	        console.log("view change");
	        if (this.ipa) {
	            this.ipa.setPreferences({
	                enableSynchronization: true
	            });
	        }
	    };
	    ObliquePhotoComponent.prototype.setLocation = function () {
	        if (this.coordinates && this.ipa) {
	            this.showWindow = true;
	            this.ipa.setLocation(this.coordinates);
	        }
	    };
	    // destroy 
	    ObliquePhotoComponent.prototype.ngOnDestroy = function () {
	        // if(this.ipa){
	        //     (this.ipa as any).destroy()
	        // }
	        // if(this.coordinates){
	        //     (this.coordinates as any).destroy()
	        // }
	        if (this.ipa) {
	            this.ipa.ready = null;
	            this.ipa.removeListener('synchronize', this.ipaSynchronize.bind(this));
	            this.ipa.removeListener('onchangeview', this.changeView.bind(this));
	        }
	        this.ipa = null;
	        this.coordinates = null;
	        this.locationSubscription.unsubscribe();
	    };
	    ObliquePhotoComponent.prototype.closePanel = function () {
	        this._eventsService.disableObliqueImage();
	    };
	    return ObliquePhotoComponent;
	}());
	__decorate([
	    core_1.ViewChild('pictometry_ipa'),
	    __metadata("design:type", core_1.ElementRef)
	], ObliquePhotoComponent.prototype, "pictometry_ipa", void 0);
	ObliquePhotoComponent = __decorate([
	    core_1.Component({
	        selector: 'obliquePhoto-component',
	        template: __webpack_require__(114),
	        styles: [__webpack_require__(115)]
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, http_1.Http, EventsService_1.EventsService])
	], ObliquePhotoComponent);
	exports.ObliquePhotoComponent = ObliquePhotoComponent;


/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = "<div id=\"pictometry_ipa_div\" class=\"pictometry_ipa_div_class\" [style.display]=\"showWindow ? 'block' : 'none'\">\r\n    <!--<div class=\"mdl-card__title headerClass\">\r\n        <h1 class=\"mdl-card__title-text\">Oblique Photography</h1>\r\n                <div class=\"mdl-layout-spacer\"></div>\r\n                  <button id=\"btnCloseDialog\" class=\"mdl-button mdl-js-button mdl-button--icon\" (click)=\"closePanel()\">    \r\n                    <i class=\"material-icons\">cancel</i>\r\n                </button>\r\n    </div>-->\r\n    <iframe id=\"pictometry_ipa\" #pictometry_ipa class=\"oblique-photo-iframe\" src=\"\"></iframe>\r\n</div>";

/***/ },
/* 115 */
/***/ function(module, exports) {

	module.exports = ".headerClass{\r\n    color:white;\r\n    background-color: #14284B;\r\n    padding-bottom: 8px;\r\n    padding-top: 8px;\r\n}\r\n\r\n.oblique-photo-iframe{\r\n    width: 100%;\r\n    height:100%;\r\n}\r\n\r\n.pictometry_ipa_div_class{\r\n    max-width:460px; \r\n    height:300px; \r\n    /*position:absolute; */\r\n    z-index:100;\r\n    /*border-style:solid;\r\n    border-bottom-width: 13px;*/\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n    .pictometry_ipa_div_class{\r\n        max-height: calc(100% - 100px);\r\n        max-width: 310px;\r\n        top:0px;\r\n        right: 0px;\r\n    }\r\n}"

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(4);
	var config_1 = __webpack_require__(60);
	var http_1 = __webpack_require__(25);
	var parcelReport_service_1 = __webpack_require__(63);
	var map_service_1 = __webpack_require__(62);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var ParcelReportComponent = (function () {
	    //  inject necessary services
	    function ParcelReportComponent(elRef, http, _mapService, _eventsService, _esriTasksService, prs) {
	        this.elRef = elRef;
	        this.http = http;
	        this._mapService = _mapService;
	        this._eventsService = _eventsService;
	        this._esriTasksService = _esriTasksService;
	        this.displayStatus = new core_1.EventEmitter();
	        this.isDisplayed = false;
	        this.showParcelSearchResult = false;
	        this.foundParcelResult = "";
	        this.showCreateButton = false;
	        this.jsonpCallback = "?method=JSONP_CALLBACK";
	        this.loadingImage = "./images/loading.gif";
	        this.reportGenerating = false;
	        this._parcelReportService = prs;
	    }
	    //initialize email objects 
	    ParcelReportComponent.prototype.ngOnInit = function () {
	        this.appSettings = config_1.Config.config[0];
	        //update chnages in the DOM
	        componentHandler.upgradeAllRegistered();
	    };
	    // destroy 
	    ParcelReportComponent.prototype.ngOnDestroy = function () {
	    };
	    ParcelReportComponent.prototype.addressLocationPicked = function (pickedAddressLocation) {
	        console.log(pickedAddressLocation);
	        var parcelNumber = "";
	        try {
	            if (pickedAddressLocation["addressSuggestion"]["SuggestionType"] == "ParcelNumber") {
	                parcelNumber = pickedAddressLocation["addressSuggestion"]["FullName"];
	            }
	            else if (pickedAddressLocation["addressSuggestion"]["SuggestionType"] == "Address") {
	                parcelNumber = pickedAddressLocation["addressLocation"]["ParcelNumber"];
	            }
	            if (parcelNumber && parcelNumber != "") {
	                this.foundParcelResult = "Parcel # " + parcelNumber + ". To generate report for this parcel, click \"CREATE\" button.";
	                this.showParcelSearchResult = true;
	                this.showCreateButton = true;
	                this.selectedParcelNumber = parcelNumber;
	                this.reportGenerating = false;
	            }
	            else {
	                this.foundParcelResult = "Cannot find parcel number. Please check the address or parcel number you entered.";
	                this.showParcelSearchResult = true;
	                this.showCreateButton = false;
	                this.reportGenerating = false;
	            }
	        }
	        catch (ex) {
	            this.foundParcelResult = "Cannot find parcel number. Please check the address or parcel number you entered";
	            this.showParcelSearchResult = true;
	            this.showCreateButton = false;
	        }
	    };
	    ParcelReportComponent.prototype.createReport = function () {
	        var _this = this;
	        this._esriTasksService.queryFeatures(this.appSettings["ParcelReport"]["ParcelsQueryMapService"], null, ("PARCEL_C = '" + this.selectedParcelNumber + "'"), ["PARCEL_C", "STNUMBER", "PRE_DIR", "FULL_STNAME", "CITY", "STATE", "ZIPCODE"], true, null).then(function (results) {
	            var parcelAttrs = results.features[0].attributes;
	            var fullAddress = parcelAttrs["STNUMBER"] + " " + ((parcelAttrs["PRE_DIR"] == null) ? "" : (parcelAttrs["PRE_DIR"] + " ")) + parcelAttrs["FULL_STNAME"] + " " + parcelAttrs["CITY"] + ", " + parcelAttrs["STATE"] + " " + parcelAttrs["ZIPCODE"];
	            var parcelNumber = parcelAttrs["PARCEL_C"];
	            var parcelFeature = results.features[0];
	            parcelFeature["attributes"] = {
	                "Parcel Address": fullAddress,
	                "Parcel Number": parcelNumber
	            };
	            _this._parcelReportService = new parcelReport_service_1.ParcelReportService(_this._esriTasksService, _this._mapService, _this._eventsService);
	            _this._parcelReportService.activeProject.subscribe(function (thing) {
	                if (thing["status"] != "ready") {
	                    alert("Report creation for parcel " + thing["parcelNumber"] + " has failed. Please try again later or contact the application support team if the issue repeats.");
	                    if (_this.selectedParcelNumber == thing["parcelNumber"]) {
	                        _this.foundParcelResult = "Parcel # " + parcelNumber + ". To generate report for this parcel, click \"CREATE\" button.";
	                        _this.showParcelSearchResult = true;
	                        _this.showCreateButton = true;
	                        _this.reportGenerating = false;
	                    }
	                }
	                else if (thing["status"] == "ready") {
	                    if (_this.selectedParcelNumber == thing["parcelNumber"]) {
	                        _this.foundParcelResult = "Parcel # " + parcelNumber + ". To generate report for this parcel, click \"CREATE\" button.";
	                        _this.showParcelSearchResult = true;
	                        _this.showCreateButton = true;
	                        _this.reportGenerating = false;
	                    }
	                }
	            });
	            _this.reportGenerating = true;
	            _this.showCreateButton = false;
	            _this.foundParcelResult = "Report generation is in progress. The report will open in a new browser tab when it is ready. While it is being generated, you can search and generate a report for another parcel.";
	            _this._parcelReportService.startParcelReport(parcelFeature);
	        }, function (error) {
	            _this.foundParcelResult = "Cannot find parcel number. Please check the address or parcel number you entered.";
	            _this.showParcelSearchResult = true;
	            _this.reportGenerating = false;
	            _this.showCreateButton = false;
	        });
	    };
	    ParcelReportComponent.prototype.addressSuggestionsReceived = function (event) {
	        this.showParcelSearchResult = false;
	    };
	    //emit the event telling the parent component to show the panel
	    ParcelReportComponent.prototype.showPanel = function () {
	        //this.isDisplayed = true;
	        this.displayStatus.emit(true);
	    };
	    //emit the event telling the parent component to hide the panel
	    ParcelReportComponent.prototype.closePanel = function () {
	        this.displayStatus.emit(false);
	    };
	    return ParcelReportComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ParcelReportComponent.prototype, "emailSubject", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], ParcelReportComponent.prototype, "emailBody", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], ParcelReportComponent.prototype, "displayStatus", void 0);
	ParcelReportComponent = __decorate([
	    core_1.Component({
	        selector: 'parcel-report',
	        template: __webpack_require__(117)
	    }),
	    __param(5, core_1.Inject(parcelReport_service_1.ParcelReportService)),
	    __metadata("design:paramtypes", [core_1.ElementRef, http_1.Http, map_service_1.MapService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService, Object])
	], ParcelReportComponent);
	exports.ParcelReportComponent = ParcelReportComponent;


/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports = "<div style=\"width:100%; height:100%; z-index:103; position:absolute;\">\r\n    <div class=\"mblSimpleDialogCover\"></div>\r\n    <div style=\"display:flex; min-width:300px; max-width:600px; position:relative; z-index:104; margin: 0 auto;\">\r\n        <addressLocator-component style=\"position: relative; width: 100%; height:100%\" inputPlaceHolderText=\"Enter parcel address or parcel # here...\" (addressLocationOutput)=\"addressLocationPicked($event)\" (addressSuggestionsOutput)=\"addressSuggestionsReceived($event)\"></addressLocator-component>\r\n        <button class=\"mdl-button mdl-js-button mdl-button--icon\" style=\"color:white; top:30px; right:20px;\" (click)=\"closePanel()\">   \r\n                <i class=\"material-icons\">cancel</i>\r\n        </button>\r\n    </div>\r\n    <div *ngIf=\"showParcelSearchResult\" style=\"position:relative; display:table; z-index:103; margin: 0 auto; top:60px;\">\r\n        <span style=\"color:white; display:block; text-align:center;\">{{foundParcelResult}}</span><br>\r\n        <button *ngIf=\"showCreateButton\" class=\"mdl-button mdl-js-button mdl-button--raised mdl-button--colored\" style=\"margin: 0 auto; display:block;\" (click)=\"createReport()\">\r\n                Create\r\n        </button>\r\n        <img *ngIf=\"reportGenerating\" src=\"{{loadingImage}}\" style=\"margin: 0 auto; display:block;\"/>\r\n    </div>\r\n</div>";

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var AppHelpComponent = (function () {
	    function AppHelpComponent() {
	        this.displayStatus = new core_1.EventEmitter();
	        this.helpSlowRunningScript = "./images/slow_running_script.png";
	        this.mainWindowImg = "./images/AppMainViewSS.PNG";
	        this.searchPlansImg = "./images/SearchPlansSS.PNG";
	        this.generateParcelReportImg = "./images/GenerateParcelReportSS.PNG";
	        this.legendCollapsedImg = "./images/LegendCollapsed_SS.PNG";
	        this.legendExpandedImg = "./images/LegendExpaned_SS.PNG";
	        this.showModulesButtonImg = "./images/ShowModulesButton_SS.PNG";
	        this.addressComponentImg = "./images/AddressComponent_SS.PNG";
	        this.extraToolsImg = "./images/ExtraTools_SS.PNG";
	        this.identifyToolImg = "./images/IdentifyTool_SS.PNG";
	        this.identifyParcelPRCImg = "./images/IdentifyParcelPRC_SS.PNG";
	        this.identifyParcelReportImg = "./images/IdentifyParcelReport_SS.PNG";
	    }
	    AppHelpComponent.prototype.ngOnInit = function () {
	    };
	    AppHelpComponent.prototype.closePanel = function () {
	        this.displayStatus.emit(false);
	    };
	    return AppHelpComponent;
	}());
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], AppHelpComponent.prototype, "displayStatus", void 0);
	AppHelpComponent = __decorate([
	    core_1.Component({
	        selector: 'app-help',
	        template: __webpack_require__(119),
	        styles: [__webpack_require__(120)]
	    }),
	    __metadata("design:paramtypes", [])
	], AppHelpComponent);
	exports.AppHelpComponent = AppHelpComponent;


/***/ },
/* 119 */
/***/ function(module, exports) {

	module.exports = "<div style=\"width:100%; height:100%; z-index:103; position:absolute;\">\r\n    <div class=\"mblSimpleDialogCover\"></div>\r\n    <div class=\"popup-message-div\">\r\n        <div class=\"demo-card-square mdl-card mdl-shadow--2dp\">\r\n            <div class=\"mdl-card__title\">\r\n                <span>Help</span>\r\n                <div class=\"mdl-layout-spacer\"></div>\r\n                <button id=\"btnCloseDialog\" class=\"mdl-button mdl-js-button mdl-button--icon closeButton\" (click)=\"closePanel()\">    \r\n                    <i class=\"material-icons\">cancel</i>\r\n                </button>\r\n            </div>\r\n            <div class=\"mdl-card__supporting-text\">\r\n                <div align=\"center\"><p style=\"font-size: 150%; font-weight: 900\">PlanIndy Help</p></div>\r\n                <div>\r\n                    <p>The PlanIndy Portal provides in-depth access to elements of the Comprehensive Plan for Indianapolis and Marion County and other planning work of the Department of Metropolitan Development.</p>\r\n                    <p style=\"font-size: 12px;\"><b>NOTE:</b> If you're having issues running a query on Internet Explorer, click <a href='#ieAnchorText'>here</a>.</p>\r\n                </div>\r\n\r\n                <div style=\"padding-top: 10px\">\r\n                    <p style=\"font-weight: bold\">Main Window</p>\r\n                    <p>Upon opening, applications presents users with options to either choose a plan to view or generate a parcel report.</p>\r\n                    <div align=\"center\"><img alt=\"Main Window\" title=\"Main Window\" src=\"{{mainWindowImg}}\"/></div>\r\n                </div>\r\n                <div align=\"center\" style=\"border-top-color:Gray;border-top-style:solid;border-top-width:1px;margin-top: 20px; margin-bottom: 10px; margin-right: 5px; margin-left: 5px;\">\r\n                </div>\r\n\r\n                <div>\r\n                    <p style=\"font-weight: bold\">Generate Parcel Report</p>\r\n                    <p>Upon choosing Generate Parcel Report option, you will be presented with text box prompting you to either enter parcel address or parcel number. Once parcel is selected, click \"CREATE\" button. While parcel report is being generated, you can proceed using the application. The report will open in a new browser tab when ready.</p>\r\n                    <div align=\"center\"><img alt=\"Disclaimer\" title=\"Disclaimer\" src=\"{{generateParcelReportImg}}\"/></div>\r\n                </div>\r\n                <div align=\"center\" style=\"border-top-color:Gray;border-top-style:solid;border-top-width:1px;margin-top: 20px; margin-bottom: 10px; margin-right: 5px; margin-left: 5px;\">\r\n                </div>\r\n\r\n                <div>\r\n                    <p style=\"font-weight: bold\">Plan Modules</p>\r\n                    <p>Upon starting PlanIndy, available search modules will appear. Click on the plan you are intersretd in.</p>\r\n                    <div align=\"center\"><img alt=\"Disclaimer\" title=\"Disclaimer\" src=\"{{searchPlansImg}}\"/></div>\r\n                    <p>To show available modules again, click on \"Show available modules\" button in the top left corner.</p>\r\n                    <div align=\"center\"><img alt=\"Disclaimer\" title=\"Disclaimer\" src=\"{{showModulesButtonImg}}\"/></div>\r\n                </div>\r\n                <div align=\"center\" style=\"border-top-color:Gray;border-top-style:solid;border-top-width:1px;margin-top: 20px; margin-bottom: 10px; margin-right: 5px; margin-left: 5px;\">\r\n                </div>\r\n\r\n                <div>\r\n                    <p style=\"font-weight: bold\">Legend Tool</p>\r\n                    <p>Legend tool provides ability to turn on/off individual map layers as well as individual plans. In addition, moving slider will change opacity of the layer.</p>\r\n                    <div align=\"center\"><img alt=\"Legend Tool\" title=\"Legend Tool\" src=\"{{legendCollapsedImg}}\"/></div>\r\n                    <div align=\"center\"><img alt=\"Legend Tool\" title=\"Legend Tool\" src=\"{{legendExpandedImg}}\"/></div>\r\n                </div>\r\n                <div align=\"center\" style=\"border-top-color:Gray;border-top-style:solid;border-top-width:1px;margin-top: 20px; margin-bottom: 10px; margin-right: 5px; margin-left: 5px;\">\r\n                </div>\r\n\r\n                <div>\r\n                    <p style=\"font-weight: bold\">Address Tool</p>\r\n                    <p>Address tool allows search addresses, parcels, and neighborhoods. Start typing either one of three options, and once a match is found, suggestions will be provided. Click on suggestions and map will be zoomed to selected item.</p>\r\n                    <div align=\"center\"><img alt=\"Add\" title=\"Legend Tool\" src=\"{{addressComponentImg}}\"/></div>\r\n                </div>\r\n                <div align=\"center\" style=\"border-top-color:Gray;border-top-style:solid;border-top-width:1px;margin-top: 20px; margin-bottom: 10px; margin-right: 5px; margin-left: 5px;\">\r\n                </div>\r\n\r\n                <div>\r\n                    <p style=\"font-weight: bold\">Extra Tools</p>\r\n                    <p>Top right corner of the application contains \"Tools\" button. Clicking on the button will show a popup menu with extra tools like \"Identify\" a plan, \"Oblique Image\", \"Free hand Draw\", or \"Draw Polygon\" tool. Tools are activated by clicking on them. Each of them is described below.</p>\r\n                    <div align=\"center\"><img alt=\"Add\" title=\"Extra Tools\" src=\"{{extraToolsImg}}\"/></div>\r\n                </div>\r\n                <div align=\"center\" style=\"border-top-color:Gray;border-top-style:solid;border-top-width:1px;margin-top: 20px; margin-bottom: 10px; margin-right: 5px; margin-left: 5px;\">\r\n                </div>\r\n\r\n                <div>\r\n                    <p style=\"font-weight: bold\">Identify Tool</p>\r\n                    <p>Identify tool is used to idenitfy active plans and parcels in clicked location. If a plan has adopting resolution document, you can open it by clicking on \"See document\" button.</p>\r\n                    <div align=\"center\"><img alt=\"Identify Tool\" title=\"Identify Tool\" src=\"{{identifyToolImg}}\"/></div>\r\n                    <p>In case if parcel is found, users can access a property record card for it and also create a parcel report.</p>\r\n                    <div align=\"center\"><img alt=\"Identify Tool\" title=\"Identify Tool\" src=\"{{identifyParcelPRCImg}}\"/></div>\r\n                    <div align=\"center\"><img alt=\"Identify Tool\" title=\"Identify Tool\" src=\"{{identifyParcelReportImg}}\"/></div>\r\n                </div>\r\n                <div align=\"center\" style=\"border-top-color:Gray;border-top-style:solid;border-top-width:1px;margin-top: 20px; margin-bottom: 10px; margin-right: 5px; margin-left: 5px;\">\r\n                </div>\r\n\r\n                <div>\r\n                    <p style=\"font-weight: bold\">Location Options Tool</p>\r\n                    <p></p>\r\n                    <div align=\"center\"><img alt=\"Add\" title=\"Legend Tool\" src=\"{{addressComponentImg}}\"/></div>\r\n                </div>\r\n                <div align=\"center\" style=\"border-top-color:Gray;border-top-style:solid;border-top-width:1px;margin-top: 20px; margin-bottom: 10px; margin-right: 5px; margin-left: 5px;\">\r\n                </div>\r\n\r\n                <a name=\"ieAnchorText\"></a>\r\n                <div>\r\n                    <p style=\"font-weight: bold\">Internet Explorer - Slow running script</p>\r\n                    <div align=\"center\"><img alt=\"IE - Slow Running Script\" title=\"IE - Slow Running Script\" src=\"{{helpSlowRunningScript}}\"/></div>\r\n                    <p>If you receive this Internet Explorer warning while running any of the queries, it means the result is taking longer that what's permitted in Internet Explorer.</p>\r\n                    <p>The following options are available:</p>\r\n                    <ul>\r\n                        <li>Use a different browser (like Firefox, or Chrome) to do the search. </li>\r\n                        <li>Run fix in IE that will expand the time the browser can wait for a response. <br />\r\n                            Navigate to <a href=\"http://support.microsoft.com/kb/175500\" target=\"_blank\">http://support.microsoft.com/kb/175500</a>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>";

/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = ".demo-card-square {\r\n    width:100%;\r\n    max-width:calc(100% - 12px);\r\n    background-color:white;\r\n    min-height:100px;\r\n}\r\n\r\n.demo-card-square > .mdl-card__supporting-text{\r\n    width: 100%;\r\n    padding-left: 0px;\r\n    padding-right: 0px;\r\n    padding-top:0px;\r\n}\r\n\r\n.demo-card-square > .mdl-card__title{\r\n    border-style: none none solid none;\r\n}\r\n\r\n.header-text{\r\n    width:calc(100% - 40px);\r\n    font-size: 20px;\r\n}\r\n\r\n.closeButton{\r\n    position: relative;\r\n    /*top:10px;*/\r\n    right:0px;\r\n}\r\n\r\n.card-div{\r\n    display:flex; \r\n    min-width:300px; \r\n    max-width:600px; \r\n    position:relative; \r\n    z-index:104; \r\n    margin: 0 auto;\r\n    top:20px;\r\n    max-height: calc(100% - 40px);\r\n}\r\n\r\n.card-message-div{\r\n    display:flex; \r\n    min-width:300px; \r\n    max-width:600px; \r\n    position: relative;; \r\n    z-index:105; \r\n    margin: 0 auto;\r\n    top:20px;\r\n    max-height: calc(100% - 40px);\r\n}\r\n\r\n.popup-message-div{\r\n    display:flex; \r\n    min-width:100px; \r\n    max-width:800px; \r\n    position: relative;; \r\n    z-index:105; \r\n    margin: 0 auto;\r\n    top:20px;\r\n    max-height: calc(100% - 40px);\r\n}\r\n\r\n.popup-message-div > .demo-card-square{\r\n    width:auto;\r\n    margin:0 auto;\r\n    max-width: calc(100% - 20px);\r\n}\r\n\r\n.popup-message-div >.demo-card-square > .mdl-card__supporting-text{\r\n    padding-left:8px;\r\n    padding-right:8px;\r\n    width: calc(100% - 16px);\r\n}\r\n\r\n.mdl-selectfield {\r\n    width:100%;\r\n    padding-top:4px;\r\n    padding-bottom:4px;\r\n}\r\n\r\n.mdl-selectfield__select{\r\n    font-size: 14px;\r\n    padding-right:20px;\r\n    border-bottom: 1px solid rgba(0,0,0, 0.35);\r\n    cursor: pointer;\r\n}\r\n\r\n/*Overrides for the 3rd party mdl-selectfield */\r\n.mdl-selectfield select {\r\n    -webkit-appearance: none;\r\n       -moz-appearance: none;\r\n            appearance: none;\r\n  }\r\n  \r\n  .mdl-selectfield {\r\n    font-family: 'Roboto','Helvetica','Arial',sans-serif;\r\n    position: relative;\r\n    display: inline-flex;\r\n  }\r\n  \r\n  .mdl-selectfield:after {\r\n    position: absolute;\r\n    top: 0.7em;\r\n    right: 0.5em;\r\n    cursor:pointer;\r\n    width: 0;\r\n    height: 0;\r\n    padding: 0;\r\n    content: '';\r\n    border-left: .25em solid transparent;\r\n    border-right: .25em solid transparent;\r\n    border-top: 0.375em solid rgba(0,0,0, 0.40);\r\n    pointer-events: none;\r\n  }\r\n  \r\n  .mdl-selectfield__label {\r\n      color: rgba(255,0,0, 0.90);\r\n      top:7px;\r\n      font-size:12px;\r\n  }\r\n\r\n    .mdl-selectfield__label:after {\r\n        height:0px;\r\n    }\r\n  \r\n  /*material-design-lite overrides*/\r\n  .mdl-textfield__label {\r\n      color:red;\r\n      opacity: 0.9;\r\n      top:5px;\r\n      font-size: 12px;\r\n  }\r\n\r\n    .mdl-textfield__label:after {\r\n        height:0px;\r\n    }\r\n\r\n  .registration-table-div{\r\n      border-style: solid;\r\n      border-color: gray;\r\n  }\r\n\r\n  .registration-table{\r\n    border-spacing: 0px;\r\n  }\r\n\r\n  .mdl-js-checkbox{\r\n      height:auto;\r\n  }\r\n\r\n.mdl-checkbox__label{\r\n    font-size: 14px;\r\n}\r\n\r\n.mdl-textfield__input{\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.35)\r\n}\r\n\r\n.coverage-areas-div{\r\n    padding-left:2px;\r\n    padding-right: 2px;\r\n}\r\n\r\n.mdl-textfield-registrationComponent{\r\n    width:100%; \r\n    padding-top:0px; \r\n    padding-bottom:0px;\r\n}\r\n\r\n.suggestionsList{\r\n    background-color: white; \r\n    padding: 0px 0px 0px 0px; \r\n    z-index:10;\r\n    border-style: solid;\r\n    margin:0px;\r\n}\r\n\r\n.suggestionItem:hover{\r\n    background-color: #ED1C24;\r\n}\r\n\r\n.suggestionItem{\r\n    cursor: pointer;\r\n    padding: 2px;\r\n    text-align: left;\r\n    min-height: 40px;\r\n}\r\n\r\n.inputFormatError{\r\n    background-color:red;\r\n    color:white;\r\n}\r\n\r\n.popupCover {\r\n    background-color: #646464;\r\n    height: 100%;\r\n    left: 0;\r\n    opacity: 0.5;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 99;\r\n}\r\n\r\n.popupHelpIcon {\r\n    cursor: pointer;\r\n}"

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(4);
	var config_1 = __webpack_require__(60);
	var map_service_1 = __webpack_require__(62);
	var EventsService_1 = __webpack_require__(31);
	var esriTasks_service_1 = __webpack_require__(32);
	var Print = __webpack_require__(122);
	var http_1 = __webpack_require__(25);
	var Point = __webpack_require__(38);
	var AppComponent = (function () {
	    function AppComponent(elRef, _mapService, _eventsService, _esriTasksService, http, jsonp) {
	        this.elRef = elRef;
	        this._mapService = _mapService;
	        this._eventsService = _eventsService;
	        this._esriTasksService = _esriTasksService;
	        this.http = http;
	        this.jsonp = jsonp;
	        this.logoPath = "./images/DMD-logo.png";
	        this.mapUpdateShow = false;
	        this.appMainViewImgPath = "./images/MainViewScreenShot.png";
	        this.showAddressComponent = true;
	        this.showSearchTool = true;
	        this.initialModuleSelected = false;
	        this.loadingImagePath = "./images/loading.gif";
	        this.appSettings = null;
	        this.searchModules = [];
	        this.showSearchOptions = false;
	        this.hideTitle = true;
	        this.urlSearchObject = "";
	        this.localStorage = window.localStorage;
	        this.printWidget = null;
	        this.showPrint = false;
	        this.operationalLayersCount = 0;
	        this.showEmailPanel = false;
	        this.emailSubject = "";
	        this.emailBody = "";
	        this.linkGenerationInProgress = false;
	        this.showAppHelp = false;
	        this.showObliqueImage = false;
	        this.tabsDisabled = false;
	        this.showCopyShortURL = false;
	        this.shortUrlCopied = false;
	        this.shortUrlValue = "";
	        this.showParcelReportComponent = false;
	        this.iOS = false;
	        // console.log(this.document.location.href);
	        // console.log(window.location.origin);
	        var search = decodeURI(window.location.search).substr(1);
	        this.urlSearchObject = search.split('=')[1];
	        console.log(this.urlSearchObject);
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._eventsService.addressSearchActivate$.subscribe(function (show) {
	            return _this.showAddressComponent = show;
	        });
	        this._eventsService.searchToolShow$.subscribe(function (show) {
	            _this.showSearchTool = show;
	            _this.initialModuleSelected = true;
	        });
	        this._eventsService.mapUpdateShow$.subscribe(function (show) {
	            _this.mapUpdateShow = show;
	        });
	        this.appSettings = config_1.Config.config[0];
	        this.emailSubject = this.appSettings["EmailService"]["subject"];
	        this.searchModules = this.appSettings["SearchModules"];
	        this._eventsService.dynamicLayerViewCreated$.subscribe(function (show) {
	            _this.operationalLayersCount++;
	            if (_this.appSettings["Map"]["Layers"]["OperationalLayers"].length == _this.operationalLayersCount) {
	                _this.showSearchOptions = true;
	            }
	        });
	        // var tab = document.createElement('a');
	        // tab.className = "mdl-layout__tab";
	        // tab.innerHTML = "Test Tab";
	        // tab.setAttribute("href", "#tabMap");
	        // var tabBar = document.getElementById("tabBar")
	        // tabBar.appendChild(tab);
	        this._eventsService.moduleSelect$.subscribe(function (module) {
	            //this.moduleSelected(module);
	        });
	        this._eventsService.expandMenuToolbar$.subscribe(function (expand) {
	            _this.hideTitle = expand;
	        });
	        // this._eventsService.showObliqueImage$.subscribe(show => {
	        //     this.showObliqueImage = show;
	        // });
	        this._eventsService.searchToolShow$.subscribe(function (evt) {
	            _this.tabsDisabled = evt;
	        });
	        // /***TEST PolygonAnalysis service***/
	        // var url:string = this.appSettings["ParcelReport"]["TextValuesPage1"]["url"];
	        // var layersArray:Array<any> = this.appSettings["ParcelReport"]["TextValuesPage1"]["layers"];
	        // this._esriTasksService.soePolygonAnalysis(url, null, layersArray);
	        this.iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	    };
	    AppComponent.prototype.moduleSelected = function (module) {
	        // var tabs:HTMLCollection = this.tabBar.nativeElement.children;
	        // for (var i:number = 0; i < tabs.length; i++){
	        //     if((module["Name"] as string).toLowerCase() == (tabs[i]["innerText"] as string).toLowerCase()){
	        //         tabs[i].classList.add('is-active');
	        //     }else{
	        //         tabs[i].classList.remove('is-active');
	        //     }
	        // }
	    };
	    AppComponent.prototype.tabClicked = function (event) {
	        if (event["event"].currentTarget.classList.contains('is-active')) {
	            return;
	        }
	        this._eventsService.moduleSelect(event["module"]);
	    };
	    AppComponent.prototype.saveSelection = function () {
	        //window.localStorage.setItem("PlanIndy_saved_search", JSON.stringify({}));
	        this._eventsService.startSaveSearch();
	    };
	    AppComponent.prototype.getLastSavedSearch = function () {
	        var savedSearch = JSON.parse(window.localStorage.getItem("PlanIndy_saved_search"));
	        if (savedSearch["geometry"] != null) {
	            var geometryObject = {};
	            geometryObject["geometry"] = savedSearch["geometry"];
	            geometryObject["buffer"] = savedSearch["buffer"];
	            geometryObject["showOnlyWithinGeometry"] = savedSearch["showOnlyWithinGeometry"];
	            this._eventsService.setSavedGeometry(geometryObject);
	        }
	        this._eventsService.savedSearchSelect(savedSearch["module"]);
	        this._mapService.view.extent = savedSearch["extent"];
	    };
	    AppComponent.prototype.hidePrintWidget = function () {
	        this.showPrint = false;
	    };
	    AppComponent.prototype.printMap = function () {
	        this.showPrint = true;
	        if (this.printWidget == null) {
	            this.printWidget = new Print({
	                view: this._mapService.view,
	                printServiceUrl: this.appSettings["Printing"]["serviceURL"],
	                container: "PrintWidgetDiv"
	            });
	        }
	    };
	    AppComponent.prototype.copyToBuffer = function () {
	        this.linkGenerationInProgress = true;
	        this._eventsService.createAppURL("copy");
	    };
	    AppComponent.prototype.createSMS = function () {
	        this.linkGenerationInProgress = true;
	        this._eventsService.createAppURL("sms");
	    };
	    AppComponent.prototype.createEmail = function () {
	        this.linkGenerationInProgress = true;
	        this._eventsService.createAppURL("email");
	    };
	    AppComponent.prototype.createShortUrl = function (shareString) {
	        var _this = this;
	        var shareObject = JSON.parse(shareString);
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        var options = new http_1.RequestOptions({ headers: headers });
	        var msgBody = { "queryString": shareObject.url };
	        this.http.post(this.appSettings["URLShortener"]["createQueryURL"], msgBody, options).toPromise().then(function (response) {
	            var queryID = response.json();
	            var queryURL = window.location.href.split('?')[0] + "?queryid=" + queryID;
	            console.log(queryURL);
	            switch (shareObject.method) {
	                case "sms":
	                    window.location.href = "sms:&body=" + queryURL;
	                    break;
	                case "email":
	                    _this.emailBody = queryURL;
	                    _this.showEmailPanel = true;
	                    break;
	                case "copy":
	                    try {
	                        _this.showCopyShortURL = true;
	                        _this.shortUrlCopied = false;
	                        _this.shortUrlValue = queryURL;
	                    }
	                    catch (ex) {
	                        console.log(ex);
	                        _this.showCopyShortURL = false;
	                        _this.shortUrlCopied = false;
	                    }
	            }
	            _this.linkGenerationInProgress = false;
	        }).catch(function (e) {
	            console.log(e);
	            alert("Operation failed. Please try again later.");
	            _this.showCopyShortURL = false;
	            _this.shortUrlCopied = false;
	            _this.linkGenerationInProgress = false;
	        });
	        // this.http.post("https://www.googleapis.com/urlshortener/v1/url?key=AIzaSyDby2eRAyjDldk2AOfgBi5zvipxiftG4W4", msgBody, options).toPromise().then((response)=>{
	        //     var responseObject:Object = response.json();
	        //     var tinyUrl:string = responseObject["id"];
	        //     switch(shareObject.method){
	        //         case "sms": 
	        //             window.location.href = "sms:&body=" + tinyUrl;
	        //             break;
	        //         case "email":
	        //             this.emailBody = tinyUrl;
	        //             this.showEmailPanel = true;
	        //             break;
	        //     }
	        // }).catch(e=>{console.log(e)})
	    };
	    AppComponent.prototype.fullExtent = function () {
	        this._mapService.view.zoom = 4;
	        //map is loaded, then do some stuff
	        var pt = new Point({
	            x: this.appSettings["Map"]["Center"]["x"],
	            y: this.appSettings["Map"]["Center"]["y"],
	            spatialReference: this._mapService.view.spatialReference
	        });
	        this._mapService.view.center = pt;
	    };
	    AppComponent.prototype.copyToClipboard = function () {
	        try {
	            this.shortUrlId.nativeElement.select();
	            document.execCommand("copy");
	            this.shortUrlCopied = true;
	        }
	        catch (ex) {
	            alert("Could not copy. Please select the text and copy it manually.");
	        }
	    };
	    AppComponent.prototype.closeCopyToClipboard = function () {
	        this.showCopyShortURL = false;
	        this.shortUrlCopied = false;
	    };
	    AppComponent.prototype.addressLocationPicked = function (pickedAddressLocation) {
	        this._eventsService.changeNav(pickedAddressLocation);
	    };
	    return AppComponent;
	}());
	__decorate([
	    core_1.ViewChild('tabBar'),
	    __metadata("design:type", core_1.ElementRef)
	], AppComponent.prototype, "tabBar", void 0);
	__decorate([
	    core_1.ViewChild('shortUrlId'),
	    __metadata("design:type", core_1.ElementRef)
	], AppComponent.prototype, "shortUrlId", void 0);
	AppComponent = __decorate([
	    core_1.Component({
	        selector: 'main-app',
	        template: __webpack_require__(123),
	        styles: [__webpack_require__(124)]
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, map_service_1.MapService, EventsService_1.EventsService, esriTasks_service_1.EsriTasksService, http_1.Http, http_1.Jsonp])
	], AppComponent);
	exports.AppComponent = AppComponent;


/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_122__;

/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-layout mdl-js-layout mdl-layout--fixed-header\" style=\"overflow:hidden\">\r\n    <header class=\"mdl-layout__header\" style=\"z-index:102\">\r\n        <div class=\"mdl-layout__header-row main-header\">\r\n            <!--<img alt=\"Voter Information Portal Logo\" src=\"{{logoPath}}\">-->\r\n            <div  style=\"float:left; position:absolute; left:10px; top:13px;\">\r\n                <searchModule-component></searchModule-component>\r\n            </div>\r\n            <!--<span class=\"title-span\" [style.visibility]=\"hideTitle ? 'hidden' : 'visible'\">PlanIndy</span>-->\r\n            <span class=\"title-span\">PlanIndy</span>\r\n            <div style=\"float:right; position:absolute; right:10px; top:13px;\">\r\n                <navTools-component></navTools-component>\r\n            </div>\r\n        </div>\r\n\r\n        <!--<div class=\"mdl-layout__tab-bar mdl-js-ripple-effect\" #tabBar>\r\n            <a class=\"mdl-layout__tab\" href=\"#tabMap\" [ngClass]=\"{'a-disabled':tabsDisabled}\" *ngFor=\"let module of searchModules\" (click)=\"tabClicked({event:$event, module:module})\">{{module.Name}}</a>\r\n        </div>-->\r\n        \r\n    </header>\r\n    <addressLocator-component style=\"position: absolute; width: 100%; height:100%; top: 0px;\" [style.display]=\"(showAddressComponent == true) ? 'block' : 'none'\" inputPlaceHolderText=\"Enter an address, parcel #, an intersection, or neighborhood name here...\" (addressLocationOutput)=\"addressLocationPicked($event)\"></addressLocator-component>\r\n    \r\n    \r\n    <main class=\"mdl-layout__content\">\r\n        <obliquePhoto-component *ngIf=\"showObliqueImage\"></obliquePhoto-component>\r\n        <legend-component (appURLCreated)=\"createShortUrl($event)\"></legend-component>\r\n        <map-view id=\"tabMap\">\r\n            <!--<img [style.display]=\"(mapUpdateShow == true) ? 'block' : 'none'\" style=\"position:absolute; left:45%; right:45%; top:45%; z-index:50;\" src=\"{{loadingImagePath}}\">-->\r\n            <div style=\"position:absolute; bottom:10px; width:100%;\">\r\n                <label [style.display]=\"(mapUpdateShow == true) ? 'table' : 'none'\" class=\"mapLoadingLabel\">Map Loading...</label>\r\n            </div>\r\n        </map-view>\r\n        <!--<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect zoom-in-label-class\" id=\"zoom-in-label\" for=\"zoom-in-icon\">\r\n            <input type=\"checkbox\" id=\"zoom-in-icon\" class=\"mdl-icon-toggle__input\" name=\"mapToolActive\" value=\"Zoom In\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">zoom_in</i>\r\n            <div class=\"mdl-tooltip mdl-tooltip--large\" for=\"zoom-in-label\">\r\n                Zoom In\r\n            </div>\r\n        </label>\r\n        <label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect zoom-out-label-class\" id=\"zoom-out-label\" for=\"zoom-out-icon\">\r\n            <input type=\"checkbox\" id=\"zoom-out-icon\" class=\"mdl-icon-toggle__input\" name=\"mapToolActive\" value=\"Zoom Out\">\r\n            <i class=\"mdl-icon-toggle__label material-icons\">zoom_out</i>\r\n            <div class=\"mdl-tooltip mdl-tooltip--large\" for=\"zoom-out-label\">\r\n                Zoom Out\r\n            </div>\r\n        </label>-->\r\n        <label class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect toolbar-items full-extent-label-class\" id=\"full-extent-label\" for=\"full-extent-icon\" (click)=\"fullExtent()\">\r\n            <i class=\"material-icons\">zoom_out_map</i>\r\n            <!--<div class=\"mdl-tooltip mdl-tooltip--large\" for=\"full-extent-label\">\r\n                Full Extent\r\n            </div>-->\r\n        </label>\r\n        <!-- <div id=\"reportMap\" style=\"width:1px; height:1px;\"></div> -->\r\n    </main>\r\n    <footer class=\"mdl-mini-footer\" style=\"min-height:50px; background-color: #14284b;\">\r\n        <table style=\"width:100%\">\r\n            <tr>\r\n                <td>\r\n                    <!--<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect\" id=\"more-label\">\r\n                        <input type=\"checkbox\" class=\"mdl-icon-toggle__input\" value=\"more\">\r\n                        <i class=\"mdl-icon-toggle__label material-icons\" style=\"color:white\">more_vert</i>\r\n                        <div class=\"mdl-tooltip mdl-tooltip--large mdl-tooltip--top\" for=\"more-label\">\r\n                            More\r\n                        </div>\r\n                    </label>-->\r\n                    <!-- Left aligned menu on top of button  -->\r\n                    <button id=\"more-options-left\"\r\n                            class=\"mdl-button mdl-js-button mdl-button--icon\" title=\"More Options\" >\r\n                        <i class=\"material-icons\">more_vert</i>\r\n                    </button>\r\n                    <ul class=\"mdl-menu mdl-menu--top-left mdl-js-menu mdl-js-ripple-effect\"\r\n                        data-mdl-for=\"more-options-left\">\r\n                        <li disabled class=\"mdl-menu__item menu-list-items-title\"><b>More Options</b></li>\r\n                        <li class=\"mdl-menu__item\" (click)=\"printMap()\">\r\n                            <i class=\"material-icons menu-list-item-content\">print</i>\r\n                            <span class=\"menu-list-item-content\">Print</span>\r\n                        </li>\r\n                        <li class=\"mdl-menu__item\" (click)=\"saveSelection()\">\r\n                            <i class=\"material-icons menu-list-item-content\">save</i>\r\n                            <span class=\"menu-list-item-content\">Save Selection</span>\r\n                        </li>\r\n                        <li class=\"mdl-menu__item\" *ngIf=\"localStorage.getItem('PlanIndy_saved_search') != null\" (click)=\"getLastSavedSearch()\">\r\n                            <i class=\"material-icons menu-list-item-content\">collections_bookmark</i>\r\n                            <span class=\"menu-list-item-content\">Open Last Saved Search</span>\r\n                        </li>\r\n                        <li class=\"mdl-menu__item\" (click)=\"showAppHelp = true\">\r\n                            <i class=\"material-icons menu-list-item-content\">help</i>\r\n                            <span class=\"menu-list-item-content\">Help</span>\r\n                        </li>\r\n                    </ul>\r\n                </td>\r\n                <td align=\"center\">\r\n                    <basemapNav-component></basemapNav-component>\r\n                </td>\r\n                <td style=\"text-align: right;\">\r\n                    <!-- Right aligned menu on top of button  -->\r\n                    <button id=\"share-options-right\"\r\n                            class=\"mdl-button mdl-js-button mdl-button--icon\" [disabled]=\"linkGenerationInProgress\" title=\"Share Selection\">\r\n                        <i class=\"material-icons\" *ngIf=\"!linkGenerationInProgress\">share</i>\r\n                        <img *ngIf=\"linkGenerationInProgress\" style=\"width:24px; height:24px; background-color:white; border-radius:16px; position:absolute; top:5px; right:5px;\" src=\"{{loadingImagePath}}\">\r\n                    </button>\r\n                    <ul class=\"mdl-menu mdl-menu--top-right mdl-js-menu mdl-js-ripple-effect\"\r\n                        data-mdl-for=\"share-options-right\">\r\n                        <li disabled class=\"mdl-menu__item menu-list-items-title\"><b>Share Selection</b></li>\r\n                        <li class=\"mdl-menu__item\" (click)=\"copyToBuffer()\">\r\n                            <i class=\"material-icons menu-list-item-content\">content_copy</i>\r\n                            <span class=\"menu-list-item-content\">Copy to Buffer</span>\r\n                        </li>\r\n                        <li class=\"mdl-menu__item\" (click)=\"createEmail()\">\r\n                            <i class=\"material-icons menu-list-item-content\">email</i>\r\n                            <span class=\"menu-list-item-content\">Email</span>\r\n                        </li>\r\n                        <!--<li class=\"mdl-menu__item\" (click)=\"createSMS()\">\r\n                            <i class=\"material-icons menu-list-item-content\">textsms</i>\r\n                            <span class=\"menu-list-item-content\">Text Message</span>\r\n                        </li>-->\r\n                    </ul>\r\n                </td>\r\n            </tr>\r\n        </table>\r\n    </footer>\r\n</div>\r\n\r\n<div id=\"demo-toast-example\" class=\"mdl-js-snackbar mdl-snackbar\">\r\n  <div class=\"mdl-snackbar__text\"></div>\r\n  <button class=\"mdl-snackbar__action mdl-snackbar__action_local\" type=\"button\"></button>\r\n</div>\r\n\r\n<searchTool-component [style.z-index]=\"initialModuleSelected ? '101' : '103'\" class=\"searchToolClass\" [ngClass]=\"{'searchToolFadeOut':!showSearchTool}\" urlSearchObject={{urlSearchObject}} (showParcelReportWidget)=\"showParcelReportComponent = true\"></searchTool-component>\r\n\r\n  <div id=\"PrintWidgetDiv\" [style.display]=\"showPrint ? 'block' : 'none'\" style=\"position: absolute; bottom:70px; left: 10px; z-index: 200;max-height: calc(100% - 200px);\">\r\n      <i class=\"material-icons menu-list-item-content\" style=\"float: right; cursor: pointer\" (click)=\"hidePrintWidget()\">cancel</i>\r\n  </div>\r\n\r\n  <!--modal dialog for email sharing-->\r\n<email-panel *ngIf=\"showEmailPanel\" (displayStatus)=\"showEmailPanel = $event\" emailSubject=\"{{emailSubject}}\" emailBody=\"{{emailBody}}\"></email-panel>\r\n\r\n<app-help *ngIf=\"showAppHelp\" (displayStatus)=\"showAppHelp = false\"></app-help>\r\n\r\n<div *ngIf=\"showCopyShortURL\" style=\"width:100%; height:100%; z-index:103; position:absolute;\">\r\n    <div class=\"mblSimpleDialogCover\"></div>\r\n    <div style=\"display:flex; min-width:270px; max-width:500px; position:relative; z-index:104; margin: 0 auto; top:100px;\">\r\n        <input class=\"mdl-textfield__input\" type=\"text\" value={{shortUrlValue}} style=\"background-color:white\" #shortUrlId>\r\n        <button class=\"mdl-button mdl-js-button mdl-button--raised mdl-button--colored copyUrlButton\" (click)=\"copyToClipboard()\" *ngIf=\"!iOS\">\r\n                Copy\r\n        </button>\r\n        <button class=\"mdl-button mdl-js-button mdl-button--icon\" style=\"color:white; bottom:30px; right:5px;\" (click)=\"closeCopyToClipboard()\">    \r\n                <i class=\"material-icons\">cancel</i>\r\n        </button>\r\n    </div>\r\n    <div *ngIf=\"shortUrlCopied || iOS\" style=\"position:relative; display:table; z-index:104; margin: 0 auto; top:100px;\">\r\n        <span *ngIf=\"!iOS\" style=\"color:white;\">The URL has been copied.</span>\r\n        <span *ngIf=\"iOS\" style=\"color:white;\">Please select and copy text above.</span>\r\n    </div>\r\n</div>\r\n\r\n<parcel-report *ngIf=\"showParcelReportComponent\" (displayStatus)=\"showParcelReportComponent = false\"></parcel-report>\r\n";

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports = ".menu-list-items-title{\r\n    color: black; \r\n    border-bottom-color: black; \r\n    border-bottom-style: solid;\r\n    text-align: center;\r\n}\r\n\r\n.menu-list-item-content{\r\n    vertical-align: middle;\r\n}\r\n\r\n.is-lowest-value{\r\n    background: white;\r\n}\r\n\r\n.a-disabled{\r\n    pointer-events: none;\r\n}\r\n\r\n.searchToolClass{\r\n    position: absolute; \r\n    height:100%; \r\n    width:100%; \r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    z-index:103;\r\n}\r\n\r\n@keyframes fadeOut {\r\n    from {\r\n        width:100%;\r\n        height:100%;\r\n    }\r\n\r\n    50% {\r\n        width:50%;\r\n        height:50%;\r\n        transform: scale3d(.3, .3, .3);\r\n    }\r\n\r\n    to {\r\n        top:15px;\r\n        left:10px;\r\n        width:0%;\r\n        height:0%;\r\n        display: none;\r\n    }\r\n    /*0% {\r\n        width:100%;\r\n        height:100%;\r\n        display: flex;\r\n        top:15px;\r\n        left:10px;\r\n    }\r\n    20% {\r\n        width:80%;\r\n        height:80%;\r\n        display: flex;\r\n        top:15px;\r\n        left:10px;\r\n    }\r\n    40% {\r\n        width:60%;\r\n        height:60%;\r\n        display: flex;\r\n        top:15px;\r\n        left:10px;\r\n    }\r\n    60% {\r\n        width:40%;\r\n        height:40%;\r\n        display: flex;\r\n        top:15px;\r\n        left:10px;\r\n    }\r\n    80% {\r\n        width:20%;\r\n        height:20%;\r\n        display: flex;\r\n        top:15px;\r\n        left:10px;\r\n    }\r\n    100% {\r\n        width:0%;\r\n        height:0%;\r\n        top:15px;\r\n        left:10px;\r\n        display: none;\r\n        visibility: hidden;\r\n    }*/\r\n}\r\n\r\n.searchToolFadeOut{\r\n    animation-duration: 1s;\r\n    animation-name: fadeOut;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.searchToolFadeIn{\r\n    animation-duration: 1s;\r\n    animation-name: fadeIn;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.copyUrlButton{\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n}\r\n\r\n.mapLoadingLabel{\r\n    background-color: white;\r\n    margin: 0px auto;\r\n    font-weight: bold;\r\n    display: table;\r\n    border-radius: 10px;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}"

/***/ },
/* 125 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 130 */,
/* 131 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 132 */,
/* 133 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_133__;

/***/ }
])});;


// WEBPACK FOOTER //
// js/main.bundle.js